{
  "level": "bs05",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs05",
    "objects": "AREAS.E3:bs05.e3",
    "mesh": "TREES.E3:bs05.e3"
  },
  "spawn_point": {
    "position": [
      -2982.5291671192535,
      -4642.40694975878,
      1004.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -2982.5291671192535,
      -4542.40694975878,
      1004.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4007.749267578125,
      -5219.0,
      980.0
    ],
    "bbox_max": [
      -1964.791748046875,
      -3619.7685546875,
      1402.623779296875
    ],
    "vertex_count": 1906,
    "vertices": [
      [
        -2654.999755859375,
        -4012.0,
        1052.5999755859375
      ],
      [
        -2709.0,
        -4012.0,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2709.0,
        -4022.0,
        1052.623779296875
      ],
      [
        -2658.771240234375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2658.771240234375,
        -4022.0,
        1052.623779296875
      ],
      [
        -3271.8125,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3277.78759765625,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3307.855712890625,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3309.619873046875,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3017.201904296875,
        -5186.44873046875,
        980.0
      ],
      [
        -3017.201904296875,
        -5213.0478515625,
        980.0
      ],
      [
        -3017.201904296875,
        -5213.0478515625,
        980.0
      ],
      [
        -3017.201904296875,
        -5219.0,
        980.0
      ],
      [
        -3017.201904296875,
        -5186.44873046875,
        980.0
      ],
      [
        -3017.201904296875,
        -5004.0,
        980.0
      ],
      [
        -3017.201904296875,
        -5186.79833984375,
        1010.0
      ],
      [
        -3017.201904296875,
        -5189.0,
        1010.0
      ],
      [
        -3017.201904296875,
        -5006.20166015625,
        1010.0
      ],
      [
        -3017.201904296875,
        -5186.79833984375,
        1010.0
      ],
      [
        -2980.000244140625,
        -5094.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -5034.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -5159.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -5150.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -5094.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -5150.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -4976.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -5034.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -5159.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -5219.0,
        1010.0
      ],
      [
        -2979.000244140625,
        -5159.0,
        1010.0
      ],
      [
        -2969.000244140625,
        -5159.0,
        1010.0
      ],
      [
        -2980.000244140625,
        -5219.0,
        1010.0
      ],
      [
        -3017.201904296875,
        -5219.0,
        1010.0
      ],
      [
        -3017.201904296875,
        -5219.0,
        980.0
      ],
      [
        -2980.000244140625,
        -4976.0,
        1010.0
      ],
      [
        -3017.201904296875,
        -4976.0,
        980.0
      ],
      [
        -3017.201904296875,
        -4976.0,
        1010.0
      ],
      [
        -3017.201904296875,
        -5186.79833984375,
        1012.5
      ],
      [
        -3017.201904296875,
        -5189.0,
        1012.5
      ],
      [
        -3017.201904296875,
        -5186.79833984375,
        1012.5
      ],
      [
        -3017.201904296875,
        -5006.20166015625,
        1012.5
      ],
      [
        -2980.000244140625,
        -5094.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5034.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5159.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5150.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5094.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5150.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -4976.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5034.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5159.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5219.0,
        1012.5
      ],
      [
        -2979.000244140625,
        -5159.0,
        1012.5
      ],
      [
        -2969.000244140625,
        -5159.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5219.0,
        1012.5
      ],
      [
        -3017.201904296875,
        -5219.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -4976.0,
        1012.5
      ],
      [
        -3017.201904296875,
        -4976.0,
        1012.5
      ],
      [
        -2980.000244140625,
        -5094.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5034.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5159.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5150.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5094.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5150.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -4976.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5034.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5159.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5219.0,
        1052.623779296875
      ],
      [
        -2979.000244140625,
        -5159.0,
        1052.623779296875
      ],
      [
        -2969.000244140625,
        -5159.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5219.0,
        1052.623779296875
      ],
      [
        -3017.201904296875,
        -5219.0,
        1052.623779296875
      ],
      [
        -3017.201904296875,
        -4976.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -4976.0,
        1052.623779296875
      ],
      [
        -3195.000244140625,
        -5004.0,
        1052.623779296875
      ],
      [
        -3195.000244140625,
        -5019.0,
        1052.623779296875
      ],
      [
        -3195.000244140625,
        -4976.0,
        1052.623779296875
      ],
      [
        -3195.000244140625,
        -5004.0,
        1052.623779296875
      ],
      [
        -3195.000244140625,
        -5219.0,
        1052.623779296875
      ],
      [
        -3195.000244140625,
        -5019.0,
        1052.623779296875
      ],
      [
        -3195.000244140625,
        -5219.0,
        1052.623779296875
      ],
      [
        -3195.000244140625,
        -4976.0,
        1052.623779296875
      ],
      [
        -3017.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3017.500244140625,
        -5189.0,
        1012.5
      ],
      [
        -3017.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3017.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3017.500244140625,
        -5186.5,
        1010.0
      ],
      [
        -3017.500244140625,
        -5189.0,
        1010.0
      ],
      [
        -3017.500244140625,
        -5006.5,
        1010.0
      ],
      [
        -3017.500244140625,
        -5186.5,
        1010.0
      ],
      [
        -3162.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5124.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5189.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5186.5,
        1010.0
      ],
      [
        -3162.500244140625,
        -5044.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5189.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5186.5,
        1010.0
      ],
      [
        -3020.000244140625,
        -5189.0,
        1010.0
      ],
      [
        -3020.000244140625,
        -5189.0,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      [
        -3017.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1015.0
      ],
      [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      [
        -3162.500244140625,
        -5184.0,
        1010.0
      ],
      [
        -3080.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3020.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3020.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5134.0,
        1052.623779296875
      ],
      [
        -3070.000244140625,
        -5134.0,
        1052.623779296875
      ],
      [
        -3080.000244140625,
        -5144.0,
        1052.623779296875
      ],
      [
        -3080.000244140625,
        -5134.0,
        1052.623779296875
      ],
      [
        -2652.971435546875,
        -4011.955322265625,
        1052.623779296875
      ],
      [
        -2652.997802734375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2652.971435546875,
        -4011.955322265625,
        1052.623779296875
      ],
      [
        -2652.997802734375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2508.815673828125,
        -4044.300048828125,
        1052.623779296875
      ],
      [
        -2518.815673828125,
        -4044.300048828125,
        1052.623779296875
      ],
      [
        -2518.815673828125,
        -4056.199951171875,
        1052.623779296875
      ],
      [
        -2508.815673828125,
        -4056.199951171875,
        1052.623779296875
      ],
      [
        -2508.815673828125,
        -4044.300048828125,
        1052.623779296875
      ],
      [
        -2508.815673828125,
        -4056.199951171875,
        1052.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1062.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1082.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1052.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1082.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1187.623779296875
      ],
      [
        -2354.91015625,
        -4155.29296875,
        1082.623779296875
      ],
      [
        -2354.909423828125,
        -4155.2939453125,
        1185.623779296875
      ],
      [
        -2515.815673828125,
        -4044.300048828125,
        1112.623779296875
      ],
      [
        -2515.861328125,
        -4044.300048828125,
        1112.623779296875
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1112.623779296875
      ],
      [
        -2526.587890625,
        -4056.1748046875,
        1112.623779296875
      ],
      [
        -2527.2109375,
        -4055.81494140625,
        1112.623779296875
      ],
      [
        -2534.01220703125,
        -4051.888427734375,
        1112.623779296875
      ],
      [
        -2526.587890625,
        -4056.1748046875,
        1101.623779296875
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1101.623779296875
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1112.623779296875
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1101.623779296875
      ],
      [
        -2526.587890625,
        -4056.1748046875,
        1112.623779296875
      ],
      [
        -2526.587890625,
        -4056.1748046875,
        1101.623779296875
      ],
      [
        -2596.536865234375,
        -4032.6484375,
        1101.623779296875
      ],
      [
        -2601.536865234375,
        -4041.30859375,
        1101.623779296875
      ],
      [
        -2717.470703125,
        -4249.7685546875,
        1101.623779296875
      ],
      [
        -2670.34326171875,
        -4249.7685546875,
        1101.623779296875
      ],
      [
        -2305.47607421875,
        -4210.19482421875,
        1101.623779296875
      ],
      [
        -2354.909912109375,
        -4155.29296875,
        1101.623779296875
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1062.623779296875
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1062.623779296875
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1062.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1101.623779296875
      ],
      [
        -2564.874267578125,
        -4094.807373046875,
        1101.623779296875
      ],
      [
        -2537.31201171875,
        -4110.72021484375,
        1101.623779296875
      ],
      [
        -2610.286865234375,
        -4056.4638671875,
        1100.123779296875
      ],
      [
        -2610.286865234375,
        -4056.4638671875,
        1095.623779296875
      ],
      [
        -2336.342529296875,
        -4226.75048828125,
        1052.623779296875
      ],
      [
        -2324.59716796875,
        -4221.4072265625,
        1052.623779296875
      ],
      [
        -2324.59716796875,
        -4221.4072265625,
        1101.623779296875
      ],
      [
        -2336.342529296875,
        -4226.75048828125,
        1101.623779296875
      ],
      [
        -2474.586181640625,
        -4141.6240234375,
        1101.623779296875
      ],
      [
        -2478.57080078125,
        -4132.51025390625,
        1052.623779296875
      ],
      [
        -2478.57080078125,
        -4132.51025390625,
        1101.623779296875
      ],
      [
        -2465.059814453125,
        -4147.12353515625,
        1101.623779296875
      ],
      [
        -2474.586181640625,
        -4141.6240234375,
        1101.623779296875
      ],
      [
        -2417.428466796875,
        -4174.6240234375,
        1101.623779296875
      ],
      [
        -2426.954833984375,
        -4169.12353515625,
        1101.623779296875
      ],
      [
        -2407.54345703125,
        -4173.51806640625,
        1052.623779296875
      ],
      [
        -2417.428466796875,
        -4174.6240234375,
        1101.623779296875
      ],
      [
        -2407.54345703125,
        -4173.51806640625,
        1101.623779296875
      ],
      [
        -2426.954833984375,
        -4169.12353515625,
        1101.623779296875
      ],
      [
        -2424.0048828125,
        -4164.01416015625,
        1052.623779296875
      ],
      [
        -2424.0048828125,
        -4164.01416015625,
        1101.623779296875
      ],
      [
        -2610.286865234375,
        -4056.464111328125,
        1052.623779296875
      ],
      [
        -2608.166015625,
        -4057.688720703125,
        1062.623779296875
      ],
      [
        -2610.286865234375,
        -4056.464111328125,
        1062.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1062.623779296875
      ],
      [
        -2608.166015625,
        -4057.688720703125,
        1062.623779296875
      ],
      [
        -2420.954833984375,
        -4158.7314453125,
        1101.623779296875
      ],
      [
        -2459.059814453125,
        -4136.7314453125,
        1101.623779296875
      ],
      [
        -2467.04052734375,
        -4090.554443359375,
        1101.623779296875
      ],
      [
        -2484.04052734375,
        -4119.99951171875,
        1101.623779296875
      ],
      [
        -2317.774169921875,
        -4218.30322265625,
        1052.623779296875
      ],
      [
        -2310.823486328125,
        -4215.14111328125,
        1101.623779296875
      ],
      [
        -2317.774169921875,
        -4218.30322265625,
        1101.623779296875
      ],
      [
        -2310.823486328125,
        -4215.14111328125,
        1101.623779296875
      ],
      [
        -2305.47607421875,
        -4210.19482421875,
        1101.623779296875
      ],
      [
        -2482.68994140625,
        -4123.0888671875,
        1052.623779296875
      ],
      [
        -2484.04052734375,
        -4119.99951171875,
        1101.623779296875
      ],
      [
        -2482.68994140625,
        -4123.0888671875,
        1101.623779296875
      ],
      [
        -2393.97412109375,
        -4171.99951171875,
        1101.623779296875
      ],
      [
        -2397.32470703125,
        -4172.37451171875,
        1052.623779296875
      ],
      [
        -2397.32470703125,
        -4172.37451171875,
        1101.623779296875
      ],
      [
        -2607.23681640625,
        -4051.181396484375,
        1052.623779296875
      ],
      [
        -2605.115966796875,
        -4052.406005859375,
        1062.623779296875
      ],
      [
        -2544.672119140625,
        -4079.9130859375,
        1096.623779296875
      ],
      [
        -2549.00244140625,
        -4077.4130859375,
        1096.623779296875
      ],
      [
        -2547.8720703125,
        -4085.45556640625,
        1095.623779296875
      ],
      [
        -2552.202392578125,
        -4082.95556640625,
        1095.623779296875
      ],
      [
        -2544.672119140625,
        -4079.9130859375,
        1096.623779296875
      ],
      [
        -2547.8720703125,
        -4085.45556640625,
        1096.623779296875
      ],
      [
        -2547.8720703125,
        -4085.45556640625,
        1095.623779296875
      ],
      [
        -2549.00244140625,
        -4077.4130859375,
        1096.623779296875
      ],
      [
        -2552.202392578125,
        -4082.95556640625,
        1095.623779296875
      ],
      [
        -2552.202392578125,
        -4082.95556640625,
        1096.623779296875
      ],
      [
        -2561.16845703125,
        -4070.388671875,
        1101.623779296875
      ],
      [
        -2548.668701171875,
        -4048.73828125,
        1101.623779296875
      ],
      [
        -2541.306396484375,
        -4076.0830078125,
        1099.123779296875
      ],
      [
        -2547.368408203125,
        -4072.5830078125,
        1099.123779296875
      ],
      [
        -2547.368408203125,
        -4072.5830078125,
        1099.123779296875
      ],
      [
        -2541.306396484375,
        -4076.0830078125,
        1099.123779296875
      ],
      [
        -2541.306396484375,
        -4076.0830078125,
        1096.623779296875
      ],
      [
        -2547.368408203125,
        -4072.5830078125,
        1096.623779296875
      ],
      [
        -2552.202392578125,
        -4082.95556640625,
        1100.123779296875
      ],
      [
        -2547.8720703125,
        -4085.45556640625,
        1100.123779296875
      ],
      [
        -2547.8720703125,
        -4085.45556640625,
        1100.123779296875
      ],
      [
        -2552.202392578125,
        -4082.95556640625,
        1100.123779296875
      ],
      [
        -2543.80615234375,
        -4080.4130859375,
        1101.1239013671875
      ],
      [
        -2541.207763671875,
        -4081.9130859375,
        1096.623779296875
      ],
      [
        -2541.207763671875,
        -4081.9130859375,
        1099.1236572265625
      ],
      [
        -2528.7080078125,
        -4060.262451171875,
        1099.1236572265625
      ],
      [
        -2528.7080078125,
        -4060.262451171875,
        1096.623779296875
      ],
      [
        -2531.30615234375,
        -4058.762451171875,
        1101.123779296875
      ],
      [
        -2540.656494140625,
        -4076.4580078125,
        1100.623779296875
      ],
      [
        -2540.007080078125,
        -4076.833251953125,
        1100.123779296875
      ],
      [
        -2543.156494140625,
        -4080.7880859375,
        1100.623779296875
      ],
      [
        -2540.656494140625,
        -4076.4580078125,
        1100.623779296875
      ],
      [
        -2541.207763671875,
        -4081.9130859375,
        1101.623779296875
      ],
      [
        -2528.7080078125,
        -4060.262451171875,
        1101.623779296875
      ],
      [
        -2537.368408203125,
        -4055.262451171875,
        1101.123779296875
      ],
      [
        -2539.96630859375,
        -4053.762451171875,
        1096.623779296875
      ],
      [
        -2539.96630859375,
        -4053.762451171875,
        1099.123779296875
      ],
      [
        -2552.46630859375,
        -4075.4130859375,
        1099.123779296875
      ],
      [
        -2549.96630859375,
        -4071.0830078125,
        1099.123779296875
      ],
      [
        -2548.667236328125,
        -4071.8330078125,
        1100.123779296875
      ],
      [
        -2548.017822265625,
        -4072.2080078125,
        1100.623779296875
      ],
      [
        -2549.96630859375,
        -4071.0830078125,
        1099.123779296875
      ],
      [
        -2549.316650390625,
        -4071.4580078125,
        1099.623779296875
      ],
      [
        -2551.167236328125,
        -4076.1630859375,
        1100.123779296875
      ],
      [
        -2548.667236328125,
        -4071.8330078125,
        1100.123779296875
      ],
      [
        -2548.017822265625,
        -4072.2080078125,
        1100.623779296875
      ],
      [
        -2550.517578125,
        -4076.5380859375,
        1100.623779296875
      ],
      [
        -2549.316650390625,
        -4071.4580078125,
        1099.623779296875
      ],
      [
        -2551.816650390625,
        -4075.7880859375,
        1099.623779296875
      ],
      [
        -2539.96630859375,
        -4053.762451171875,
        1101.623779296875
      ],
      [
        -2549.96630859375,
        -4071.0830078125,
        1099.623779296875
      ],
      [
        -2552.46630859375,
        -4075.4130859375,
        1099.623779296875
      ],
      [
        -2549.96630859375,
        -4071.0830078125,
        1099.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1062.623779296875
      ],
      [
        -2607.23681640625,
        -4051.181396484375,
        1062.623779296875
      ],
      [
        -2605.115966796875,
        -4052.406005859375,
        1062.623779296875
      ],
      [
        -2610.286865234375,
        -4056.4638671875,
        1095.623779296875
      ],
      [
        -2607.786865234375,
        -4052.134033203125,
        1095.623779296875
      ],
      [
        -2482.68994140625,
        -4123.0888671875,
        1095.623779296875
      ],
      [
        -2478.57080078125,
        -4132.51025390625,
        1095.623779296875
      ],
      [
        -2407.54345703125,
        -4173.51806640625,
        1095.623779296875
      ],
      [
        -2397.32470703125,
        -4172.37451171875,
        1095.623779296875
      ],
      [
        -2420.954833984375,
        -4158.7314453125,
        1095.623779296875
      ],
      [
        -2424.0048828125,
        -4164.01416015625,
        1095.623779296875
      ],
      [
        -2317.774169921875,
        -4218.30322265625,
        1095.623779296875
      ],
      [
        -2324.59716796875,
        -4221.4072265625,
        1095.623779296875
      ],
      [
        -2607.786865234375,
        -4052.134033203125,
        1095.623779296875
      ],
      [
        -2607.786865234375,
        -4052.134033203125,
        1100.123779296875
      ],
      [
        -2481.947265625,
        -4124.787109375,
        1101.623779296875
      ],
      [
        -2481.947265625,
        -4124.787109375,
        1095.623779296875
      ],
      [
        -2399.1669921875,
        -4172.58056640625,
        1101.623779296875
      ],
      [
        -2399.1669921875,
        -4172.58056640625,
        1095.623779296875
      ],
      [
        -2420.954833984375,
        -4158.7314453125,
        1101.623779296875
      ],
      [
        -2421.5048828125,
        -4159.68408203125,
        1101.623779296875
      ],
      [
        -2421.5048828125,
        -4159.68408203125,
        1095.623779296875
      ],
      [
        -2319.004150390625,
        -4218.86279296875,
        1101.623779296875
      ],
      [
        -2319.004150390625,
        -4218.86279296875,
        1095.623779296875
      ],
      [
        -2607.786865234375,
        -4052.134033203125,
        1100.123779296875
      ],
      [
        -2610.286865234375,
        -4056.464111328125,
        1100.123779296875
      ],
      [
        -2478.57080078125,
        -4132.51025390625,
        1100.123779296875
      ],
      [
        -2481.947265625,
        -4124.787109375,
        1100.123779296875
      ],
      [
        -2407.54345703125,
        -4173.51806640625,
        1100.123779296875
      ],
      [
        -2399.1669921875,
        -4172.58056640625,
        1100.123779296875
      ],
      [
        -2424.0048828125,
        -4164.01416015625,
        1100.123779296875
      ],
      [
        -2421.5048828125,
        -4159.68408203125,
        1100.123779296875
      ],
      [
        -2324.59716796875,
        -4221.4072265625,
        1100.123779296875
      ],
      [
        -2319.004150390625,
        -4218.86279296875,
        1100.123779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2341.7802734375,
        -4229.22412109375,
        1101.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1101.623779296875
      ],
      [
        -2341.7802734375,
        -4229.22412109375,
        1101.623779296875
      ],
      [
        -2719.465576171875,
        -4249.7685546875,
        1105.2296142578125
      ],
      [
        -2720.678466796875,
        -4247.66796875,
        1111.2197265625
      ],
      [
        -2719.6171875,
        -4245.830078125,
        1112.623779296875
      ],
      [
        -2717.470703125,
        -4249.7685546875,
        1101.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1101.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1112.623779296875
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1112.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1121.623779296875
      ],
      [
        -2612.158203125,
        -4067.508056640625,
        1121.623779296875
      ],
      [
        -2596.536865234375,
        -4032.6484375,
        1112.623779296875
      ],
      [
        -2596.536865234375,
        -4032.6484375,
        1115.1722412109375
      ],
      [
        -2596.536865234375,
        -4032.6484375,
        1101.623779296875
      ],
      [
        -2596.536865234375,
        -4032.6484375,
        1112.623779296875
      ],
      [
        -2601.536865234375,
        -4041.30859375,
        1112.623779296875
      ],
      [
        -2601.536865234375,
        -4041.30859375,
        1115.17236328125
      ],
      [
        -2601.536865234375,
        -4041.30859375,
        1112.623779296875
      ],
      [
        -2601.536865234375,
        -4041.30859375,
        1101.623779296875
      ],
      [
        -2601.536865234375,
        -4041.30859375,
        1115.17236328125
      ],
      [
        -2596.536865234375,
        -4032.6484375,
        1115.1722412109375
      ],
      [
        -2720.678466796875,
        -4247.66796875,
        1111.2197265625
      ],
      [
        -2719.465576171875,
        -4249.7685546875,
        1105.2296142578125
      ],
      [
        -2721.891357421875,
        -4249.7685546875,
        1106.8345947265625
      ],
      [
        -2720.67822265625,
        -4247.66796875,
        1113.4166259765625
      ],
      [
        -2719.46533203125,
        -4249.7685546875,
        1116.799072265625
      ],
      [
        -2716.531005859375,
        -4249.7685546875,
        1119.794189453125
      ],
      [
        -2719.6171875,
        -4245.830078125,
        1112.623779296875
      ],
      [
        -2719.46533203125,
        -4249.7685546875,
        1116.799072265625
      ],
      [
        -2720.67822265625,
        -4247.66796875,
        1113.4166259765625
      ],
      [
        -2721.89111328125,
        -4249.7685546875,
        1115.8927001953125
      ],
      [
        -2721.546142578125,
        -4249.7685546875,
        1130.52001953125
      ],
      [
        -2721.89111328125,
        -4249.7685546875,
        1130.7247314453125
      ],
      [
        -2721.7265625,
        -4249.48388671875,
        1131.2579345703125
      ],
      [
        -2714.73876953125,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -2719.46533203125,
        -4249.7685546875,
        1129.285400390625
      ],
      [
        -2720.67822265625,
        -4247.66796875,
        1134.6568603515625
      ],
      [
        -2714.73876953125,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -2720.67822265625,
        -4247.66796875,
        1134.6568603515625
      ],
      [
        -2719.46533203125,
        -4249.7685546875,
        1129.285400390625
      ],
      [
        -2656.4736328125,
        -4249.7685546875,
        1148.53466796875
      ],
      [
        -2654.341064453125,
        -4249.7685546875,
        1152.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1226.623779296875
      ],
      [
        -2344.819580078125,
        -4166.49951171875,
        1101.623779296875
      ],
      [
        -2344.81982421875,
        -4166.49951171875,
        1185.623779296875
      ],
      [
        -2670.34326171875,
        -4249.7685546875,
        1101.623779296875
      ],
      [
        -2664.265869140625,
        -4249.7685546875,
        1112.623779296875
      ],
      [
        -2664.265869140625,
        -4249.7685546875,
        1112.623779296875
      ],
      [
        -2671.39990234375,
        -4249.7685546875,
        1119.9119873046875
      ],
      [
        -2673.075439453125,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -2656.4736328125,
        -4249.7685546875,
        1148.53466796875
      ],
      [
        -2673.075439453125,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1082.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1052.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1082.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1187.623779296875
      ],
      [
        -2733.863037109375,
        -4249.7685546875,
        1137.827880859375
      ],
      [
        -2730.640869140625,
        -4249.7685546875,
        1112.623779296875
      ],
      [
        -2720.174560546875,
        -4246.7958984375,
        1113.0404052734375
      ],
      [
        -2730.640869140625,
        -4249.7685546875,
        1112.623779296875
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1052.623779296875
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1152.623779296875
      ],
      [
        -2741.692626953125,
        -4249.7685546875,
        1142.4732666015625
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1152.623779296875
      ],
      [
        -2628.05224609375,
        -4058.33154296875,
        1101.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1101.623779296875
      ],
      [
        -2619.05224609375,
        -4042.7431640625,
        1101.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1101.623779296875
      ],
      [
        -2620.30224609375,
        -4044.908203125,
        1100.123779296875
      ],
      [
        -2622.80224609375,
        -4049.23828125,
        1100.123779296875
      ],
      [
        -2622.80224609375,
        -4049.23828125,
        1095.623779296875
      ],
      [
        -2620.30224609375,
        -4044.908203125,
        1095.623779296875
      ],
      [
        -2620.30224609375,
        -4044.908203125,
        1095.623779296875
      ],
      [
        -2620.30224609375,
        -4044.908203125,
        1100.123779296875
      ],
      [
        -2622.80224609375,
        -4049.23828125,
        1100.123779296875
      ],
      [
        -2622.80224609375,
        -4049.23828125,
        1095.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1117.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1112.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1117.623779296875
      ],
      [
        -2628.05224609375,
        -4058.33154296875,
        1112.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1112.623779296875
      ],
      [
        -2624.96728515625,
        -4047.98828125,
        1100.123779296875
      ],
      [
        -2624.96728515625,
        -4047.98828125,
        1095.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.623779296875
      ],
      [
        -2653.2646484375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1052.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2659.0380859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2657.471435546875,
        -4022.0,
        1054.9637451171875
      ],
      [
        -2658.9130859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2611.779541015625,
        -4011.146240234375,
        1057.623779296875
      ],
      [
        -2611.779541015625,
        -4011.146240234375,
        1055.623779296875
      ],
      [
        -2611.779541015625,
        -4011.146240234375,
        1057.623779296875
      ],
      [
        -2626.624267578125,
        -4071.857666015625,
        1072.623779296875
      ],
      [
        -2621.124267578125,
        -4062.33154296875,
        1072.623779296875
      ],
      [
        -2621.990234375,
        -4061.83154296875,
        1072.623779296875
      ],
      [
        -2626.990234375,
        -4070.49169921875,
        1072.623779296875
      ],
      [
        -2626.624267578125,
        -4071.857666015625,
        1072.623779296875
      ],
      [
        -2627.490234375,
        -4071.357666015625,
        1072.623779296875
      ],
      [
        -2637.016357421875,
        -4065.857666015625,
        1055.72021484375
      ],
      [
        -2636.150390625,
        -4066.357666015625,
        1057.7200927734375
      ],
      [
        -2634.027099609375,
        -4067.58349609375,
        1062.623779296875
      ],
      [
        -2629.69677734375,
        -4070.083740234375,
        1072.623779296875
      ],
      [
        -2631.516357421875,
        -4056.33154296875,
        1055.720458984375
      ],
      [
        -2637.016357421875,
        -4065.857666015625,
        1055.72021484375
      ],
      [
        -2633.527099609375,
        -4066.717529296875,
        1062.623779296875
      ],
      [
        -2626.990234375,
        -4070.49169921875,
        1072.623779296875
      ],
      [
        -2629.19677734375,
        -4069.2177734375,
        1072.623779296875
      ],
      [
        -2633.527099609375,
        -4066.717529296875,
        1062.623779296875
      ],
      [
        -2634.027099609375,
        -4067.58349609375,
        1062.623779296875
      ],
      [
        -2635.650390625,
        -4065.49169921875,
        1057.7200927734375
      ],
      [
        -2636.150390625,
        -4066.357666015625,
        1057.7200927734375
      ],
      [
        -2635.650390625,
        -4065.49169921875,
        1057.7200927734375
      ],
      [
        -2630.650390625,
        -4056.83154296875,
        1057.7200927734375
      ],
      [
        -2626.624267578125,
        -4071.857666015625,
        1079.719482421875
      ],
      [
        -2621.124267578125,
        -4062.33154296875,
        1079.7197265625
      ],
      [
        -2621.990234375,
        -4061.83154296875,
        1077.7197265625
      ],
      [
        -2626.990234375,
        -4070.49169921875,
        1077.719482421875
      ],
      [
        -2626.624267578125,
        -4071.857666015625,
        1079.719482421875
      ],
      [
        -2627.490234375,
        -4071.357666015625,
        1072.623779296875
      ],
      [
        -2627.490234375,
        -4071.357666015625,
        1077.7197265625
      ],
      [
        -2626.990234375,
        -4070.49169921875,
        1077.7196044921875
      ],
      [
        -2636.150390625,
        -4066.357666015625,
        1113.623779296875
      ],
      [
        -2626.124267578125,
        -4070.99169921875,
        1113.623779296875
      ],
      [
        -2626.124267578125,
        -4070.99169921875,
        1079.719482421875
      ],
      [
        -2688.893310546875,
        -4094.796630859375,
        1052.623779296875
      ],
      [
        -2685.8232421875,
        -4085.78515625,
        1059.6280517578125
      ],
      [
        -2750.961181640625,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -3046.499755859375,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -3041.499755859375,
        -3974.800048828125,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1071.66943359375
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1072.9744873046875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1082.623779296875
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1187.623779296875
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1149.37744140625
      ],
      [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1152.623779296875
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1149.37744140625
      ],
      [
        -2910.0,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2894.0,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2750.961181640625,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2750.961181640625,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -2740.97705078125,
        -4247.66796875,
        1146.69970703125
      ],
      [
        -2910.0,
        -4249.7685546875,
        1064.0
      ],
      [
        -2910.0,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2910.0,
        -4249.7685546875,
        1057.5999755859375
      ],
      [
        -2998.0,
        -3922.08203125,
        1057.5999755859375
      ],
      [
        -2846.860595703125,
        -3905.65966796875,
        1057.5999755859375
      ],
      [
        -2845.2509765625,
        -3898.5556640625,
        1057.5999755859375
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1082.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1057.5999755859375
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1082.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1185.623779296875
      ],
      [
        -2846.860595703125,
        -3905.65966796875,
        1057.5999755859375
      ],
      [
        -2845.2509765625,
        -3898.5556640625,
        1057.5999755859375
      ],
      [
        -2752.65576171875,
        -3925.654541015625,
        1057.5999755859375
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1057.5999755859375
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1082.623779296875
      ],
      [
        -2751.3486328125,
        -3918.51513671875,
        1057.5999755859375
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1057.5999755859375
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1082.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1185.623779296875
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -3021.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      [
        -3021.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      [
        -2994.94970703125,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1137.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1057.5999755859375
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2862.34423828125,
        -3980.7685546875,
        1069.623779296875
      ],
      [
        -2850.55126953125,
        -3974.7685546875,
        1069.623779296875
      ],
      [
        -2938.099853515625,
        -4019.310546875,
        1108.123779296875
      ],
      [
        -2938.499755859375,
        -4019.513916015625,
        1137.623779296875
      ],
      [
        -2992.185791015625,
        -4046.827880859375,
        1139.873779296875
      ],
      [
        -2992.185791015625,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4048.234130859375,
        1127.5999755859375
      ],
      [
        -2992.185791015625,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2854.599853515625,
        -4050.7685546875,
        1108.123779296875
      ],
      [
        -2854.999755859375,
        -4050.7685546875,
        1137.623779296875
      ],
      [
        -2780.499755859375,
        -4020.023193359375,
        1137.623779296875
      ],
      [
        -2780.099609375,
        -4020.226318359375,
        1108.123779296875
      ],
      [
        -2857.65478515625,
        -3980.7685546875,
        1069.623779296875
      ],
      [
        -2859.99951171875,
        -3979.57568359375,
        1069.623779296875
      ],
      [
        -2761.676025390625,
        -4029.60009765625,
        1084.623779296875
      ],
      [
        -2761.676025390625,
        -4029.60009765625,
        1106.623779296875
      ],
      [
        -2767.03125,
        -4026.87548828125,
        1076.123779296875
      ],
      [
        -2761.676025390625,
        -4029.60009765625,
        1084.623779296875
      ],
      [
        -2768.499755859375,
        -4041.4189453125,
        1093.623779296875
      ],
      [
        -2768.499755859375,
        -4026.1279296875,
        1093.623779296875
      ],
      [
        -2761.676025390625,
        -4029.599853515625,
        1093.623779296875
      ],
      [
        -2765.245849609375,
        -4027.783447265625,
        1113.123779296875
      ],
      [
        -2761.676025390625,
        -4029.60009765625,
        1106.623779296875
      ],
      [
        -2767.03125,
        -4026.87548828125,
        1076.123779296875
      ],
      [
        -2767.03125,
        -4026.87548828125,
        1064.0205078125
      ],
      [
        -2767.03125,
        -4026.87548828125,
        1057.5999755859375
      ],
      [
        -2768.499755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4032.48779296875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4032.48779296875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      [
        -2755.999755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      [
        -2731.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2731.999755859375,
        -4044.698486328125,
        1082.623779296875
      ],
      [
        -2720.06884765625,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2731.999755859375,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2731.999755859375,
        -4044.698486328125,
        1102.623779296875
      ],
      [
        -2720.06884765625,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2727.813720703125,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2720.068603515625,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2761.676025390625,
        -4029.599853515625,
        1093.623779296875
      ],
      [
        -2767.03125,
        -4026.87548828125,
        1066.0557861328125
      ],
      [
        -2716.85986328125,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4039.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.5999755859375
      ],
      [
        -2709.7998046875,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2709.7998046875,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2709.7998046875,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1078.82373046875
      ],
      [
        -2709.7998046875,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1098.82373046875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.5999755859375
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1057.5999755859375
      ],
      [
        -2750.961181640625,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -3005.750732421875,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4053.302734375,
        1137.623779296875
      ],
      [
        -2994.94970703125,
        -4053.302734375,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4058.64013671875,
        1139.873779296875
      ],
      [
        -2994.94970703125,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2990.181640625,
        -4051.238037109375,
        1139.873779296875
      ],
      [
        -2990.277587890625,
        -4051.404296875,
        1127.5999755859375
      ],
      [
        -2990.277587890625,
        -4051.404296875,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4051.404296875,
        1127.5999755859375
      ],
      [
        -2992.248779296875,
        -4054.818603515625,
        1139.873779296875
      ],
      [
        -2992.248779296875,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2992.185302734375,
        -4054.709228515625,
        1137.623779296875
      ],
      [
        -2992.185302734375,
        -4054.709228515625,
        1127.5999755859375
      ],
      [
        -2992.248779296875,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2992.185791015625,
        -4054.70947265625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4053.30322265625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2991.97021484375,
        -4054.818603515625,
        1137.623779296875
      ],
      [
        -2991.97021484375,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2832.838134765625,
        -4054.818603515625,
        1084.623779296875
      ],
      [
        -2832.838134765625,
        -4054.818603515625,
        1106.623779296875
      ],
      [
        -2839.766357421875,
        -4054.818603515625,
        1057.5999755859375
      ],
      [
        -2839.766357421875,
        -4054.818603515625,
        1076.123779296875
      ],
      [
        -2839.766357421875,
        -4054.818603515625,
        1076.123779296875
      ],
      [
        -2832.838134765625,
        -4054.818603515625,
        1084.623779296875
      ],
      [
        -2837.45703125,
        -4054.818603515625,
        1113.123779296875
      ],
      [
        -2832.838134765625,
        -4054.818603515625,
        1106.623779296875
      ],
      [
        -2731.999755859375,
        -4054.818603515625,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4054.818603515625,
        1102.623779296875
      ],
      [
        -2731.999755859375,
        -4054.818603515625,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4054.818603515625,
        1082.623779296875
      ],
      [
        -2768.499755859375,
        -4054.818603515625,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4054.818603515625,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4054.818603515625,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4054.818603515625,
        1092.123779296875
      ],
      [
        -2727.750732421875,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2728.029052734375,
        -4054.818603515625,
        1137.623779296875
      ],
      [
        -2728.029052734375,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2938.499755859375,
        -4082.023193359375,
        1137.623779296875
      ],
      [
        -2938.099853515625,
        -4082.2265625,
        1108.123779296875
      ],
      [
        -2780.099609375,
        -4081.310791015625,
        1108.123779296875
      ],
      [
        -2780.499755859375,
        -4081.514404296875,
        1137.623779296875
      ],
      [
        -2761.67578125,
        -4071.937255859375,
        1106.623779296875
      ],
      [
        -2761.67578125,
        -4071.937255859375,
        1084.623779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1076.123779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1057.5999755859375
      ],
      [
        -2768.499755859375,
        -4075.4091796875,
        1093.623779296875
      ],
      [
        -2768.499755859375,
        -4072.1181640625,
        1093.623779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1093.623779296875
      ],
      [
        -2761.67578125,
        -4071.937255859375,
        1084.623779296875
      ],
      [
        -2765.03564453125,
        -4066.117919921875,
        1084.623779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1076.123779296875
      ],
      [
        -2765.03564453125,
        -4066.117919921875,
        1106.623779296875
      ],
      [
        -2761.67578125,
        -4071.937255859375,
        1106.623779296875
      ],
      [
        -2765.245849609375,
        -4073.753662109375,
        1113.123779296875
      ],
      [
        -2769.654296875,
        -4066.117919921875,
        1113.123779296875
      ],
      [
        -2768.499755859375,
        -4066.117919921875,
        1093.623779296875
      ],
      [
        -2765.035888671875,
        -4066.117919921875,
        1093.623779296875
      ],
      [
        -2761.676025390625,
        -4071.937255859375,
        1093.623779296875
      ],
      [
        -2768.499755859375,
        -4060.118408203125,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4069.04931640625,
        1092.123779296875
      ],
      [
        -2731.999755859375,
        -4056.839111328125,
        1082.623779296875
      ],
      [
        -2728.028564453125,
        -4054.818603515625,
        1082.623779296875
      ],
      [
        -2731.999755859375,
        -4056.839111328125,
        1102.623779296875
      ],
      [
        -2728.028564453125,
        -4054.818603515625,
        1102.623779296875
      ],
      [
        -2761.676025390625,
        -4071.937255859375,
        1093.623779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1066.05615234375
      ],
      [
        -2716.85986328125,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4058.64013671875,
        1139.873779296875
      ],
      [
        -2716.85986328125,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4061.7685546875,
        1082.623779296875
      ],
      [
        -2687.17529296875,
        -4088.126953125,
        1057.5999755859375
      ],
      [
        -2686.712158203125,
        -4088.39453125,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1052.623779296875
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2823.678955078125,
        -3903.140869140625,
        1057.5999755859375
      ],
      [
        -2823.678955078125,
        -3903.140869140625,
        1052.623779296875
      ],
      [
        -2658.927490234375,
        -3979.7685546875,
        1057.5999755859375
      ],
      [
        -2658.927490234375,
        -3979.7685546875,
        1052.623779296875
      ],
      [
        -2772.989501953125,
        -3913.915283203125,
        1057.5999755859375
      ],
      [
        -2772.989501953125,
        -3913.915283203125,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      [
        -2704.999755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      [
        -2910.0,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4022.0,
        1057.5999755859375
      ],
      [
        -2704.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4012.0,
        1057.5999755859375
      ],
      [
        -3600.0,
        -4069.7685546875,
        1302.623779296875
      ],
      [
        -3170.86669921875,
        -3902.59228515625,
        1302.623779296875
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3063.126220703125,
        -3857.455078125,
        1165.0567626953125
      ],
      [
        -3066.32861328125,
        -3883.4814453125,
        1098.453857421875
      ],
      [
        -3163.276611328125,
        -3965.8662109375,
        1102.623779296875
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3066.32861328125,
        -3883.4814453125,
        1098.4541015625
      ],
      [
        -3068.5068359375,
        -3889.566650390625,
        1086.4215087890625
      ],
      [
        -3502.938720703125,
        -4189.7685546875,
        1302.623779296875
      ],
      [
        -3439.048583984375,
        -4197.71923828125,
        1121.623779296875
      ],
      [
        -3426.12841796875,
        -4210.6396484375,
        1052.623779296875
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1152.623779296875
      ],
      [
        -3046.499755859375,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1152.623779296875
      ],
      [
        -3699.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      [
        -3699.999755859375,
        -4206.7998046875,
        1102.623779296875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1102.623779296875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1102.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3754.28271484375,
        -4249.7685546875,
        1302.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4981.9541015625,
        1302.623779296875
      ],
      [
        -2920.0,
        -5050.6669921875,
        1060.0
      ],
      [
        -2920.0,
        -5077.3330078125,
        1060.0
      ],
      [
        -2749.999755859375,
        -4919.7685546875,
        1232.623779296875
      ],
      [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      [
        -2839.999755859375,
        -4718.13916015625,
        1230.4019775390625
      ],
      [
        -2799.999755859375,
        -4869.7685546875,
        1231.90625
      ],
      [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      [
        -2920.0,
        -4919.7685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4916.376953125,
        1179.3675537109375
      ],
      [
        -2920.0,
        -4850.7685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4852.89501953125,
        1179.3675537109375
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4852.89501953125,
        1179.3675537109375
      ],
      [
        -2920.0,
        -4916.376953125,
        1179.3675537109375
      ],
      [
        -2920.0,
        -4910.60400390625,
        1227.393310546875
      ],
      [
        -2920.0,
        -4857.9619140625,
        1255.3924560546875
      ],
      [
        -2920.0,
        -4909.00634765625,
        1255.3924560546875
      ],
      [
        -2920.0,
        -4909.00634765625,
        1255.3924560546875
      ],
      [
        -2920.0,
        -4910.60400390625,
        1227.393310546875
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4857.9619140625,
        1255.3924560546875
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      [
        -2654.999755859375,
        -4250.61962890625,
        1152.302978515625
      ],
      [
        -2654.999755859375,
        -4249.7685546875,
        1151.3607177734375
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      [
        -2654.999755859375,
        -4250.61962890625,
        1152.302978515625
      ],
      [
        -2919.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      [
        -2919.999755859375,
        -4306.16796875,
        1152.623779296875
      ],
      [
        -2919.999755859375,
        -4294.16796875,
        1101.623779296875
      ],
      [
        -2919.999755859375,
        -4259.66796875,
        1101.623779296875
      ],
      [
        -2750.961181640625,
        -4306.16796875,
        1101.623779296875
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1101.623779296875
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1101.623779296875
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1101.623779296875
      ],
      [
        -2919.999755859375,
        -4292.16796875,
        1121.623779296875
      ],
      [
        -2919.999755859375,
        -4306.16796875,
        1152.623779296875
      ],
      [
        -2919.999755859375,
        -4294.16796875,
        1101.623779296875
      ],
      [
        -2919.999755859375,
        -4298.61669921875,
        1112.623779296875
      ],
      [
        -2750.961181640625,
        -4306.16796875,
        1131.2947998046875
      ],
      [
        -2706.1767578125,
        -4294.16796875,
        1101.623779296875
      ],
      [
        -2919.999755859375,
        -4298.61669921875,
        1112.623779296875
      ],
      [
        -2919.999755859375,
        -4292.16796875,
        1121.623779296875
      ],
      [
        -2698.7119140625,
        -4292.16796875,
        1121.623291015625
      ],
      [
        -2722.77880859375,
        -4298.61669921875,
        1112.6231689453125
      ],
      [
        -2709.7890625,
        -4283.1357421875,
        1101.623779296875
      ],
      [
        -2711.724853515625,
        -4288.103515625,
        1112.623779296875
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1119.7088623046875
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1119.7088623046875
      ],
      [
        -2687.31787109375,
        -4283.1357421875,
        1101.623779296875
      ],
      [
        -2711.724853515625,
        -4288.103515625,
        1112.623779296875
      ],
      [
        -2919.999755859375,
        -4261.66796875,
        1121.623779296875
      ],
      [
        -2919.999755859375,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -2919.999755859375,
        -4255.21337890625,
        1112.623779296875
      ],
      [
        -2919.999755859375,
        -4261.66796875,
        1121.623779296875
      ],
      [
        -2719.438720703125,
        -4249.81494140625,
        1105.0968017578125
      ],
      [
        -2719.438720703125,
        -4249.81494140625,
        1105.0968017578125
      ],
      [
        -2719.356201171875,
        -4249.7685546875,
        1105.0318603515625
      ],
      [
        -2684.974853515625,
        -4261.66796875,
        1121.623779296875
      ],
      [
        -2656.820556640625,
        -4249.7685546875,
        1147.9722900390625
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1145.650390625
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1106.4940185546875
      ],
      [
        -2665.850341796875,
        -4261.66796875,
        1121.623779296875
      ],
      [
        -2669.71044921875,
        -4255.21337890625,
        1112.623779296875
      ],
      [
        -2684.974853515625,
        -4261.66796875,
        1121.623779296875
      ],
      [
        -2668.46044921875,
        -4249.7685546875,
        1105.03173828125
      ],
      [
        -2669.71044921875,
        -4255.21337890625,
        1112.623779296875
      ],
      [
        -2919.999755859375,
        -4259.66796875,
        1101.623779296875
      ],
      [
        -2919.999755859375,
        -4255.21337890625,
        1112.623779296875
      ],
      [
        -2680.242431640625,
        -4259.66796875,
        1101.623779296875
      ],
      [
        -2663.85009765625,
        -4259.66796875,
        1101.623779296875
      ],
      [
        -2659.3955078125,
        -4255.21337890625,
        1112.62353515625
      ],
      [
        -2674.88232421875,
        -4270.7001953125,
        1101.623779296875
      ],
      [
        -2691.27490234375,
        -4270.7001953125,
        1101.623779296875
      ],
      [
        -2680.2294921875,
        -4265.732421875,
        1112.623779296875
      ],
      [
        -2680.2294921875,
        -4265.732421875,
        1112.623779296875
      ],
      [
        -2684.8994140625,
        -4270.40234375,
        1112.623779296875
      ],
      [
        -2685.64208984375,
        -4268.1669921875,
        1107.2333984375
      ],
      [
        -2684.8994140625,
        -4270.40234375,
        1112.623779296875
      ],
      [
        -2919.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      [
        -3699.999755859375,
        -4260.35546875,
        1102.623779296875
      ],
      [
        -3729.92431640625,
        -4249.7685546875,
        1222.32177734375
      ],
      [
        -3699.999755859375,
        -4260.80517578125,
        1102.623779296875
      ],
      [
        -3733.5146484375,
        -4249.7685546875,
        1236.6832275390625
      ],
      [
        -3699.999755859375,
        -4879.7685546875,
        1302.623779296875
      ],
      [
        -3319.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3580.227294921875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3052.21630859375,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3079.999755859375,
        -4722.58154296875,
        1052.623779296875
      ],
      [
        -3079.999755859375,
        -4722.58154296875,
        1082.623779296875
      ],
      [
        -3079.999755859375,
        -4722.58154296875,
        1082.623779296875
      ],
      [
        -3079.999755859375,
        -4722.58154296875,
        1152.623779296875
      ],
      [
        -3079.999755859375,
        -4722.58154296875,
        1152.623779296875
      ],
      [
        -3069.999755859375,
        -4729.26416015625,
        1207.623779296875
      ],
      [
        -3055.98583984375,
        -4738.62744140625,
        1207.623779296875
      ],
      [
        -3119.999755859375,
        -4695.8544921875,
        1052.623779296875
      ],
      [
        -3119.999755859375,
        -4695.8544921875,
        1082.623779296875
      ],
      [
        -3119.999755859375,
        -4695.8544921875,
        1082.623779296875
      ],
      [
        -3119.999755859375,
        -4695.8544921875,
        1152.623779296875
      ],
      [
        -3133.7236328125,
        -4686.6845703125,
        1152.623779296875
      ],
      [
        -3124.88232421875,
        -4692.59228515625,
        1179.4783935546875
      ],
      [
        -3119.999755859375,
        -4695.8544921875,
        1152.623779296875
      ],
      [
        -3124.88232421875,
        -4692.59228515625,
        1179.4783935546875
      ],
      [
        -3082.100341796875,
        -4721.17822265625,
        1101.623779296875
      ],
      [
        -3116.6005859375,
        -4698.12548828125,
        1101.623779296875
      ],
      [
        -3082.100341796875,
        -4721.17822265625,
        1101.623779296875
      ],
      [
        -3087.100341796875,
        -4717.83740234375,
        1092.623779296875
      ],
      [
        -3111.6005859375,
        -4701.46728515625,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4717.83740234375,
        1092.623779296875
      ],
      [
        -3116.6005859375,
        -4698.1259765625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4701.46728515625,
        1092.623779296875
      ],
      [
        -3116.6005859375,
        -4698.1259765625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4701.46728515625,
        1092.623779296875
      ],
      [
        -3147.783203125,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3119.999755859375,
        -4722.58251953125,
        1052.623779296875
      ],
      [
        -3119.999755859375,
        -4722.58251953125,
        1082.623779296875
      ],
      [
        -3119.999755859375,
        -4722.58251953125,
        1082.623779296875
      ],
      [
        -3119.999755859375,
        -4722.58251953125,
        1152.623779296875
      ],
      [
        -3119.999755859375,
        -4722.58251953125,
        1152.623779296875
      ],
      [
        -3129.999755859375,
        -4729.2646484375,
        1207.623779296875
      ],
      [
        -3144.01171875,
        -4738.626953125,
        1207.623779296875
      ],
      [
        -3116.6005859375,
        -4720.31103515625,
        1101.623779296875
      ],
      [
        -3099.9990234375,
        -4709.21826171875,
        1101.623779296875
      ],
      [
        -3116.600341796875,
        -4720.31103515625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4716.97021484375,
        1092.623779296875
      ],
      [
        -3116.600341796875,
        -4720.31103515625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4716.97021484375,
        1092.623779296875
      ],
      [
        -3111.6005859375,
        -4716.97021484375,
        1092.623779296875
      ],
      [
        -3099.99951171875,
        -4709.21875,
        1092.623779296875
      ],
      [
        -3091.3515625,
        -4726.7685546875,
        1101.623779296875
      ],
      [
        -3082.100341796875,
        -4730.02880859375,
        1101.623779296875
      ],
      [
        -3091.3515625,
        -4726.7685546875,
        1101.623779296875
      ],
      [
        -3114.210205078125,
        -4718.7138671875,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4719.63330078125,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4728.2666015625,
        1092.623779296875
      ],
      [
        -3082.100341796875,
        -4730.02880859375,
        1101.623779296875
      ],
      [
        -3087.100341796875,
        -4728.2666015625,
        1092.623779296875
      ],
      [
        -3111.6005859375,
        -4719.63330078125,
        1092.623779296875
      ],
      [
        -3114.2099609375,
        -4718.7138671875,
        1097.321044921875
      ],
      [
        -3111.6005859375,
        -4719.63330078125,
        1092.623779296875
      ],
      [
        -3114.2099609375,
        -4718.7138671875,
        1097.321044921875
      ],
      [
        -3108.6484375,
        -4726.7685546875,
        1101.623779296875
      ],
      [
        -3116.600341796875,
        -4729.57080078125,
        1101.623779296875
      ],
      [
        -3108.6484375,
        -4726.7685546875,
        1101.623779296875
      ],
      [
        -3100.000244140625,
        -4723.72119140625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4727.80859375,
        1092.623779296875
      ],
      [
        -3100.00048828125,
        -4723.720703125,
        1092.623779296875
      ],
      [
        -3116.600341796875,
        -4729.5703125,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4727.80859375,
        1092.623779296875
      ],
      [
        -3116.600341796875,
        -4729.5703125,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4727.80859375,
        1092.623779296875
      ],
      [
        -3116.600341796875,
        -4740.53759765625,
        1101.623779296875
      ],
      [
        -3082.100341796875,
        -4740.53759765625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3116.600341796875,
        -4740.53759765625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3116.600341796875,
        -4740.53759765625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3082.100341796875,
        -4740.53759765625,
        1101.623779296875
      ],
      [
        -3243.922119140625,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3231.940185546875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.965576171875,
        -4744.802734375,
        1202.759765625
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.9658203125,
        -4854.802734375,
        1202.759765625
      ],
      [
        -3600.0,
        -4854.5673828125,
        1201.8182373046875
      ],
      [
        -3319.999755859375,
        -4947.19970703125,
        1212.34912109375
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3290.547119140625,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3319.999755859375,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3319.999755859375,
        -4929.11279296875,
        1140.0
      ],
      [
        -3289.445068359375,
        -4929.11279296875,
        1140.0
      ],
      [
        -3227.233642578125,
        -4978.57177734375,
        1140.0
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3274.022705078125,
        -4929.11279296875,
        1140.0
      ],
      [
        -3274.022705078125,
        -4929.11279296875,
        1140.0
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2925.976806640625,
        -4929.11279296875,
        1140.0
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -2972.765869140625,
        -4978.57177734375,
        1140.0
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2925.976806640625,
        -4929.11279296875,
        1140.0
      ],
      [
        -2920.0,
        -4929.11279296875,
        1140.0
      ],
      [
        -2920.0,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3054.07763671875,
        -4965.7685546875,
        1140.0
      ],
      [
        -3015.14697265625,
        -4935.62158203125,
        1140.0
      ],
      [
        -3318.725830078125,
        -4850.7685546875,
        1140.0
      ],
      [
        -3271.273681640625,
        -4850.7685546875,
        1140.0
      ],
      [
        -3184.8525390625,
        -4935.62158203125,
        1140.0
      ],
      [
        -3145.921875,
        -4965.7685546875,
        1140.0
      ],
      [
        -3210.865234375,
        -4896.6904296875,
        1140.0
      ],
      [
        -3184.8525390625,
        -4935.62158203125,
        1140.0
      ],
      [
        -3015.14697265625,
        -4935.62158203125,
        1140.0
      ],
      [
        -2989.13427734375,
        -4896.6904296875,
        1140.0
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1140.0
      ],
      [
        -3210.865234375,
        -4896.6904296875,
        1140.0
      ],
      [
        -2989.13427734375,
        -4896.6904296875,
        1140.0
      ],
      [
        -2979.999755859375,
        -4850.7685546875,
        1140.0
      ],
      [
        -3133.613525390625,
        -4965.7685546875,
        1140.0
      ],
      [
        -3137.244873046875,
        -4965.7685546875,
        1140.0
      ],
      [
        -3066.385986328125,
        -4965.7685546875,
        1140.0
      ],
      [
        -3062.754638671875,
        -4965.7685546875,
        1140.0
      ],
      [
        -3099.999755859375,
        -4965.7685546875,
        1140.0
      ],
      [
        -3133.613525390625,
        -4965.7685546875,
        1140.0
      ],
      [
        -3099.999755859375,
        -4965.7685546875,
        1140.0
      ],
      [
        -3066.385986328125,
        -4965.7685546875,
        1140.0
      ],
      [
        -3137.244873046875,
        -4965.7685546875,
        1140.0
      ],
      [
        -3145.921875,
        -4965.7685546875,
        1140.0
      ],
      [
        -3054.07763671875,
        -4965.7685546875,
        1140.0
      ],
      [
        -3062.754638671875,
        -4965.7685546875,
        1140.0
      ],
      [
        -3184.8525390625,
        -4765.91552734375,
        1140.0
      ],
      [
        -3210.865234375,
        -4804.8466796875,
        1140.0
      ],
      [
        -2989.13427734375,
        -4804.8466796875,
        1140.0
      ],
      [
        -3015.14697265625,
        -4765.91552734375,
        1140.0
      ],
      [
        -2979.999755859375,
        -4850.7685546875,
        1140.0
      ],
      [
        -2989.13427734375,
        -4804.8466796875,
        1140.0
      ],
      [
        -3146.15673828125,
        -4740.06005859375,
        1140.0
      ],
      [
        -3184.8525390625,
        -4765.91552734375,
        1140.0
      ],
      [
        -3015.14697265625,
        -4765.91552734375,
        1140.0
      ],
      [
        -3053.8427734375,
        -4740.06005859375,
        1140.0
      ],
      [
        -3211.039794921875,
        -4805.724609375,
        1140.0
      ],
      [
        -3218.669921875,
        -4844.08251953125,
        1140.0
      ],
      [
        -3210.865234375,
        -4804.8466796875,
        1140.0
      ],
      [
        -3211.039794921875,
        -4805.724609375,
        1140.0
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1140.0
      ],
      [
        -3218.669921875,
        -4844.08251953125,
        1140.0
      ],
      [
        -3087.100341796875,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3111.6005859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3111.6005859375,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3087.1005859375,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3116.58740234375,
        -4939.7685546875,
        1101.5999755859375
      ],
      [
        -3111.6005859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3082.113525390625,
        -4939.7685546875,
        1101.5999755859375
      ],
      [
        -3116.016845703125,
        -4965.7685546875,
        1100.57275390625
      ],
      [
        -3114.305419921875,
        -4965.7685546875,
        1101.5999755859375
      ],
      [
        -3116.587646484375,
        -4965.7685546875,
        1101.5999755859375
      ],
      [
        -3085.694091796875,
        -4965.7685546875,
        1101.5999755859375
      ],
      [
        -3083.009033203125,
        -4965.7685546875,
        1099.98828125
      ],
      [
        -3082.113525390625,
        -4965.7685546875,
        1101.5999755859375
      ],
      [
        -3083.0087890625,
        -4965.7685546875,
        1099.98828125
      ],
      [
        -3085.694091796875,
        -4965.7685546875,
        1101.5999755859375
      ],
      [
        -3114.305419921875,
        -4965.7685546875,
        1101.5999755859375
      ],
      [
        -3116.0166015625,
        -4965.7685546875,
        1100.5728759765625
      ],
      [
        -3111.600341796875,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3082.105224609375,
        -4939.7685546875,
        1101.614990234375
      ],
      [
        -3082.100341796875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3082.100341796875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1101.5999755859375
      ],
      [
        -3085.705322265625,
        -4965.7685546875,
        1101.606689453125
      ],
      [
        -3082.10986328125,
        -4965.7685546875,
        1101.606689453125
      ],
      [
        -3085.73388671875,
        -4965.7685546875,
        1101.606689453125
      ],
      [
        -3085.73388671875,
        -4965.7685546875,
        1101.5999755859375
      ],
      [
        -3116.6005859375,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3114.294189453125,
        -4965.7685546875,
        1101.606689453125
      ],
      [
        -3116.59130859375,
        -4965.7685546875,
        1101.606689453125
      ],
      [
        -3085.734130859375,
        -4973.7685546875,
        1101.623779296875
      ],
      [
        -3085.73388671875,
        -4976.0,
        1101.623779296875
      ],
      [
        -3085.73388671875,
        -4976.0,
        1101.623779296875
      ],
      [
        -3085.73388671875,
        -4976.0,
        1101.623779296875
      ],
      [
        -3082.100341796875,
        -4965.7685546875,
        1101.623779296875
      ],
      [
        -3114.265869140625,
        -4973.7685546875,
        1101.623779296875
      ],
      [
        -3114.265625,
        -4976.0,
        1101.623779296875
      ],
      [
        -3114.265625,
        -4976.0,
        1101.623779296875
      ],
      [
        -3116.600830078125,
        -4965.7685546875,
        1101.623779296875
      ],
      [
        -3098.21142578125,
        -4789.7685546875,
        1072.623779296875
      ],
      [
        -3100.489013671875,
        -4789.7685546875,
        1072.623779296875
      ],
      [
        -3100.489013671875,
        -4769.7685546875,
        1072.623779296875
      ],
      [
        -3098.21142578125,
        -4769.7685546875,
        1072.623779296875
      ],
      [
        -3098.21142578125,
        -4769.7685546875,
        1072.623779296875
      ],
      [
        -3100.489013671875,
        -4769.7685546875,
        1072.623779296875
      ],
      [
        -3099.350341796875,
        -4769.7685546875,
        1070.573974609375
      ],
      [
        -3106.044921875,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3092.656005859375,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3092.656005859375,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3106.044921875,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3099.3505859375,
        -4965.7685546875,
        1070.57373046875
      ],
      [
        -3100.489013671875,
        -4789.7685546875,
        1072.623779296875
      ],
      [
        -3098.21142578125,
        -4789.7685546875,
        1072.623779296875
      ],
      [
        -3099.350341796875,
        -4789.7685546875,
        1070.573974609375
      ],
      [
        -3184.8525390625,
        -4935.62158203125,
        1082.623779296875
      ],
      [
        -3184.8525390625,
        -4765.91552734375,
        1082.623779296875
      ],
      [
        -3210.865234375,
        -4804.8466796875,
        1082.623779296875
      ],
      [
        -3210.865234375,
        -4896.6904296875,
        1082.623779296875
      ],
      [
        -3184.8525390625,
        -4935.62158203125,
        1082.623779296875
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1082.623779296875
      ],
      [
        -3210.865234375,
        -4896.6904296875,
        1082.623779296875
      ],
      [
        -3147.224853515625,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3184.8525390625,
        -4765.91552734375,
        1082.623779296875
      ],
      [
        -3210.865234375,
        -4804.8466796875,
        1082.623779296875
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1082.623779296875
      ],
      [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      [
        -3100.907958984375,
        -4879.7685546875,
        1067.76953125
      ],
      [
        -3100.907958984375,
        -4872.13232421875,
        1067.76953125
      ],
      [
        -3102.194580078125,
        -4859.7685546875,
        1065.4539794921875
      ],
      [
        -3100.907958984375,
        -4872.13232421875,
        1067.76953125
      ],
      [
        -3109.743408203125,
        -4879.7685546875,
        1064.161865234375
      ],
      [
        -3103.720947265625,
        -4879.7685546875,
        1062.7064208984375
      ],
      [
        -3101.4658203125,
        -4879.7685546875,
        1066.7657470703125
      ],
      [
        -3102.477783203125,
        -4879.7685546875,
        1067.12841796875
      ],
      [
        -3104.51708984375,
        -4879.7685546875,
        1061.2734375
      ],
      [
        -3100.907958984375,
        -4879.7685546875,
        1067.76953125
      ],
      [
        -3104.51708984375,
        -4870.9296875,
        1061.2734375
      ],
      [
        -3104.51708984375,
        -4879.7685546875,
        1061.2734375
      ],
      [
        -3102.194580078125,
        -4859.7685546875,
        1065.4539794921875
      ],
      [
        -3104.516845703125,
        -4859.7685546875,
        1061.2734375
      ],
      [
        -3104.875,
        -4859.7685546875,
        1060.62890625
      ],
      [
        -3104.51708984375,
        -4870.9296875,
        1061.2734375
      ],
      [
        -3104.875,
        -4859.7685546875,
        1060.62890625
      ],
      [
        -3108.5498046875,
        -4895.28515625,
        1064.649169921875
      ],
      [
        -3103.38330078125,
        -4893.56298828125,
        1063.314453125
      ],
      [
        -3103.720947265625,
        -4879.7685546875,
        1062.7064208984375
      ],
      [
        -3109.743408203125,
        -4879.7685546875,
        1064.161865234375
      ],
      [
        -3102.477783203125,
        -4879.7685546875,
        1067.12841796875
      ],
      [
        -3101.4658203125,
        -4879.7685546875,
        1066.7657470703125
      ],
      [
        -3100.908203125,
        -4887.791015625,
        1067.769287109375
      ],
      [
        -3100.908203125,
        -4899.7685546875,
        1067.7694091796875
      ],
      [
        -3103.231201171875,
        -4899.7685546875,
        1063.588134765625
      ],
      [
        -3108.204833984375,
        -4899.7685546875,
        1064.7900390625
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1059.9736328125
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1058.7777099609375
      ],
      [
        -3122.9287109375,
        -4946.83984375,
        1058.7777099609375
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1059.9736328125
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1058.7777099609375
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1055.890380859375
      ],
      [
        -3129.999755859375,
        -4949.7685546875,
        1055.890380859375
      ],
      [
        -3122.9287109375,
        -4946.83984375,
        1058.7777099609375
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1055.890380859375
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1053.0030517578125
      ],
      [
        -3137.07080078125,
        -4946.83984375,
        1053.0030517578125
      ],
      [
        -3129.999755859375,
        -4949.7685546875,
        1055.890380859375
      ],
      [
        -3137.99951171875,
        -4934.939453125,
        1052.623779296875
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1053.0030517578125
      ],
      [
        -3137.99951171875,
        -4944.59765625,
        1052.623779296875
      ],
      [
        -3137.07080078125,
        -4946.83984375,
        1053.0030517578125
      ],
      [
        -3108.5498046875,
        -4899.7685546875,
        1064.649169921875
      ],
      [
        -3103.38330078125,
        -4899.7685546875,
        1063.314453125
      ],
      [
        -3103.38330078125,
        -4893.56298828125,
        1063.314453125
      ],
      [
        -3108.5498046875,
        -4895.28515625,
        1064.649169921875
      ],
      [
        -3103.38330078125,
        -4899.7685546875,
        1063.314453125
      ],
      [
        -3108.5498046875,
        -4899.7685546875,
        1064.649169921875
      ],
      [
        -3106.600341796875,
        -4789.7685546875,
        1065.445068359375
      ],
      [
        -3106.600341796875,
        -4789.7685546875,
        1057.5238037109375
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1057.5238037109375
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1065.445068359375
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1065.445068359375
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1057.5238037109375
      ],
      [
        -3100.908447265625,
        -4769.7685546875,
        1067.769287109375
      ],
      [
        -3100.908447265625,
        -4789.7685546875,
        1067.769287109375
      ],
      [
        -3106.600341796875,
        -4789.7685546875,
        1057.5238037109375
      ],
      [
        -3106.600341796875,
        -4789.7685546875,
        1065.445068359375
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1082.623779296875
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1082.623779296875
      ],
      [
        -3139.999755859375,
        -4939.7685546875,
        1082.623779296875
      ],
      [
        -3137.07080078125,
        -4946.83984375,
        1082.623779296875
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1082.623779296875
      ],
      [
        -3139.999755859375,
        -4939.7685546875,
        1082.623779296875
      ],
      [
        -3137.07080078125,
        -4946.83984375,
        1082.623779296875
      ],
      [
        -3129.999755859375,
        -4949.7685546875,
        1082.623779296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1082.623779296875
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1082.623779296875
      ],
      [
        -3129.999755859375,
        -4949.7685546875,
        1082.623779296875
      ],
      [
        -3122.9287109375,
        -4946.83984375,
        1082.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1082.623779296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1082.623779296875
      ],
      [
        -3122.9287109375,
        -4946.83984375,
        1082.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1082.623779296875
      ],
      [
        -3177.4326171875,
        -4862.7294921875,
        1082.623779296875
      ],
      [
        -3164.42626953125,
        -4882.19482421875,
        1082.623779296875
      ],
      [
        -3100.572265625,
        -4892.6259765625,
        1068.3741455078125
      ],
      [
        -3164.42626953125,
        -4882.19482421875,
        1081.421875
      ],
      [
        -3100.572265625,
        -4892.6259765625,
        1068.3741455078125
      ],
      [
        -3100.572265625,
        -4899.7685546875,
        1068.3741455078125
      ],
      [
        -3100.572265625,
        -4899.7685546875,
        1068.3741455078125
      ],
      [
        -3105.739501953125,
        -4899.7685546875,
        1065.796630859375
      ],
      [
        -3107.515380859375,
        -4879.7685546875,
        1065.071533203125
      ],
      [
        -3121.999755859375,
        -4879.7685546875,
        1067.14453125
      ],
      [
        -3150.283935546875,
        -4868.052734375,
        1077.010009765625
      ],
      [
        -3137.30712890625,
        -4876.7236328125,
        1069.59814453125
      ],
      [
        -3177.4326171875,
        -4862.7294921875,
        1080.6424560546875
      ],
      [
        -3180.083984375,
        -4849.39990234375,
        1079.089111328125
      ],
      [
        -3137.30712890625,
        -4876.7236328125,
        1069.59814453125
      ],
      [
        -3129.5654296875,
        -4878.263671875,
        1068.1536865234375
      ],
      [
        -3121.999755859375,
        -4879.7685546875,
        1067.14453125
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1076.4903564453125
      ],
      [
        -3150.283935546875,
        -4868.052734375,
        1077.010009765625
      ],
      [
        -3169.90478515625,
        -4847.80224609375,
        1077.19189453125
      ],
      [
        -3163.64404296875,
        -4848.0576171875,
        1076.2093505859375
      ],
      [
        -3160.323974609375,
        -4848.19287109375,
        1075.688232421875
      ],
      [
        -3160.323974609375,
        -4848.19287109375,
        1075.688232421875
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1076.4903564453125
      ],
      [
        -3109.1005859375,
        -4794.7685546875,
        1082.623779296875
      ],
      [
        -3109.1005859375,
        -4764.7685546875,
        1082.623779296875
      ],
      [
        -3106.044921875,
        -4794.7685546875,
        1082.623779296875
      ],
      [
        -3109.1005859375,
        -4794.7685546875,
        1082.623779296875
      ],
      [
        -3109.1005859375,
        -4764.7685546875,
        1082.623779296875
      ],
      [
        -3106.044921875,
        -4764.7685546875,
        1082.623779296875
      ],
      [
        -3106.37109375,
        -4769.7685546875,
        1071.706787109375
      ],
      [
        -3099.489501953125,
        -4769.7685546875,
        1070.3232421875
      ],
      [
        -3100.423095703125,
        -4789.7685546875,
        1068.64306640625
      ],
      [
        -3105.87939453125,
        -4789.7685546875,
        1069.7401123046875
      ],
      [
        -3175.3642578125,
        -4819.884765625,
        1082.623779296875
      ],
      [
        -3178.644287109375,
        -4822.8994140625,
        1082.623779296875
      ],
      [
        -3172.42822265625,
        -4818.88037109375,
        1082.623779296875
      ],
      [
        -3175.3642578125,
        -4819.884765625,
        1082.623779296875
      ],
      [
        -3164.42626953125,
        -4882.19482421875,
        1082.623779296875
      ],
      [
        -3160.45361328125,
        -4884.84912109375,
        1082.623779296875
      ],
      [
        -3162.0263671875,
        -4881.71044921875,
        1082.623779296875
      ],
      [
        -3160.45361328125,
        -4884.84912109375,
        1082.623779296875
      ],
      [
        -3181.999755859375,
        -4839.7685546875,
        1082.3773193359375
      ],
      [
        -3181.313720703125,
        -4843.2177734375,
        1082.623779296875
      ],
      [
        -3177.4326171875,
        -4862.7294921875,
        1082.623779296875
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1078.74072265625
      ],
      [
        -3150.283935546875,
        -4868.052734375,
        1078.2279052734375
      ],
      [
        -3180.666748046875,
        -4833.06640625,
        1081.2677001953125
      ],
      [
        -3181.999755859375,
        -4839.7685546875,
        1082.3773193359375
      ],
      [
        -3150.283935546875,
        -4868.052734375,
        1078.2279052734375
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1077.64697265625
      ],
      [
        -3160.285888671875,
        -4848.38427734375,
        1075.7105712890625
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1078.74072265625
      ],
      [
        -3161.85107421875,
        -4839.021484375,
        1077.5233154296875
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1077.64697265625
      ],
      [
        -3162.216552734375,
        -4879.9853515625,
        1082.623779296875
      ],
      [
        -3162.0263671875,
        -4881.71044921875,
        1082.623779296875
      ],
      [
        -3178.644287109375,
        -4822.8994140625,
        1082.623779296875
      ],
      [
        -3181.999755859375,
        -4839.7685546875,
        1082.623779296875
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1081.093505859375
      ],
      [
        -3181.999755859375,
        -4839.7685546875,
        1082.623779296875
      ],
      [
        -3159.099365234375,
        -4825.1875,
        1080.291015625
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1081.4393310546875
      ],
      [
        -3172.42822265625,
        -4818.88037109375,
        1082.623779296875
      ],
      [
        -3161.4619140625,
        -4823.4228515625,
        1080.84326171875
      ],
      [
        -3168.95166015625,
        -4818.875,
        1082.623779296875
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1081.4393310546875
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1081.093505859375
      ],
      [
        -3163.257568359375,
        -4865.5087890625,
        1082.623779296875
      ],
      [
        -3162.216552734375,
        -4879.9853515625,
        1082.623779296875
      ],
      [
        -3163.80517578125,
        -4857.0849609375,
        1082.623779296875
      ],
      [
        -3163.257568359375,
        -4865.5087890625,
        1082.623779296875
      ],
      [
        -3162.706298828125,
        -4852.583984375,
        1082.623779296875
      ],
      [
        -3163.80517578125,
        -4857.0849609375,
        1082.623779296875
      ],
      [
        -3162.706298828125,
        -4852.583984375,
        1082.623779296875
      ],
      [
        -3161.7177734375,
        -4850.93994140625,
        1082.623779296875
      ],
      [
        -3158.954833984375,
        -4824.46142578125,
        1082.623779296875
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1082.623779296875
      ],
      [
        -3157.840087890625,
        -4818.85791015625,
        1082.623779296875
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1082.623779296875
      ],
      [
        -3160.259765625,
        -4848.515625,
        1082.623779296875
      ],
      [
        -3160.259765625,
        -4848.515625,
        1082.623779296875
      ],
      [
        -3155.208251953125,
        -4818.85400390625,
        1082.623779296875
      ],
      [
        -3158.954833984375,
        -4824.46142578125,
        1082.623779296875
      ],
      [
        -3155.208251953125,
        -4818.85400390625,
        1082.623779296875
      ],
      [
        -3106.600341796875,
        -4789.7685546875,
        1069.885009765625
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1071.7528076171875
      ],
      [
        -3106.600341796875,
        -4789.7685546875,
        1069.885009765625
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1071.7528076171875
      ],
      [
        -3105.78564453125,
        -4899.7685546875,
        1065.77783203125
      ],
      [
        -3107.593994140625,
        -4879.7685546875,
        1065.0394287109375
      ],
      [
        -3108.204833984375,
        -4899.7685546875,
        1064.7900390625
      ],
      [
        -3314.499755859375,
        -4850.7685546875,
        1091.987060546875
      ],
      [
        -3304.959228515625,
        -4850.7685546875,
        1093.363525390625
      ],
      [
        -3275.499755859375,
        -4850.7685546875,
        1097.7962646484375
      ],
      [
        -3314.85302734375,
        -4850.7685546875,
        1101.623779296875
      ],
      [
        -3275.146484375,
        -4850.7685546875,
        1101.623779296875
      ],
      [
        -3264.823974609375,
        -4787.7001953125,
        1094.9735107421875
      ],
      [
        -3314.499755859375,
        -4850.7685546875,
        1091.927978515625
      ],
      [
        -3264.06005859375,
        -4787.7001953125,
        1095.0885009765625
      ],
      [
        -3264.823974609375,
        -4787.7001953125,
        1094.9735107421875
      ],
      [
        -3264.06005859375,
        -4787.7001953125,
        1095.0885009765625
      ],
      [
        -3184.8525390625,
        -4935.62158203125,
        1101.623779296875
      ],
      [
        -3145.921875,
        -4965.7685546875,
        1101.623779296875
      ],
      [
        -3210.865234375,
        -4896.6904296875,
        1101.623779296875
      ],
      [
        -3184.8525390625,
        -4935.62158203125,
        1101.623779296875
      ],
      [
        -3184.8525390625,
        -4765.91552734375,
        1101.623779296875
      ],
      [
        -3210.865234375,
        -4804.8466796875,
        1101.623779296875
      ],
      [
        -3213.019775390625,
        -4808.0712890625,
        1082.623779296875
      ],
      [
        -3213.019775390625,
        -4808.0712890625,
        1095.0
      ],
      [
        -3241.68994140625,
        -4790.2587890625,
        1082.623779296875
      ],
      [
        -3242.2041015625,
        -4791.22216796875,
        1097.6827392578125
      ],
      [
        -3213.019775390625,
        -4808.0712890625,
        1095.0
      ],
      [
        -3219.147216796875,
        -4817.24169921875,
        1095.0
      ],
      [
        -3219.147216796875,
        -4817.24169921875,
        1095.0
      ],
      [
        -3246.836669921875,
        -4801.2861328125,
        1082.623779296875
      ],
      [
        -3219.147216796875,
        -4817.24169921875,
        1082.623779296875
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1101.623779296875
      ],
      [
        -3210.865234375,
        -4896.6904296875,
        1101.623779296875
      ],
      [
        -3146.87109375,
        -4740.537109375,
        1101.623779296875
      ],
      [
        -3184.8525390625,
        -4765.91552734375,
        1101.623779296875
      ],
      [
        -3145.921875,
        -4965.7685546875,
        1101.623779296875
      ],
      [
        -3211.571044921875,
        -4808.39404296875,
        1101.623779296875
      ],
      [
        -3214.626708984375,
        -4823.7568359375,
        1101.623779296875
      ],
      [
        -3210.865234375,
        -4804.8466796875,
        1101.623779296875
      ],
      [
        -3211.571044921875,
        -4808.39404296875,
        1101.623779296875
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1101.623779296875
      ],
      [
        -3214.626708984375,
        -4823.7568359375,
        1101.623779296875
      ],
      [
        -3150.283935546875,
        -4811.484375,
        1086.623779296875
      ],
      [
        -3158.954833984375,
        -4824.46142578125,
        1083.45703125
      ],
      [
        -3158.954833984375,
        -4824.46142578125,
        1086.415283203125
      ],
      [
        -3158.954833984375,
        -4824.46142578125,
        1086.415283203125
      ],
      [
        -3158.954833984375,
        -4824.46142578125,
        1083.45703125
      ],
      [
        -3160.201416015625,
        -4830.72802734375,
        1082.623779296875
      ],
      [
        -3177.4326171875,
        -4862.7294921875,
        1084.027587890625
      ],
      [
        -3174.753662109375,
        -4866.73876953125,
        1082.623779296875
      ],
      [
        -3160.504638671875,
        -4847.28466796875,
        1082.623779296875
      ],
      [
        -3147.731201171875,
        -4809.77880859375,
        1086.2979736328125
      ],
      [
        -3150.283935546875,
        -4811.484375,
        1086.623779296875
      ],
      [
        -3150.283935546875,
        -4811.484375,
        1088.9765625
      ],
      [
        -3139.737548828125,
        -4804.4375,
        1088.8004150390625
      ],
      [
        -3150.283935546875,
        -4811.484375,
        1088.9765625
      ],
      [
        -3168.46142578125,
        -4876.15576171875,
        1082.623779296875
      ],
      [
        -3170.151611328125,
        -4819.82373046875,
        1090.466064453125
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1095.32275390625
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1093.623779296875
      ],
      [
        -3137.30712890625,
        -4802.8134765625,
        1094.540283203125
      ],
      [
        -3122.699462890625,
        -4799.90771484375,
        1095.3203125
      ],
      [
        -3114.329345703125,
        -4779.7685546875,
        1097.5357666015625
      ],
      [
        -3115.61328125,
        -4779.7685546875,
        1099.846923828125
      ],
      [
        -3121.999755859375,
        -4779.7685546875,
        1099.7872314453125
      ],
      [
        -3121.999755859375,
        -4779.7685546875,
        1095.6551513671875
      ],
      [
        -3137.30712890625,
        -4802.8134765625,
        1094.540283203125
      ],
      [
        -3116.85986328125,
        -4799.7685546875,
        1094.884033203125
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1093.623779296875
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1095.322998046875
      ],
      [
        -3168.752197265625,
        -4839.7685546875,
        1086.0618896484375
      ],
      [
        -3165.80029296875,
        -4850.52880859375,
        1083.7061767578125
      ],
      [
        -3114.647705078125,
        -4799.7685546875,
        1095.4263916015625
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1095.35791015625
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1095.357666015625
      ],
      [
        -3177.83642578125,
        -4839.7685546875,
        1088.3330078125
      ],
      [
        -3177.43212890625,
        -4842.80224609375,
        1087.7757568359375
      ],
      [
        -3170.67626953125,
        -4859.93115234375,
        1084.4830322265625
      ],
      [
        -3166.46142578125,
        -4864.880859375,
        1083.4571533203125
      ],
      [
        -3166.46142578125,
        -4864.880859375,
        1083.4571533203125
      ],
      [
        -3163.013916015625,
        -4868.89794921875,
        1082.623779296875
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1098.60302734375
      ],
      [
        -3115.306396484375,
        -4799.7685546875,
        1099.2945556640625
      ],
      [
        -3113.336181640625,
        -4799.7685546875,
        1095.7479248046875
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1098.60302734375
      ],
      [
        -3168.6083984375,
        -4864.4599609375,
        1084.015625
      ],
      [
        -3162.363037109375,
        -4877.94921875,
        1082.623779296875
      ],
      [
        -3168.6083984375,
        -4864.4599609375,
        1084.015625
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1101.623779296875
      ],
      [
        -3139.999755859375,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1101.623779296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1092.623779296875
      ],
      [
        -3122.9287109375,
        -4946.83984375,
        1092.623779296875
      ],
      [
        -3122.9287109375,
        -4946.83984375,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3139.999755859375,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3137.07080078125,
        -4946.83984375,
        1101.623779296875
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1101.623779296875
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1101.623779296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1101.623779296875
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1101.623779296875
      ],
      [
        -3137.07080078125,
        -4946.83984375,
        1101.623779296875
      ],
      [
        -3129.999755859375,
        -4949.7685546875,
        1101.623779296875
      ],
      [
        -3129.999755859375,
        -4949.7685546875,
        1101.623779296875
      ],
      [
        -3122.9287109375,
        -4946.83984375,
        1101.623779296875
      ],
      [
        -3172.321044921875,
        -4863.73193359375,
        1084.9814453125
      ],
      [
        -3172.09814453125,
        -4870.71337890625,
        1085.05517578125
      ],
      [
        -3172.09814453125,
        -4870.71337890625,
        1085.05517578125
      ],
      [
        -3173.36083984375,
        -4868.8232421875,
        1084.6375732421875
      ],
      [
        -3161.938232421875,
        -4883.857421875,
        1082.623779296875
      ],
      [
        -3172.40966796875,
        -4860.64892578125,
        1084.9521484375
      ],
      [
        -3172.321044921875,
        -4863.73193359375,
        1084.9814453125
      ],
      [
        -3112.640869140625,
        -4779.7685546875,
        1094.4962158203125
      ],
      [
        -3112.640869140625,
        -4799.7685546875,
        1094.4962158203125
      ],
      [
        -3113.71533203125,
        -4799.7685546875,
        1092.623779296875
      ],
      [
        -3112.266845703125,
        -4779.7685546875,
        1093.8231201171875
      ],
      [
        -3111.736083984375,
        -4799.7685546875,
        1092.86767578125
      ],
      [
        -3113.71533203125,
        -4799.7685546875,
        1092.623779296875
      ],
      [
        -3240.88623046875,
        -4788.43212890625,
        1082.623779296875
      ],
      [
        -3240.88623046875,
        -4788.43212890625,
        1094.0478515625
      ],
      [
        -3292.7587890625,
        -4850.7685546875,
        1088.123779296875
      ],
      [
        -3292.7587890625,
        -4850.7685546875,
        1095.1993408203125
      ],
      [
        -3292.7587890625,
        -4850.7685546875,
        1088.123779296875
      ],
      [
        -3292.7587890625,
        -4850.7685546875,
        1082.623779296875
      ],
      [
        -3224.8740234375,
        -4976.0,
        1126.0738525390625
      ],
      [
        -3229.66650390625,
        -4976.0,
        1140.0
      ],
      [
        -3294.428466796875,
        -4850.7685546875,
        1101.623779296875
      ],
      [
        -3294.428466796875,
        -4850.7685546875,
        1140.0
      ],
      [
        -3070.433837890625,
        -4949.5888671875,
        1122.623779296875
      ],
      [
        -3070.433837890625,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3114.265625,
        -4965.7685546875,
        1120.1566162109375
      ],
      [
        -3116.671142578125,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3125.301513671875,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3114.265625,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3116.671142578125,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3114.265625,
        -4965.7685546875,
        1120.1566162109375
      ],
      [
        -3125.301513671875,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3145.921875,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1122.623779296875
      ],
      [
        -3122.9287109375,
        -4946.83984375,
        1122.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1122.623779296875
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1122.623779296875
      ],
      [
        -3129.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      [
        -3122.9287109375,
        -4946.83984375,
        1122.623779296875
      ],
      [
        -3114.265625,
        -4939.7685546875,
        1118.4931640625
      ],
      [
        -3114.265625,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3114.265625,
        -4939.7685546875,
        1118.4931640625
      ],
      [
        -3114.265625,
        -4939.7685546875,
        1110.1207275390625
      ],
      [
        -3114.265625,
        -4934.7685546875,
        1110.1207275390625
      ],
      [
        -3114.265625,
        -4934.7685546875,
        1110.1207275390625
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1122.623779296875
      ],
      [
        -3139.999755859375,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3139.999755859375,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3137.07080078125,
        -4946.83984375,
        1122.623779296875
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1122.623779296875
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1122.623779296875
      ],
      [
        -3137.07080078125,
        -4946.83984375,
        1122.623779296875
      ],
      [
        -3129.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      [
        -3103.329345703125,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3103.32958984375,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3106.92919921875,
        -4934.7685546875,
        1117.3388671875
      ],
      [
        -3106.92919921875,
        -4939.7685546875,
        1117.3388671875
      ],
      [
        -3106.92919921875,
        -4934.7685546875,
        1117.3388671875
      ],
      [
        -3085.57275390625,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3099.999755859375,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3099.999755859375,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3085.5732421875,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3096.946044921875,
        -4934.7685546875,
        1118.68212890625
      ],
      [
        -3096.946044921875,
        -4939.7685546875,
        1118.68212890625
      ],
      [
        -3096.946044921875,
        -4934.7685546875,
        1118.68212890625
      ],
      [
        -3083.328369140625,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3085.73388671875,
        -4965.7685546875,
        1120.1566162109375
      ],
      [
        -3074.697998046875,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3085.73388671875,
        -4965.7685546875,
        1120.1566162109375
      ],
      [
        -3083.328369140625,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3085.73388671875,
        -4965.7685546875,
        1122.568115234375
      ],
      [
        -3074.697998046875,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3070.43359375,
        -4965.7685546875,
        1122.623779296875
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1118.4931640625
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1122.5679931640625
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1118.4931640625
      ],
      [
        -3082.100341796875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1105.4046630859375
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1105.4046630859375
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1105.4046630859375
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3077.07080078125,
        -4946.83984375,
        1122.623779296875
      ],
      [
        -3077.07080078125,
        -4946.83984375,
        1110.6771240234375
      ],
      [
        -3077.07080078125,
        -4946.83984375,
        1110.6771240234375
      ],
      [
        -3077.07080078125,
        -4946.83984375,
        1122.623779296875
      ],
      [
        -3070.433837890625,
        -4949.5888671875,
        1122.623779296875
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1110.6771240234375
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1122.623779296875
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1105.4046630859375
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1122.623779296875
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1110.6771240234375
      ],
      [
        -3070.433837890625,
        -4929.9482421875,
        1122.623779296875
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1110.1207275390625
      ],
      [
        -3085.73388671875,
        -4934.7685546875,
        1110.1207275390625
      ],
      [
        -3085.73388671875,
        -4934.7685546875,
        1110.1207275390625
      ],
      [
        -3094.550537109375,
        -4965.7685546875,
        1119.512451171875
      ],
      [
        -3094.550537109375,
        -4939.7685546875,
        1119.5123291015625
      ],
      [
        -3093.06982421875,
        -4934.7685546875,
        1117.3387451171875
      ],
      [
        -3093.06982421875,
        -4939.7685546875,
        1117.3387451171875
      ],
      [
        -3093.06982421875,
        -4934.7685546875,
        1117.3387451171875
      ],
      [
        -3060.780029296875,
        -4965.7685546875,
        1140.0
      ],
      [
        -3064.878173828125,
        -4931.8896484375,
        1132.623779296875
      ],
      [
        -3064.878173828125,
        -4947.6474609375,
        1132.623779296875
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1123.4049072265625
      ],
      [
        -3069.999755859375,
        -4949.7685546875,
        1123.4049072265625
      ],
      [
        -3064.878173828125,
        -4931.8896484375,
        1132.623779296875
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1123.4049072265625
      ],
      [
        -3069.999755859375,
        -4949.7685546875,
        1123.4049072265625
      ],
      [
        -3064.878173828125,
        -4947.6474609375,
        1132.623779296875
      ],
      [
        -2970.3330078125,
        -4976.0,
        1140.0
      ],
      [
        -2975.12548828125,
        -4976.0,
        1126.0738525390625
      ],
      [
        -3087.100341796875,
        -4942.6865234375,
        1092.623779296875
      ],
      [
        -3087.1005859375,
        -4956.85107421875,
        1092.623779296875
      ],
      [
        -3077.07080078125,
        -4952.69677734375,
        1092.623779296875
      ],
      [
        -3077.07080078125,
        -4952.69677734375,
        1092.623779296875
      ],
      [
        -3077.07080078125,
        -4952.69677734375,
        1101.623779296875
      ],
      [
        -3077.07080078125,
        -4952.69677734375,
        1101.623779296875
      ],
      [
        -3070.433837890625,
        -4949.94775390625,
        1122.623779296875
      ],
      [
        -3108.630615234375,
        -4965.7685546875,
        1053.8697509765625
      ],
      [
        -3108.630615234375,
        -4965.7685546875,
        1052.623779296875
      ],
      [
        -3070.76904296875,
        -4965.7685546875,
        1122.02001953125
      ],
      [
        -3070.76904296875,
        -4965.7685546875,
        1092.641845703125
      ],
      [
        -3070.76904296875,
        -4965.7685546875,
        1092.6419677734375
      ],
      [
        -3070.76904296875,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3070.76904296875,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3070.76904296875,
        -4965.7685546875,
        1052.623779296875
      ],
      [
        -3069.999755859375,
        -4963.9111328125,
        1122.623779296875
      ],
      [
        -3069.999755859375,
        -4963.9111328125,
        1101.623779296875
      ],
      [
        -3070.76904296875,
        -4965.7685546875,
        1101.623779296875
      ],
      [
        -3069.999755859375,
        -4963.9111328125,
        1101.623779296875
      ],
      [
        -3069.999755859375,
        -4963.9111328125,
        1122.623779296875
      ],
      [
        -3070.433837890625,
        -4964.95947265625,
        1122.623779296875
      ],
      [
        -3076.568115234375,
        -4899.7685546875,
        1058.572509765625
      ],
      [
        -3076.568115234375,
        -4899.7685546875,
        1056.38720703125
      ],
      [
        -3076.568115234375,
        -4899.7685546875,
        1056.38720703125
      ],
      [
        -3082.07958984375,
        -4886.4619140625,
        1057.81103515625
      ],
      [
        -3093.135986328125,
        -4859.7685546875,
        1068.699951171875
      ],
      [
        -3085.949951171875,
        -4877.11865234375,
        1073.87744140625
      ],
      [
        -3082.07958984375,
        -4886.4619140625,
        1060.822998046875
      ],
      [
        -3076.568115234375,
        -4899.7685546875,
        1058.572509765625
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1058.52734375
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1060.8125
      ],
      [
        -3103.383056640625,
        -4879.7685546875,
        1063.314453125
      ],
      [
        -3091.44970703125,
        -4879.7685546875,
        1064.649169921875
      ],
      [
        -3099.999755859375,
        -4879.7685546875,
        1062.4404296875
      ],
      [
        -3103.383056640625,
        -4879.7685546875,
        1063.314453125
      ],
      [
        -3099.99951171875,
        -4879.7685546875,
        1068.1405029296875
      ],
      [
        -3082.07958984375,
        -4886.4619140625,
        1060.822998046875
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1060.8125
      ],
      [
        -3093.13623046875,
        -4859.7685546875,
        1063.4658203125
      ],
      [
        -3098.733154296875,
        -4859.7685546875,
        1062.11328125
      ],
      [
        -3099.999755859375,
        -4872.435546875,
        1062.4404296875
      ],
      [
        -3091.44970703125,
        -4875.28564453125,
        1064.649169921875
      ],
      [
        -3090.707275390625,
        -4865.6328125,
        1064.3460693359375
      ],
      [
        -3099.99951171875,
        -4879.7685546875,
        1068.1405029296875
      ],
      [
        -3099.99951171875,
        -4872.43505859375,
        1068.1405029296875
      ],
      [
        -3097.521484375,
        -4859.7685546875,
        1067.1285400390625
      ],
      [
        -3103.383056640625,
        -4859.7685546875,
        1063.314453125
      ],
      [
        -3098.733154296875,
        -4859.7685546875,
        1062.11328125
      ],
      [
        -3093.13623046875,
        -4859.7685546875,
        1063.4658203125
      ],
      [
        -3093.13623046875,
        -4859.7685546875,
        1065.337890625
      ],
      [
        -3091.44970703125,
        -4875.28564453125,
        1064.649169921875
      ],
      [
        -3099.999755859375,
        -4872.435546875,
        1062.4404296875
      ],
      [
        -3099.999755859375,
        -4879.7685546875,
        1062.4404296875
      ],
      [
        -3091.44970703125,
        -4879.7685546875,
        1064.649169921875
      ],
      [
        -3084.852294921875,
        -4879.7685546875,
        1074.3255615234375
      ],
      [
        -3085.949951171875,
        -4877.11865234375,
        1073.87744140625
      ],
      [
        -3084.852294921875,
        -4879.7685546875,
        1066.353515625
      ],
      [
        -3084.852294921875,
        -4879.7685546875,
        1074.3255615234375
      ],
      [
        -3085.949951171875,
        -4877.11865234375,
        1066.0699462890625
      ],
      [
        -3093.135986328125,
        -4859.7685546875,
        1068.699951171875
      ],
      [
        -3085.949951171875,
        -4877.11865234375,
        1066.0699462890625
      ],
      [
        -3084.852294921875,
        -4879.7685546875,
        1066.353515625
      ],
      [
        -3082.07958984375,
        -4886.4619140625,
        1057.81103515625
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1058.146484375
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1058.146484375
      ],
      [
        -3101.266357421875,
        -4879.7685546875,
        1062.11328125
      ],
      [
        -3103.720947265625,
        -4879.7685546875,
        1062.7064208984375
      ],
      [
        -3102.068603515625,
        -4859.7685546875,
        1061.30712890625
      ],
      [
        -3102.068603515625,
        -4871.74609375,
        1061.906005859375
      ],
      [
        -3104.210693359375,
        -4859.7685546875,
        1061.8248291015625
      ],
      [
        -3102.068603515625,
        -4859.7685546875,
        1061.30712890625
      ],
      [
        -3102.068603515625,
        -4871.74609375,
        1061.906005859375
      ],
      [
        -3101.266357421875,
        -4879.7685546875,
        1062.11328125
      ],
      [
        -3104.2333984375,
        -4879.7685546875,
        1061.7840576171875
      ],
      [
        -3102.06884765625,
        -4879.7685546875,
        1062.30712890625
      ],
      [
        -3106.600341796875,
        -4779.7685546875,
        1052.623779296875
      ],
      [
        -3106.600341796875,
        -4777.3193359375,
        1057.5238037109375
      ],
      [
        -3106.600341796875,
        -4782.21875,
        1057.5238037109375
      ],
      [
        -3097.100341796875,
        -4769.7685546875,
        1052.623779296875
      ],
      [
        -3097.100341796875,
        -4789.7685546875,
        1052.623779296875
      ],
      [
        -3093.076171875,
        -4859.7685546875,
        1068.7213134765625
      ],
      [
        -3093.135986328125,
        -4859.7685546875,
        1068.482421875
      ],
      [
        -3093.076171875,
        -4859.7685546875,
        1068.7213134765625
      ],
      [
        -3093.069580078125,
        -4859.9287109375,
        1068.7476806640625
      ],
      [
        -3039.69970703125,
        -4835.6328125,
        1074.5296630859375
      ],
      [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1077.010009765625
      ],
      [
        -3019.91552734375,
        -4829.39990234375,
        1079.089111328125
      ],
      [
        -3022.56689453125,
        -4842.7294921875,
        1080.6424560546875
      ],
      [
        -3084.852294921875,
        -4879.7685546875,
        1067.14306640625
      ],
      [
        -3077.999755859375,
        -4859.7685546875,
        1067.1446533203125
      ],
      [
        -3093.13623046875,
        -4859.7685546875,
        1064.978271484375
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1077.010009765625
      ],
      [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1074.4188232421875
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1076.4903564453125
      ],
      [
        -3077.999755859375,
        -4859.7685546875,
        1067.1446533203125
      ],
      [
        -3070.432373046875,
        -4858.26318359375,
        1068.1539306640625
      ],
      [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1076.4903564453125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1074.4188232421875
      ],
      [
        -3039.713623046875,
        -4828.38427734375,
        1075.7105712890625
      ],
      [
        -3022.56689453125,
        -4842.7294921875,
        1084.0179443359375
      ],
      [
        -3017.999755859375,
        -4819.7685546875,
        1082.377197265625
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1078.227783203125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1078.74072265625
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1078.227783203125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1078.74072265625
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1077.646728515625
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1077.646728515625
      ],
      [
        -3038.148193359375,
        -4819.02197265625,
        1077.523193359375
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1086.4156494140625
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1080.809814453125
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1086.4156494140625
      ],
      [
        -3049.715576171875,
        -4791.484375,
        1086.6236572265625
      ],
      [
        -3045.495361328125,
        -4841.73681640625,
        1078.4774169921875
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1080.809814453125
      ],
      [
        -3052.357421875,
        -4789.23681640625,
        1086.374755859375
      ],
      [
        -3052.26806640625,
        -4789.77880859375,
        1086.2978515625
      ],
      [
        -3049.715576171875,
        -4791.484375,
        1086.6236572265625
      ],
      [
        -3052.26806640625,
        -4789.77880859375,
        1086.2978515625
      ],
      [
        -3036.31494140625,
        -4778.083984375,
        1086.4462890625
      ],
      [
        -3036.31494140625,
        -4778.083984375,
        1086.4462890625
      ],
      [
        -3037.419677734375,
        -4776.1083984375,
        1086.789306640625
      ],
      [
        -3056.054443359375,
        -4766.7880859375,
        1089.561279296875
      ],
      [
        -3056.054443359375,
        -4766.7880859375,
        1089.561279296875
      ],
      [
        -3057.064697265625,
        -4763.93310546875,
        1089.8314208984375
      ],
      [
        -3048.349365234375,
        -4846.0078125,
        1078.30859375
      ],
      [
        -3040.0419921875,
        -4830.03515625,
        1081.9833984375
      ],
      [
        -3041.163330078125,
        -4835.25341796875,
        1081.262451171875
      ],
      [
        -3060.59228515625,
        -4855.3203125,
        1076.5166015625
      ],
      [
        -3049.715576171875,
        -4791.484375,
        1087.5196533203125
      ],
      [
        -3062.6923828125,
        -4782.8134765625,
        1093.626953125
      ],
      [
        -3084.6484375,
        -4759.7685546875,
        1097.037109375
      ],
      [
        -3086.18994140625,
        -4759.7685546875,
        1094.262451171875
      ],
      [
        -3077.999755859375,
        -4759.7685546875,
        1097.2554931640625
      ],
      [
        -3062.6923828125,
        -4782.8134765625,
        1093.626953125
      ],
      [
        -3077.999755859375,
        -4779.7685546875,
        1093.6697998046875
      ],
      [
        -3044.61376953125,
        -4799.11962890625,
        1086.501220703125
      ],
      [
        -3049.715576171875,
        -4791.484375,
        1087.5196533203125
      ],
      [
        -3082.49072265625,
        -4779.7685546875,
        1093.5223388671875
      ],
      [
        -3077.999755859375,
        -4779.7685546875,
        1093.6697998046875
      ],
      [
        -3040.360595703125,
        -4807.90087890625,
        1085.9569091796875
      ],
      [
        -3086.283935546875,
        -4779.7685546875,
        1092.623779296875
      ],
      [
        -3086.517333984375,
        -4759.7685546875,
        1093.67333984375
      ],
      [
        -3086.283935546875,
        -4779.7685546875,
        1092.623779296875
      ],
      [
        -3087.048095703125,
        -4779.7685546875,
        1092.7178955078125
      ],
      [
        -3086.677490234375,
        -4779.7685546875,
        1093.384765625
      ],
      [
        -3062.6923828125,
        -4782.8134765625,
        1094.5404052734375
      ],
      [
        -3083.093994140625,
        -4759.7685546875,
        1099.8349609375
      ],
      [
        -3077.999755859375,
        -4759.7685546875,
        1099.7872314453125
      ],
      [
        -3062.6923828125,
        -4782.8134765625,
        1094.5404052734375
      ],
      [
        -3077.999755859375,
        -4779.7685546875,
        1095.3577880859375
      ],
      [
        -3085.542236328125,
        -4779.7685546875,
        1095.428466796875
      ],
      [
        -3077.999755859375,
        -4779.7685546875,
        1095.3577880859375
      ],
      [
        -3082.100341796875,
        -4762.57421875,
        1101.623779296875
      ],
      [
        -3077.999755859375,
        -4779.7685546875,
        1098.60302734375
      ],
      [
        -3083.46484375,
        -4779.7685546875,
        1099.167724609375
      ],
      [
        -3077.999755859375,
        -4779.7685546875,
        1098.60302734375
      ],
      [
        -3084.852294921875,
        -4879.7685546875,
        1067.1322021484375
      ],
      [
        -3093.13623046875,
        -4859.7685546875,
        1064.9337158203125
      ],
      [
        -3087.513671875,
        -4859.7685546875,
        1064.8245849609375
      ],
      [
        -3089.698486328125,
        -4868.06884765625,
        1064.7115478515625
      ],
      [
        -3093.13623046875,
        -4859.7685546875,
        1063.813232421875
      ],
      [
        -3087.513671875,
        -4859.7685546875,
        1064.8245849609375
      ],
      [
        -3084.852294921875,
        -4879.7685546875,
        1066.4678955078125
      ],
      [
        -3041.22607421875,
        -4835.98681640625,
        1074.2427978515625
      ],
      [
        -3092.100341796875,
        -4769.7685546875,
        1070.1458740234375
      ],
      [
        -3092.100341796875,
        -4789.7685546875,
        1068.2783203125
      ],
      [
        -3092.100341796875,
        -4789.7685546875,
        1068.2783203125
      ],
      [
        -3093.244140625,
        -4789.7685546875,
        1068.04833984375
      ],
      [
        -3092.752685546875,
        -4769.7685546875,
        1070.0147705078125
      ],
      [
        -3092.100341796875,
        -4769.7685546875,
        1070.1458740234375
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1058.52734375
      ],
      [
        -3247.0,
        -5024.57177734375,
        1064.699951171875
      ],
      [
        -3257.0,
        -5025.64306640625,
        1064.699951171875
      ],
      [
        -3257.0,
        -5025.64306640625,
        1064.699951171875
      ],
      [
        -3295.0,
        -5029.71484375,
        1064.699951171875
      ],
      [
        -2980.000244140625,
        -5093.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5084.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5159.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5150.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5094.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5150.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5004.0,
        1052.623779296875
      ],
      [
        -2980.000244140625,
        -5004.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5159.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5219.0,
        1069.5999755859375
      ],
      [
        -2979.000244140625,
        -5159.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5159.0,
        1060.0
      ],
      [
        -2960.000244140625,
        -5084.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5084.0,
        1069.5999755859375
      ],
      [
        -2979.000244140625,
        -5159.0,
        1069.5999755859375
      ],
      [
        -2969.000244140625,
        -5159.0,
        1069.5999755859375
      ],
      [
        -2996.000244140625,
        -5037.0,
        1060.4288330078125
      ],
      [
        -3009.00048828125,
        -5043.5,
        1065.0
      ],
      [
        -2996.000244140625,
        -5037.0,
        1060.4288330078125
      ],
      [
        -2994.78076171875,
        -5036.39013671875,
        1060.0
      ],
      [
        -2996.000244140625,
        -5084.70751953125,
        1060.4288330078125
      ],
      [
        -2996.000244140625,
        -5090.15771484375,
        1060.4288330078125
      ],
      [
        -2994.78076171875,
        -5090.7353515625,
        1060.0
      ],
      [
        -2990.000244140625,
        -5034.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5034.0,
        1065.0
      ],
      [
        -2980.000244140625,
        -5034.0,
        1063.6376953125
      ],
      [
        -2988.498046875,
        -5034.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5093.0,
        1065.0
      ],
      [
        -2980.000244140625,
        -5093.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5093.0,
        1065.0
      ],
      [
        -2980.000244140625,
        -5034.0,
        1064.1339111328125
      ],
      [
        -2987.204833984375,
        -5034.0,
        1065.0
      ],
      [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5093.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5093.0,
        1069.5999755859375
      ],
      [
        -2990.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      [
        -2980.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      [
        -2990.000244140625,
        -5093.0,
        1069.5999755859375
      ],
      [
        -2996.000244140625,
        -5090.15771484375,
        1069.5999755859375
      ],
      [
        -2996.000244140625,
        -5091.0,
        1069.5999755859375
      ],
      [
        -2996.000244140625,
        -5090.15771484375,
        1069.5999755859375
      ],
      [
        -2990.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      [
        -2996.000244140625,
        -5037.0,
        1069.5999755859375
      ],
      [
        -2996.000244140625,
        -5037.84228515625,
        1069.5999755859375
      ],
      [
        -2996.000244140625,
        -5037.0,
        1069.5999755859375
      ],
      [
        -3130.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3195.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5104.0,
        1086.5
      ],
      [
        -3160.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5184.0,
        1086.5
      ],
      [
        -3130.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5105.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5034.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5094.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5159.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5150.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5094.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5150.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5034.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5004.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5159.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5219.0,
        1101.5
      ],
      [
        -2979.000244140625,
        -5159.0,
        1101.5
      ],
      [
        -2969.000244140625,
        -5159.0,
        1101.5
      ],
      [
        -2990.000244140625,
        -5093.0,
        1070.0
      ],
      [
        -2980.000244140625,
        -5093.0,
        1070.0
      ],
      [
        -2990.000244140625,
        -5093.0,
        1070.0
      ],
      [
        -2996.000244140625,
        -5090.15771484375,
        1070.0
      ],
      [
        -2996.000244140625,
        -5091.0,
        1070.0
      ],
      [
        -2996.000244140625,
        -5090.15771484375,
        1070.0
      ],
      [
        -3116.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3120.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3070.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3074.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3074.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3116.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -2990.000244140625,
        -5093.0,
        1072.0
      ],
      [
        -2980.000244140625,
        -5093.0,
        1072.0
      ],
      [
        -2990.000244140625,
        -5093.0,
        1072.0
      ],
      [
        -2996.000244140625,
        -5090.15771484375,
        1072.0
      ],
      [
        -2996.000244140625,
        -5091.0,
        1072.0
      ],
      [
        -2996.000244140625,
        -5090.15771484375,
        1072.0
      ],
      [
        -2990.000244140625,
        -5034.0,
        1072.0
      ],
      [
        -2980.000244140625,
        -5034.0,
        1072.0
      ],
      [
        -2990.000244140625,
        -5034.0,
        1072.0
      ],
      [
        -2996.000244140625,
        -5037.0,
        1072.0
      ],
      [
        -2996.000244140625,
        -5037.84228515625,
        1072.0
      ],
      [
        -2996.000244140625,
        -5037.0,
        1072.0
      ],
      [
        -3110.000244140625,
        -5076.87890625,
        1080.0
      ],
      [
        -3120.000244140625,
        -5076.87890625,
        1080.0
      ],
      [
        -3070.000244140625,
        -5076.87890625,
        1080.0
      ],
      [
        -3080.000244140625,
        -5076.87890625,
        1080.0
      ],
      [
        -3080.000244140625,
        -5077.87890625,
        1080.0
      ],
      [
        -3080.000244140625,
        -5076.87890625,
        1080.0
      ],
      [
        -3092.500244140625,
        -5054.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5004.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5004.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5019.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5069.0,
        1086.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1086.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1086.5
      ],
      [
        -3107.500244140625,
        -5069.0,
        1086.5
      ],
      [
        -3107.500244140625,
        -5072.63623046875,
        1083.5001220703125
      ],
      [
        -3092.500244140625,
        -5072.63623046875,
        1083.5001220703125
      ],
      [
        -3130.000244140625,
        -5184.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5094.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5094.0,
        1101.5
      ],
      [
        -3025.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -3015.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -3025.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -3070.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -2995.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -2995.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -2995.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5074.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5049.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5004.0,
        1098.0
      ],
      [
        -3040.000244140625,
        -5004.0,
        1101.5
      ],
      [
        -3025.000244140625,
        -5099.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5099.0,
        1101.5
      ],
      [
        -2995.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3015.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3015.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -3015.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3010.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5054.0,
        1101.5
      ],
      [
        -3050.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3050.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5049.0,
        1101.5
      ],
      [
        -2980.000244140625,
        -5034.0,
        1101.5999755859375
      ],
      [
        -2980.000244140625,
        -5094.0,
        1101.5999755859375
      ],
      [
        -2980.000244140625,
        -5094.0,
        1101.5999755859375
      ],
      [
        -2980.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      [
        -2980.000244140625,
        -5034.0,
        1101.5999755859375
      ],
      [
        -2980.000244140625,
        -5219.0,
        1101.5999755859375
      ],
      [
        -2969.000244140625,
        -5159.0,
        1101.5999755859375
      ],
      [
        -3092.500244140625,
        -5004.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3125.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3040.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3015.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3040.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3040.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -3015.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3015.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3015.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3010.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3075.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3085.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5081.19677734375,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      [
        -3077.500244140625,
        -5101.5,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5096.19677734375,
        1101.5999755859375
      ],
      [
        -3077.500244140625,
        -5086.5,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5081.19677734375,
        1101.5999755859375
      ],
      [
        -3075.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3075.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -2980.000244140625,
        -4976.0,
        1101.5999755859375
      ],
      [
        -3010.000244140625,
        -5124.0,
        1124.0
      ],
      [
        -2980.000244140625,
        -5124.0,
        1124.0
      ],
      [
        -3070.000244140625,
        -5059.0,
        1135.0
      ],
      [
        -3070.000244140625,
        -5059.0,
        1135.0
      ],
      [
        -3070.000244140625,
        -5059.0,
        1140.0
      ],
      [
        -3075.332275390625,
        -5081.2666015625,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5081.19677734375,
        1101.7047119140625
      ],
      [
        -3075.303466796875,
        -5081.19677734375,
        1101.7047119140625
      ],
      [
        -3075.000244140625,
        -5081.0712890625,
        1101.5999755859375
      ],
      [
        -3075.000244140625,
        -5081.0712890625,
        1101.89306640625
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3290.547119140625,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -2920.0,
        -4954.5869140625,
        1227.393310546875
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -2985.0,
        -4965.7685546875,
        1152.623779296875
      ],
      [
        -2987.251708984375,
        -4976.64208984375,
        1166.2159423828125
      ],
      [
        -3214.99951171875,
        -4965.7685546875,
        1152.623779296875
      ],
      [
        -3212.747802734375,
        -4976.64208984375,
        1166.2159423828125
      ],
      [
        -3255.81689453125,
        -4912.5498046875,
        1214.7630615234375
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3302.565185546875,
        -4912.111328125,
        1213.0048828125
      ],
      [
        -3292.71533203125,
        -4912.064453125,
        1213.3753662109375
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3699.999755859375,
        -4853.626953125,
        1198.05712890625
      ],
      [
        -3303.63720703125,
        -4969.7685546875,
        1302.623779296875
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3369.999755859375,
        -4917.0087890625,
        1302.623779296875
      ],
      [
        -3360.86962890625,
        -4912.603515625,
        1266.10302734375
      ],
      [
        -3347.175537109375,
        -4916.06201171875,
        1211.3270263671875
      ],
      [
        -3369.999755859375,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -2959.9150390625,
        -4907.111328125,
        1302.6241455078125
      ],
      [
        -2978.129638671875,
        -4906.7841796875,
        1302.6241455078125
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4906.9423828125,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4906.9423828125,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4907.111328125,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4906.7548828125,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -2978.129638671875,
        -4906.7841796875,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4906.7548828125,
        1302.6241455078125
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3566.1171875,
        -4753.6513671875,
        1238.15380859375
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3351.867919921875,
        -4914.876953125,
        1230.0960693359375
      ],
      [
        -3600.0,
        -4863.9697265625,
        1239.427978515625
      ],
      [
        -3600.0,
        -4854.5673828125,
        1201.8182373046875
      ],
      [
        -3566.1171875,
        -4863.6513671875,
        1238.15380859375
      ],
      [
        -3600.0,
        -4879.7685546875,
        1302.623779296875
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3248.5048828125,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -3248.5048828125,
        -4906.9423828125,
        1302.6241455078125
      ],
      [
        -3240.08447265625,
        -4907.111328125,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4906.7841796875,
        1302.6241455078125
      ],
      [
        -3240.08447265625,
        -4907.111328125,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4906.7548828125,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4906.7841796875,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4906.7548828125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3082.751220703125,
        -4274.68359375,
        1101.623779296875
      ],
      [
        -3088.267333984375,
        -4288.0009765625,
        1101.623779296875
      ],
      [
        -3088.267333984375,
        -4288.0009765625,
        1101.623779296875
      ],
      [
        -3105.568115234375,
        -4329.7685546875,
        1101.623779296875
      ],
      [
        -3082.751220703125,
        -4274.68359375,
        1101.623779296875
      ],
      [
        -3086.520751953125,
        -4271.79052734375,
        1112.623779296875
      ],
      [
        -3086.520751953125,
        -4271.79052734375,
        1112.623779296875
      ],
      [
        -3070.100341796875,
        -4271.44384765625,
        1121.623779296875
      ],
      [
        -3070.100341796875,
        -4257.44384765625,
        1152.623779296875
      ],
      [
        -3070.100341796875,
        -4271.44384765625,
        1121.623779296875
      ],
      [
        -3070.100341796875,
        -4264.9892578125,
        1112.623779296875
      ],
      [
        -3070.100341796875,
        -4269.443359375,
        1101.623779296875
      ],
      [
        -3070.100341796875,
        -4280.4765625,
        1101.623779296875
      ],
      [
        -3070.100341796875,
        -4269.443359375,
        1101.623779296875
      ],
      [
        -3070.100341796875,
        -4264.9892578125,
        1112.623779296875
      ],
      [
        -3070.100341796875,
        -4303.94384765625,
        1101.623779296875
      ],
      [
        -3070.100341796875,
        -4306.16796875,
        1130.977783203125
      ],
      [
        -3070.100341796875,
        -4311.5380859375,
        1112.623779296875
      ],
      [
        -3070.100341796875,
        -4306.16796875,
        1115.7283935546875
      ],
      [
        -3070.100341796875,
        -4306.16796875,
        1130.977783203125
      ],
      [
        -3070.100341796875,
        -4301.943359375,
        1121.623779296875
      ],
      [
        -3070.100341796875,
        -4301.943359375,
        1121.623779296875
      ],
      [
        -3070.100341796875,
        -4306.16796875,
        1115.7283935546875
      ],
      [
        -3070.100341796875,
        -4306.16796875,
        1107.123779296875
      ],
      [
        -3070.100341796875,
        -4311.5380859375,
        1112.623779296875
      ],
      [
        -3070.100341796875,
        -4303.94384765625,
        1101.623779296875
      ],
      [
        -3070.100341796875,
        -4306.16796875,
        1107.123779296875
      ],
      [
        -3070.100341796875,
        -4629.7685546875,
        1052.623779296875
      ],
      [
        -3128.60009765625,
        -4629.7685546875,
        1052.623779296875
      ],
      [
        -3120.0,
        -4679.7998046875,
        1110.0185546875
      ],
      [
        -3128.600341796875,
        -4629.7685546875,
        1131.2572021484375
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1133.579345703125
      ],
      [
        -3120.0,
        -4679.7998046875,
        1114.0947265625
      ],
      [
        -3121.054931640625,
        -4673.66259765625,
        1112.623779296875
      ],
      [
        -3020.100830078125,
        -4306.16796875,
        1052.623779296875
      ],
      [
        -3020.09716796875,
        -4306.16796875,
        1152.623779296875
      ],
      [
        -3020.098876953125,
        -4294.16796875,
        1101.623779296875
      ],
      [
        -3020.098876953125,
        -4259.66796875,
        1101.623779296875
      ],
      [
        -3020.09814453125,
        -4292.16796875,
        1121.623779296875
      ],
      [
        -3020.09716796875,
        -4306.16796875,
        1152.623779296875
      ],
      [
        -3020.098876953125,
        -4294.16796875,
        1101.623779296875
      ],
      [
        -3020.0986328125,
        -4298.61669921875,
        1112.623779296875
      ],
      [
        -3064.730224609375,
        -4306.16796875,
        1112.623779296875
      ],
      [
        -3064.730224609375,
        -4306.16796875,
        1112.623779296875
      ],
      [
        -3070.100341796875,
        -4302.1435546875,
        1121.344482421875
      ],
      [
        -3020.0986328125,
        -4298.61669921875,
        1112.623779296875
      ],
      [
        -3020.09814453125,
        -4292.16796875,
        1121.623779296875
      ],
      [
        -3020.09814453125,
        -4261.66796875,
        1121.623779296875
      ],
      [
        -3020.09716796875,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -3020.098876953125,
        -4259.66796875,
        1101.623779296875
      ],
      [
        -3020.0986328125,
        -4255.21337890625,
        1112.623779296875
      ],
      [
        -3020.0986328125,
        -4255.21337890625,
        1112.623779296875
      ],
      [
        -3020.09814453125,
        -4261.66796875,
        1121.623779296875
      ],
      [
        -3070.100341796875,
        -4265.4453125,
        1113.2596435546875
      ],
      [
        -3070.100341796875,
        -4315.94287109375,
        1139.9432373046875
      ],
      [
        -3067.27978515625,
        -4306.16796875,
        1114.0977783203125
      ],
      [
        -3264.46923828125,
        -4288.404296875,
        1082.5
      ],
      [
        -3268.512939453125,
        -4285.408203125,
        1077.5
      ],
      [
        -2182.125244140625,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -2214.77978515625,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -2182.12548828125,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3488.941650390625,
        -4910.29736328125,
        1302.623779296875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3939.26220703125,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -3556.305419921875,
        -4069.7685546875,
        1302.623779296875
      ],
      [
        -3802.58349609375,
        -4310.9921875,
        1302.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3985.582763671875,
        -4213.58984375,
        1402.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ],
      [
        -4007.749267578125,
        -4244.5771484375,
        1402.623779296875
      ],
      [
        -3835.11669921875,
        -4356.12060546875,
        1302.623779296875
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ],
      [
        -3311.842041015625,
        -3619.7685546875,
        1402.623779296875
      ],
      [
        -3221.86962890625,
        -3820.217529296875,
        1302.623779296875
      ],
      [
        -3233.817626953125,
        -4906.32763671875,
        1315.9034423828125
      ],
      [
        -3237.80029296875,
        -4906.3974609375,
        1315.9383544921875
      ],
      [
        -3239.638916015625,
        -4906.36181640625,
        1315.92041015625
      ],
      [
        -3237.80029296875,
        -4906.3974609375,
        1315.9383544921875
      ],
      [
        -3100.0,
        -3780.262451171875,
        1322.556640625
      ],
      [
        -3100.0,
        -3820.217529296875,
        1302.623779296875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4012.0,
      "bbox_min": [
        -3309.975341796875,
        -4319.68701171875,
        1051.337158203125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4012.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7590693235397339,
        -0.4528779983520508,
        -0.4676700830459595
      ],
      "plane_d": 688.9970703125,
      "bbox_min": [
        -3309.975341796875,
        -4319.68701171875,
        1051.337158203125
      ],
      "bbox_max": [
        -2658.771240234375,
        -4022.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27660542726516724,
        -0.9063540101051331,
        -0.3193928301334381
      ],
      "plane_d": -4444.03955078125,
      "bbox_min": [
        -3309.975341796875,
        -4264.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3307.855712890625,
        -4263.8017578125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -979.9999389648438,
      "bbox_min": [
        -3017.201904296875,
        -5219.0,
        980.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -4976.0,
        1052.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3017.201904296875,
        -5219.0,
        980.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -4976.0,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -3017.201904296875,
        -5219.0,
        980.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -4976.0,
        1010.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        980.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5159.0,
        1010.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5219.0,
      "bbox_min": [
        -3017.201904296875,
        -5219.0,
        980.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -3017.201904296875,
        -5219.0,
        1010.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -4976.0,
        1012.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2979.000244140625,
        -5159.0,
        1010.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5159.0,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5219.0,
      "bbox_min": [
        -3017.201904296875,
        -5219.0,
        1010.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4976.0,
      "bbox_min": [
        -3017.201904296875,
        -4976.0,
        1010.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -3017.201904296875,
        -5219.0,
        1012.5
      ],
      "bbox_max": [
        -2969.000244140625,
        -4976.0,
        1052.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2979.000244140625,
        -5159.0,
        1012.5
      ],
      "bbox_max": [
        -2969.000244140625,
        -5159.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5219.0,
      "bbox_min": [
        -3017.201904296875,
        -5219.0,
        1012.5
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4976.0,
      "bbox_min": [
        -3017.201904296875,
        -4976.0,
        1012.5
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        980.0
      ],
      "bbox_max": [
        -3017.201904296875,
        -4976.0,
        1052.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5219.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        980.0
      ],
      "bbox_max": [
        -3017.201904296875,
        -4976.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4976.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        980.0
      ],
      "bbox_max": [
        -3017.201904296875,
        -4976.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        980.0
      ],
      "bbox_max": [
        -3017.201904296875,
        -5004.0,
        1052.623779296875
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3017.500244140625,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3017.201904296875,
        -5004.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1012.4999389648438,
      "bbox_min": [
        -3017.500244140625,
        -5189.0,
        1010.0
      ],
      "bbox_max": [
        -3017.201904296875,
        -5006.20166015625,
        1012.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3017.500244140625,
        -5189.0,
        1010.0
      ],
      "bbox_max": [
        -3017.201904296875,
        -5006.20166015625,
        1010.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3162.500244140625,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3017.500244140625,
        -5004.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1012.4999389648438,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        1010.0
      ],
      "bbox_max": [
        -3162.500244140625,
        -5004.0,
        1012.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        1010.0
      ],
      "bbox_max": [
        -3162.500244140625,
        -5044.0,
        1010.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3020.000244140625,
      "bbox_min": [
        -3162.500244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3017.500244140625,
        -5006.5,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3020.000244140625,
        -5189.0,
        1010.0
      ],
      "bbox_max": [
        -3017.500244140625,
        -5006.5,
        1015.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5186.5,
      "bbox_min": [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      "bbox_max": [
        -3017.500244140625,
        -5186.5,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5186.5,
      "bbox_min": [
        -3020.000244140625,
        -5186.5,
        1012.5
      ],
      "bbox_max": [
        -3017.500244140625,
        -5186.5,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3162.500244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5186.5,
      "bbox_min": [
        -3162.500244140625,
        -5189.0,
        1010.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5184.0,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3162.500244140625,
        -5189.0,
        1010.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3162.500244140625,
        -5186.5,
        1010.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5184.0,
        1010.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3160.000244140625,
      "bbox_min": [
        -3162.500244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3162.500244140625,
        -5184.0,
        1010.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5044.0,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5154.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3040.000244140625,
        -5134.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3040.000244140625,
        -5074.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3080.000244140625,
        -5134.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3080.000244140625,
        -5134.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3140.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3100.000244140625,
      "bbox_min": [
        -3100.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5124.0,
        980.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5074.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3120.000244140625,
        -5074.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5186.5,
      "bbox_min": [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1052.623779296875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5074.0,
        1030.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3040.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5074.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3040.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5074.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3080.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5104.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3080.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5134.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3140.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5104.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3100.000244140625,
      "bbox_min": [
        -3100.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5164.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3140.000244140625,
        -5104.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3140.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3140.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5134.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5134.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4012.0,
      "bbox_min": [
        -2654.999755859375,
        -4012.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2652.997802734375,
        -4012.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2508.815673828125,
      "bbox_min": [
        -2508.815673828125,
        -4056.199951171875,
        1049.123779296875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.300048828125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4249.7685546875,
      "bbox_min": [
        -3835.11669921875,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -3820.217529296875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -232.342041015625,
      "bbox_min": [
        -2741.692626953125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -3984.21875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000007748603821,
        -0.8660249710083008,
        1.395172148477286e-06
      ],
      "plane_d": -4776.0458984375,
      "bbox_min": [
        -2721.891357421875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4020.00439453125,
        1226.623779296875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2508.815673828125,
      "bbox_min": [
        -2534.839111328125,
        -4056.199951171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.281005859375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4056.199951171875,
      "bbox_min": [
        -2534.839111328125,
        -4056.199951171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.281005859375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4044.300048828125,
      "bbox_min": [
        -2534.839111328125,
        -4056.199951171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.281005859375,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2515.861328125,
        -4044.300048828125,
        1112.623779296875
      ],
      "bbox_max": [
        -2515.815673828125,
        -4044.281005859375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2534.839111328125,
        -4056.199951171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.300048828125,
        1112.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2534.839111328125,
        -4056.199951171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2518.815673828125,
        -4044.300048828125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7728275060653687,
        -0.6346163153648376,
        0.0
      ],
      "plane_d": -612.09814453125,
      "bbox_min": [
        -2534.839111328125,
        -4056.199951171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2518.815673828125,
        -4044.300048828125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0032432021107524633,
        0.9999947547912598,
        0.0
      ],
      "plane_d": 4064.34765625,
      "bbox_min": [
        -2526.587890625,
        -4056.199951171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2518.815673828125,
        -4056.1748046875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2721.891357421875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4020.00439453125,
        1226.623779296875
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2615.537109375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4020.00439453125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999934434890747,
        -0.8660258054733276,
        0.0
      ],
      "plane_d": -4828.64453125,
      "bbox_min": [
        -2615.537109375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4020.00439453125,
        1101.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5000002980232239,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 4818.14453125,
      "bbox_min": [
        -2615.536865234375,
        -4226.75048828125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4020.00439453125,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2615.536865234375,
        -4226.75048828125,
        1052.623779296875
      ],
      "bbox_max": [
        -2324.59716796875,
        -4056.464111328125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2615.536865234375,
        -4174.6240234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2407.54345703125,
        -4056.464111328125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000298619270325,
        -0.8660082817077637,
        0.0
      ],
      "plane_d": -4824.04541015625,
      "bbox_min": [
        -2474.586181640625,
        -4174.6240234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2407.54345703125,
        -4141.6240234375,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8411673307418823,
        0.48564860224723816,
        0.237871915102005
      ],
      "plane_d": -476.0616455078125,
      "bbox_min": [
        -2615.536865234375,
        -4066.781982421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2608.166015625,
        -4056.464111328125,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2615.536865234375,
        -4066.781982421875,
        1062.623779296875
      ],
      "bbox_max": [
        -2608.166015625,
        -4056.464111328125,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660269379615784,
        0.49999743700027466,
        0.0
      ],
      "plane_d": -91.2567138671875,
      "bbox_min": [
        -2607.23681640625,
        -4218.30322265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4020.00439453125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2484.04052734375,
        -4218.30322265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4119.99951171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2484.04052734375,
        -4172.37451171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2393.97412109375,
        -4119.99951171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.623779296875,
      "bbox_min": [
        -2563.7666015625,
        -4086.9130859375,
        1094.623779296875
      ],
      "bbox_max": [
        -2518.247802734375,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5000016689300537,
        -0.8660244941711426,
        -3.205383836757392e-05
      ],
      "plane_d": -4800.60986328125,
      "bbox_min": [
        -2553.33251953125,
        -4085.45556640625,
        1094.623779296875
      ],
      "bbox_max": [
        -2537.85107421875,
        -4070.5830078125,
        1096.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2553.33251953125,
        -4085.45556640625,
        1094.623779296875
      ],
      "bbox_max": [
        -2537.85107421875,
        -4070.5830078125,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1095.623779296875,
      "bbox_min": [
        -2552.202392578125,
        -4085.45556640625,
        1095.623779296875
      ],
      "bbox_max": [
        -2544.672119140625,
        -4077.4130859375,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 168.7708740234375,
      "bbox_min": [
        -2552.202392578125,
        -4082.95556640625,
        1095.623779296875
      ],
      "bbox_max": [
        -2549.00244140625,
        -4077.4130859375,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3872966468334198,
        -0.2236083298921585,
        0.8944276571273804
      ],
      "plane_d": -903.1380004882812,
      "bbox_min": [
        -2553.33251953125,
        -4082.407958984375,
        1094.623779296875
      ],
      "bbox_max": [
        -2537.85107421875,
        -4070.5830078125,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38810262084007263,
        0.22407366335391998,
        0.8939616680145264
      ],
      "plane_d": -1051.4964599609375,
      "bbox_min": [
        -2543.80615234375,
        -4082.407958984375,
        1094.623779296875
      ],
      "bbox_max": [
        -2537.85107421875,
        -4076.0830078125,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426047325134277,
        -0.42874792218208313,
        0.5145032405853271
      ],
      "plane_d": -407.45135498046875,
      "bbox_min": [
        -2563.7666015625,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": -149.7943115234375,
      "bbox_min": [
        -2563.7666015625,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 182.8192138671875,
      "bbox_min": [
        -2563.7666015625,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000134706497192,
        0.8660176396369934,
        1.6161244275281206e-05
      ],
      "plane_d": 4805.6298828125,
      "bbox_min": [
        -2563.7666015625,
        -4070.388671875,
        1096.623779296875
      ],
      "bbox_max": [
        -2548.66845703125,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000048279762268,
        -0.8660226464271545,
        0.0
      ],
      "plane_d": -4780.6455078125,
      "bbox_min": [
        -2551.2666015625,
        -4048.73828125,
        1096.623779296875
      ],
      "bbox_max": [
        -2548.66845703125,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660260438919067,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -169.8001708984375,
      "bbox_min": [
        -2561.16845703125,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4048.73828125,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 162.8001708984375,
      "bbox_min": [
        -2552.202392578125,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4058.762451171875,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1101.123779296875,
      "bbox_min": [
        -2552.202392578125,
        -4085.45556640625,
        1096.623779296875
      ],
      "bbox_max": [
        -2541.30615234375,
        -4072.5830078125,
        1101.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000010132789612,
        -0.8660248517990112,
        -0.0
      ],
      "plane_d": -4800.64501953125,
      "bbox_min": [
        -2552.202392578125,
        -4085.45556640625,
        1096.623779296875
      ],
      "bbox_max": [
        -2541.30615234375,
        -4072.5830078125,
        1101.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1100.123779296875,
      "bbox_min": [
        -2552.202392578125,
        -4085.45556640625,
        1096.623779296875
      ],
      "bbox_max": [
        -2544.672119140625,
        -4077.4130859375,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -163.7706298828125,
      "bbox_min": [
        -2552.202392578125,
        -4085.45556640625,
        1096.623779296875
      ],
      "bbox_max": [
        -2544.672119140625,
        -4077.4130859375,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48037827014923096,
        -0.2773457467556,
        0.832055389881134
      ],
      "plane_d": -825.8920288085938,
      "bbox_min": [
        -2543.80615234375,
        -4081.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2528.7080078125,
        -4058.762451171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000010132789612,
        0.8660248517990112,
        0.0
      ],
      "plane_d": 4805.64501953125,
      "bbox_min": [
        -2543.80615234375,
        -4081.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2528.7080078125,
        -4058.762451171875,
        1101.1239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000010132789612,
        -0.8660248517990112,
        -0.0
      ],
      "plane_d": -4780.64501953125,
      "bbox_min": [
        -2543.80615234375,
        -4080.7880859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2528.7080078125,
        -4058.762451171875,
        1101.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000010132789612,
        -0.8660248517990112,
        -0.0
      ],
      "plane_d": -4800.64501953125,
      "bbox_min": [
        -2543.80615234375,
        -4080.7880859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2538.7080078125,
        -4076.0830078125,
        1101.123779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.623779296875,
      "bbox_min": [
        -2543.80615234375,
        -4080.7880859375,
        1100.623779296875
      ],
      "bbox_max": [
        -2540.656494140625,
        -4076.0830078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000010132789612,
        0.8660248517990112,
        0.0
      ],
      "plane_d": 4805.64501953125,
      "bbox_min": [
        -2543.80615234375,
        -4081.9130859375,
        1099.1236572265625
      ],
      "bbox_max": [
        -2528.7080078125,
        -4058.762451171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 160.7711181640625,
      "bbox_min": [
        -2542.07421875,
        -4081.4130859375,
        1100.123779296875
      ],
      "bbox_max": [
        -2539.57421875,
        -4076.4580078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000253915786743,
        0.8660107851028442,
        0.0
      ],
      "plane_d": 4800.6494140625,
      "bbox_min": [
        -2540.656494140625,
        -4077.0830078125,
        1100.123779296875
      ],
      "bbox_max": [
        -2539.57421875,
        -4076.4580078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000010132789612,
        -0.8660248517990112,
        -0.0
      ],
      "plane_d": -4780.64501953125,
      "bbox_min": [
        -2541.207763671875,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4060.262451171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000010132789612,
        0.8660248517990112,
        0.0
      ],
      "plane_d": 4805.64501953125,
      "bbox_min": [
        -2541.207763671875,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2532.5478515625,
        -4081.9130859375,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000134706497192,
        0.8660176396369934,
        1.6161244275281206e-05
      ],
      "plane_d": 4805.6298828125,
      "bbox_min": [
        -2561.16845703125,
        -4076.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4048.73828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48040175437927246,
        0.2773593068122864,
        0.8320373892784119
      ],
      "plane_d": -1010.3675537109375,
      "bbox_min": [
        -2552.46630859375,
        -4076.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4053.762451171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000048279762268,
        -0.8660226464271545,
        0.0
      ],
      "plane_d": -4780.6455078125,
      "bbox_min": [
        -2552.46630859375,
        -4076.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4053.762451171875,
        1101.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999951720237732,
        -0.8660282492637634,
        -8.703877028892748e-06
      ],
      "plane_d": -4800.6337890625,
      "bbox_min": [
        -2551.816650390625,
        -4076.9130859375,
        1099.123779296875
      ],
      "bbox_max": [
        -2547.368408203125,
        -4071.0830078125,
        1101.123779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.623779296875,
      "bbox_min": [
        -2550.517578125,
        -4076.9130859375,
        1100.623779296875
      ],
      "bbox_max": [
        -2547.368408203125,
        -4072.2080078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 171.7708740234375,
      "bbox_min": [
        -2551.816650390625,
        -4075.9130859375,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.100341796875,
        -4071.4580078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1099.623779296875,
      "bbox_min": [
        -2551.816650390625,
        -4075.9130859375,
        1099.623779296875
      ],
      "bbox_max": [
        -2549.100341796875,
        -4071.4580078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000010132789612,
        -0.8660248517990112,
        -0.0
      ],
      "plane_d": -4800.64501953125,
      "bbox_min": [
        -2549.96630859375,
        -4072.5830078125,
        1096.623779296875
      ],
      "bbox_max": [
        -2547.368408203125,
        -4071.0830078125,
        1099.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000048279762268,
        -0.8660226464271545,
        0.0
      ],
      "plane_d": -4780.6455078125,
      "bbox_min": [
        -2552.46630859375,
        -4076.5380859375,
        1099.123779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4053.762451171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.623779296875,
      "bbox_min": [
        -2551.600341796875,
        -4076.5380859375,
        1100.123779296875
      ],
      "bbox_max": [
        -2548.017822265625,
        -4071.5830078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -171.7708740234375,
      "bbox_min": [
        -2551.600341796875,
        -4075.9130859375,
        1100.123779296875
      ],
      "bbox_max": [
        -2548.017822265625,
        -4071.5830078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000253915786743,
        0.8660107851028442,
        -0.0
      ],
      "plane_d": 4800.64990234375,
      "bbox_min": [
        -2549.100341796875,
        -4072.2080078125,
        1100.123779296875
      ],
      "bbox_max": [
        -2548.017822265625,
        -4071.5830078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1099.623779296875,
      "bbox_min": [
        -2552.46630859375,
        -4075.7880859375,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.316650390625,
        -4071.0830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999725818634033,
        0.866041362285614,
        -0.0
      ],
      "plane_d": 4800.6396484375,
      "bbox_min": [
        -2549.96630859375,
        -4071.4580078125,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.316650390625,
        -4071.0830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1098.623779296875,
      "bbox_min": [
        -2556.796630859375,
        -4075.4130859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2549.96630859375,
        -4068.5830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1097.623779296875,
      "bbox_min": [
        -2556.796630859375,
        -4074.9130859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2550.83251953125,
        -4068.5830078125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 175.7708740234375,
      "bbox_min": [
        -2556.796630859375,
        -4073.9130859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2552.564453125,
        -4068.5830078125,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -177.7708740234375,
      "bbox_min": [
        -2556.796630859375,
        -4072.9130859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2552.564453125,
        -4068.5830078125,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999725818634033,
        0.866041362285614,
        -0.0
      ],
      "plane_d": 4800.6396484375,
      "bbox_min": [
        -2554.296630859375,
        -4069.5830078125,
        1097.123779296875
      ],
      "bbox_max": [
        -2552.564453125,
        -4068.5830078125,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 173.7708740234375,
      "bbox_min": [
        -2555.064453125,
        -4074.9130859375,
        1098.123779296875
      ],
      "bbox_max": [
        -2550.83251953125,
        -4069.5830078125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -175.7708740234375,
      "bbox_min": [
        -2555.064453125,
        -4073.9130859375,
        1098.123779296875
      ],
      "bbox_max": [
        -2550.83251953125,
        -4069.5830078125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000253915786743,
        0.8660107851028442,
        -0.0
      ],
      "plane_d": 4800.64990234375,
      "bbox_min": [
        -2552.564453125,
        -4070.5830078125,
        1098.123779296875
      ],
      "bbox_max": [
        -2550.83251953125,
        -4069.5830078125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1099.623779296875,
      "bbox_min": [
        -2553.33251953125,
        -4075.4130859375,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.96630859375,
        -4070.5830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1099.123779296875,
      "bbox_min": [
        -2553.33251953125,
        -4075.4130859375,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.96630859375,
        -4070.5830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -173.7708740234375,
      "bbox_min": [
        -2553.33251953125,
        -4074.9130859375,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.96630859375,
        -4070.5830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999725818634033,
        0.866041362285614,
        -0.0
      ],
      "plane_d": 4800.6396484375,
      "bbox_min": [
        -2550.83251953125,
        -4071.0830078125,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.96630859375,
        -4070.5830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2607.23681640625,
        -4052.406005859375,
        1062.623779296875
      ],
      "bbox_max": [
        -2587.115966796875,
        -4020.00439453125,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2610.286865234375,
        -4221.4072265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2317.774169921875,
        -4051.181396484375,
        1095.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11120469868183136,
        -0.9937976002693176,
        0.0
      ],
      "plane_d": -3879.902099609375,
      "bbox_min": [
        -2424.0048828125,
        -4221.4072265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2317.774169921875,
        -4158.7314453125,
        1095.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2424.0048828125,
        -4164.01416015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4158.7314453125,
        1095.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2610.286865234375,
        -4057.688720703125,
        1062.623779296875
      ],
      "bbox_max": [
        -2605.115966796875,
        -4051.181396484375,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500001072883606,
        -0.8660247921943665,
        0.0
      ],
      "plane_d": -4813.14453125,
      "bbox_min": [
        -2610.286865234375,
        -4221.4072265625,
        1095.623779296875
      ],
      "bbox_max": [
        -2317.774169921875,
        -4052.134033203125,
        1101.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2552.75244140625,
        -4218.86279296875,
        1095.623779296875
      ],
      "bbox_max": [
        -2317.774169921875,
        -4082.95556640625,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11120469868183136,
        -0.9937976002693176,
        0.0
      ],
      "plane_d": -3879.902099609375,
      "bbox_min": [
        -2421.5048828125,
        -4218.86279296875,
        1095.623779296875
      ],
      "bbox_max": [
        -2317.774169921875,
        -4158.7314453125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2421.5048828125,
        -4159.68408203125,
        1095.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4158.7314453125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2319.004150390625,
        -4218.86279296875,
        1095.623779296875
      ],
      "bbox_max": [
        -2317.774169921875,
        -4218.30322265625,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1100.123779296875,
      "bbox_min": [
        -2552.75244140625,
        -4086.408203125,
        1095.623779296875
      ],
      "bbox_max": [
        -2547.8720703125,
        -4082.95556640625,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -163.7706298828125,
      "bbox_min": [
        -2552.75244140625,
        -4086.408203125,
        1095.623779296875
      ],
      "bbox_max": [
        -2547.8720703125,
        -4082.95556640625,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 168.7708740234375,
      "bbox_min": [
        -2552.75244140625,
        -4083.908203125,
        1095.623779296875
      ],
      "bbox_max": [
        -2552.202392578125,
        -4082.95556640625,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1100.123779296875,
      "bbox_min": [
        -2610.286865234375,
        -4221.4072265625,
        1095.623779296875
      ],
      "bbox_max": [
        -2319.004150390625,
        -4052.134033203125,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2570.0166015625,
        -4221.4072265625,
        1100.123779296875
      ],
      "bbox_max": [
        -2319.004150390625,
        -4075.384033203125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11120469868183136,
        -0.9937976002693176,
        0.0
      ],
      "plane_d": -3879.902099609375,
      "bbox_min": [
        -2424.0048828125,
        -4221.4072265625,
        1100.123779296875
      ],
      "bbox_max": [
        -2319.004150390625,
        -4159.68408203125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2424.0048828125,
        -4164.01416015625,
        1100.123779296875
      ],
      "bbox_max": [
        -2421.5048828125,
        -4159.68408203125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2324.59716796875,
        -4221.4072265625,
        1100.123779296875
      ],
      "bbox_max": [
        -2319.004150390625,
        -4218.86279296875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -169.770751953125,
      "bbox_min": [
        -2570.0166015625,
        -4087.73828125,
        1100.123779296875
      ],
      "bbox_max": [
        -2553.618408203125,
        -4075.384033203125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 185.8193359375,
      "bbox_min": [
        -2570.0166015625,
        -4079.714111328125,
        1100.123779296875
      ],
      "bbox_max": [
        -2567.5166015625,
        -4075.384033203125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2550.922119140625,
        -4221.4072265625,
        1095.623779296875
      ],
      "bbox_max": [
        -2319.004150390625,
        -4086.408203125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11120469868183136,
        -0.9937976002693176,
        0.0
      ],
      "plane_d": -3879.902099609375,
      "bbox_min": [
        -2424.0048828125,
        -4221.4072265625,
        1095.623779296875
      ],
      "bbox_max": [
        -2319.004150390625,
        -4159.68408203125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2424.0048828125,
        -4164.01416015625,
        1095.623779296875
      ],
      "bbox_max": [
        -2421.5048828125,
        -4159.68408203125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2324.59716796875,
        -4221.4072265625,
        1095.623779296875
      ],
      "bbox_max": [
        -2319.004150390625,
        -4218.86279296875,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -163.770751953125,
      "bbox_min": [
        -2550.922119140625,
        -4090.73828125,
        1095.623779296875
      ],
      "bbox_max": [
        -2548.422119140625,
        -4086.408203125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2336.342529296875,
        -4226.75048828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8027092218399048,
        -0.4634445309638977,
        0.375336229801178
      ],
      "plane_d": -209.24679565429688,
      "bbox_min": [
        -2721.891357421875,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2577.112548828125,
        -4023.77734375,
        1152.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6585177183151245,
        -0.6585177183151245,
        0.36429232358932495
      ],
      "plane_d": -1410.3582763671875,
      "bbox_min": [
        -2721.891357421875,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2586.14453125,
        -4032.6484375,
        1131.2579345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999839067459106,
        -0.8660262823104858,
        0.0
      ],
      "plane_d": -4828.6435546875,
      "bbox_min": [
        -2721.891357421875,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2586.14453125,
        -4032.6484375,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000037550926208,
        -0.8660233616828918,
        0.0
      ],
      "plane_d": -4790.64599609375,
      "bbox_min": [
        -2601.536865234375,
        -4047.30859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2586.14453125,
        -4032.6484375,
        1115.17236328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999959468841553,
        0.8660277724266052,
        1.17841018436593e-05
      ],
      "plane_d": 4800.63037109375,
      "bbox_min": [
        -2601.536865234375,
        -4047.30859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2590.002197265625,
        -4032.6484375,
        1115.17236328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2601.536865234375,
        -4045.08154296875,
        1112.623779296875
      ],
      "bbox_max": [
        -2590.002197265625,
        -4032.6484375,
        1115.17236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123776435852051,
        0.35355043411254883,
        -0.7071037888526917
      ],
      "plane_d": 624.2259521484375,
      "bbox_min": [
        -2601.536865234375,
        -4042.5830078125,
        1112.623779296875
      ],
      "bbox_max": [
        -2594.329833984375,
        -4032.6484375,
        1115.17236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24103493988513947,
        -0.8995543122291565,
        0.364285945892334
      ],
      "plane_d": -3570.03125,
      "bbox_min": [
        -2721.891357421875,
        -4249.7685546875,
        1105.2296142578125
      ],
      "bbox_max": [
        -2719.465576171875,
        -4247.66796875,
        1111.2197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21275591850280762,
        -0.7940161824226379,
        -0.5694498419761658
      ],
      "plane_d": -2159.841552734375,
      "bbox_min": [
        -2721.89111328125,
        -4249.7685546875,
        1113.4166259765625
      ],
      "bbox_max": [
        -2719.46533203125,
        -4247.66796875,
        1131.2579345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23722945153713226,
        -0.8853526711463928,
        0.3998410999774933
      ],
      "plane_d": -3568.94140625,
      "bbox_min": [
        -2721.89111328125,
        -4249.7685546875,
        1130.52001953125
      ],
      "bbox_max": [
        -2721.546142578125,
        -4249.48388671875,
        1131.2579345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7037546038627625,
        -0.40631303191185,
        -0.5827857255935669
      ],
      "plane_d": 831.0966186523438,
      "bbox_min": [
        -2721.7265625,
        -4249.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2577.112548828125,
        -4023.77734375,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6481265425682068,
        -0.648120105266571,
        0.3998405635356903
      ],
      "plane_d": -1443.3369140625,
      "bbox_min": [
        -2721.7265625,
        -4249.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2603.412353515625,
        -4067.508056640625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000026226043701,
        -0.8660238981246948,
        2.5891913537634537e-05
      ],
      "plane_d": -4828.673828125,
      "bbox_min": [
        -2721.7265625,
        -4249.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2603.412353515625,
        -4067.508056640625,
        1134.6568603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23722945153713226,
        -0.8853526711463928,
        0.3998410999774933
      ],
      "plane_d": -3568.94140625,
      "bbox_min": [
        -2721.7265625,
        -4249.7685546875,
        1129.285400390625
      ],
      "bbox_max": [
        -2719.46533203125,
        -4247.66796875,
        1134.6568603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7892683148384094,
        0.45568564534187317,
        0.411590039730072
      ],
      "plane_d": -632.83740234375,
      "bbox_min": [
        -2673.075439453125,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4027.00439453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8028474450111389,
        0.46352434158325195,
        0.3749416172504425
      ],
      "plane_d": -585.3289794921875,
      "bbox_min": [
        -2671.39990234375,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4042.25439453125,
        1226.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.8660269379615784,
        0.49999743700027466,
        0.0
      ],
      "plane_d": -91.2567138671875,
      "bbox_min": [
        -2571.2666015625,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4047.23828125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2484.04052734375,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4119.99951171875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.291259765625,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2341.7802734375,
        -4229.22412109375,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000298619270325,
        -0.8660082817077637,
        0.0
      ],
      "plane_d": -4824.04541015625,
      "bbox_min": [
        -2474.586181640625,
        -4174.6240234375,
        1101.623779296875
      ],
      "bbox_max": [
        -2344.819580078125,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1101.623779296875
      ],
      "bbox_max": [
        -2344.819580078125,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2354.909912109375,
        -4166.49951171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2344.819580078125,
        -4155.29296875,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000013709068298,
        -0.8660246729850769,
        -0.0
      ],
      "plane_d": -4812.044921875,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1101.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44329512119293213,
        -0.7678069472312927,
        -0.46256038546562195
      ],
      "plane_d": -3709.5517578125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1203.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2344.81982421875,
        -4215.14111328125,
        1101.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4166.49951171875,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6790370345115662,
        0.7341040372848511,
        0.0
      ],
      "plane_d": 1525.21728515625,
      "bbox_min": [
        -2310.823486328125,
        -4215.14111328125,
        1101.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4210.19482421875,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999934434890747,
        -0.8660258054733276,
        0.0
      ],
      "plane_d": -4828.64453125,
      "bbox_min": [
        -2571.2666015625,
        -4110.72021484375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.23828125,
        1124.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44057026505470276,
        0.25436335802078247,
        -0.8609281182289124
      ],
      "plane_d": 883.8370971679688,
      "bbox_min": [
        -2571.2666015625,
        -4102.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.23828125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2571.2666015625,
        -4102.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.23828125,
        1121.623779296875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.7570364475250244,
        -0.4370751976966858,
        -0.4856555461883545
      ],
      "plane_d": 688.7777099609375,
      "bbox_min": [
        -2549.868408203125,
        -4086.9130859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4055.262451171875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1121.623779296875,
      "bbox_min": [
        -2549.868408203125,
        -4086.9130859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4055.262451171875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": -149.794189453125,
      "bbox_min": [
        -2549.868408203125,
        -4086.9130859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4055.262451171875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000010132789612,
        0.8660248517990112,
        -0.0
      ],
      "plane_d": 4805.64501953125,
      "bbox_min": [
        -2549.868408203125,
        -4086.9130859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4055.262451171875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        -0.8660247921943665,
        -6.25086158834165e-06
      ],
      "plane_d": -4780.6376953125,
      "bbox_min": [
        -2537.368408203125,
        -4065.262451171875,
        1112.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4055.262451171875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999722838401794,
        0.8660271167755127,
        0.0
      ],
      "plane_d": 4826.64453125,
      "bbox_min": [
        -2571.2666015625,
        -4102.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.23828125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000054836273193,
        0.8660222887992859,
        0.0
      ],
      "plane_d": 4805.6455078125,
      "bbox_min": [
        -2571.2666015625,
        -4102.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.23828125,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660261034965515,
        0.4999989867210388,
        0.0
      ],
      "plane_d": -154.800048828125,
      "bbox_min": [
        -2571.2666015625,
        -4102.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2539.3779296875,
        -4073.218994140625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000020861625671,
        -0.8660241961479187,
        4.130942215851974e-06
      ],
      "plane_d": -4810.6494140625,
      "bbox_min": [
        -2571.2666015625,
        -4095.099609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2539.3779296875,
        -4073.218994140625,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -162.770751953125,
      "bbox_min": [
        -2552.368408203125,
        -4084.7431640625,
        1101.623779296875
      ],
      "bbox_max": [
        -2543.80615234375,
        -4076.9130859375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 169.7708740234375,
      "bbox_min": [
        -2552.368408203125,
        -4081.2431640625,
        1101.623779296875
      ],
      "bbox_max": [
        -2549.868408203125,
        -4076.9130859375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49998968839645386,
        0.8660314083099365,
        2.089589906972833e-05
      ],
      "plane_d": 4820.619140625,
      "bbox_min": [
        -2571.2666015625,
        -4095.099609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2557.368408203125,
        -4081.879150390625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660311102867126,
        -0.4999901354312897,
        0.0
      ],
      "plane_d": 169.8492431640625,
      "bbox_min": [
        -2560.368408203125,
        -4095.099609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2557.368408203125,
        -4089.9033203125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000020861625671,
        -0.8660241961479187,
        0.0
      ],
      "plane_d": -4780.64453125,
      "bbox_min": [
        -2551.600341796875,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.23828125,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0032432021107524633,
        0.9999947547912598,
        0.0
      ],
      "plane_d": 4064.34765625,
      "bbox_min": [
        -2537.368408203125,
        -4058.762451171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2526.587890625,
        -4051.410888671875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660311102867126,
        0.4999901354312897,
        0.0
      ],
      "plane_d": -162.8487548828125,
      "bbox_min": [
        -2531.30615234375,
        -4058.762451171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.80615234375,
        -4056.164306640625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660311102867126,
        -0.4999901354312897,
        0.0
      ],
      "plane_d": 169.8487548828125,
      "bbox_min": [
        -2537.368408203125,
        -4055.262451171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2534.839111328125,
        -4051.410888671875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7728275060653687,
        -0.6346163153648376,
        0.0
      ],
      "plane_d": -612.09814453125,
      "bbox_min": [
        -2535.868408203125,
        -4052.664306640625,
        1101.623779296875
      ],
      "bbox_max": [
        -2534.839111328125,
        -4051.410888671875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2587907314300537,
        0.9659333825111389,
        0.0
      ],
      "plane_d": 3278.143310546875,
      "bbox_min": [
        -2551.600341796875,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2587907314300537,
        0.9659333825111389,
        0.0
      ],
      "plane_d": 3285.21435546875,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2522.5478515625,
        -4069.592529296875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659450054168701,
        -0.2587476074695587,
        0.0
      ],
      "plane_d": -3500.245849609375,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2527.5478515625,
        -4078.252685546875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660311102867126,
        0.4999901354312897,
        0.0
      ],
      "plane_d": -150.848876953125,
      "bbox_min": [
        -2530.413818359375,
        -4082.5830078125,
        1101.623779296875
      ],
      "bbox_max": [
        -2527.5478515625,
        -4078.252685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123799681663513,
        0.3535417914390564,
        -0.7071060538291931
      ],
      "plane_d": 672.97802734375,
      "bbox_min": [
        -2530.413818359375,
        -4082.5830078125,
        1101.623779296875
      ],
      "bbox_max": [
        -2527.5478515625,
        -4078.252685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123724579811096,
        0.3535374701023102,
        0.7071147561073303
      ],
      "plane_d": -892.7381591796875,
      "bbox_min": [
        -2530.413818359375,
        -4082.5830078125,
        1111.623779296875
      ],
      "bbox_max": [
        -2527.5478515625,
        -4078.252685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2589518129825592,
        0.9658902883529663,
        0.0
      ],
      "plane_d": 3291.701904296875,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.681884765625,
        -4082.5830078125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -148.653564453125,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.681884765625,
        -4082.5830078125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6124160885810852,
        0.35358259081840515,
        -0.7070543766021729
      ],
      "plane_d": 680.7737426757812,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.681884765625,
        -4082.5830078125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123937964439392,
        0.3535696566104889,
        0.7070801854133606
      ],
      "plane_d": -884.8445434570312,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.681884765625,
        -4082.5830078125,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659333825111389,
        -0.2587907314300537,
        -0.0
      ],
      "plane_d": -3493.321533203125,
      "bbox_min": [
        -2527.5478515625,
        -4078.252685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2522.5478515625,
        -4069.592529296875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660311102867126,
        0.4999901354312897,
        0.0
      ],
      "plane_d": -150.8487548828125,
      "bbox_min": [
        -2525.413818359375,
        -4073.922607421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2522.5478515625,
        -4069.592529296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123788356781006,
        0.35356104373931885,
        -0.7070974707603455
      ],
      "plane_d": 673.0498657226562,
      "bbox_min": [
        -2525.413818359375,
        -4073.922607421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2522.5478515625,
        -4069.592529296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123937964439392,
        0.3535696566104889,
        0.7070801854133606
      ],
      "plane_d": -892.6224365234375,
      "bbox_min": [
        -2525.413818359375,
        -4073.922607421875,
        1111.623779296875
      ],
      "bbox_max": [
        -2522.5478515625,
        -4069.592529296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660311102867126,
        0.4999901354312897,
        0.0
      ],
      "plane_d": -148.84912109375,
      "bbox_min": [
        -2527.5478515625,
        -4078.252685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2524.681884765625,
        -4073.922607421875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123937964439392,
        0.3535696566104889,
        0.7070801854133606
      ],
      "plane_d": -884.8445434570312,
      "bbox_min": [
        -2527.5478515625,
        -4078.252685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2524.681884765625,
        -4073.922607421875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123788356781006,
        0.35356104373931885,
        -0.7070974707603455
      ],
      "plane_d": 680.8279418945312,
      "bbox_min": [
        -2527.5478515625,
        -4078.252685546875,
        1111.623779296875
      ],
      "bbox_max": [
        -2524.681884765625,
        -4073.922607421875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5510156154632568,
        -0.834494948387146,
        0.0
      ],
      "plane_d": -1994.0164794921875,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5510156154632568,
        -0.834494948387146,
        0.0
      ],
      "plane_d": -1985.96630859375,
      "bbox_min": [
        -2539.16748046875,
        -4060.37841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.57421875,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.998195230960846,
        0.06005331128835678,
        0.0
      ],
      "plane_d": -2291.0458984375,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49991971254348755,
        -0.866071879863739,
        -0.0
      ],
      "plane_d": -4781.62890625,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2236163318157196,
        -0.3872886300086975,
        -0.894429087638855
      ],
      "plane_d": -1152.6297607421875,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2236381471157074,
        -0.3873264193534851,
        0.8944072127342224
      ],
      "plane_d": -3133.30126953125,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1112.123779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.998208224773407,
        0.05983571708202362,
        0.0
      ],
      "plane_d": -2283.91162109375,
      "bbox_min": [
        -2531.373046875,
        -4060.37841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.57421875,
        -4058.762451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000253915786743,
        -0.8660107851028442,
        -0.0
      ],
      "plane_d": -4781.6494140625,
      "bbox_min": [
        -2531.373046875,
        -4060.37841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.57421875,
        -4058.762451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.223638117313385,
        -0.3873263895511627,
        -0.8944071531295776
      ],
      "plane_d": -1152.8621826171875,
      "bbox_min": [
        -2531.373046875,
        -4060.37841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.57421875,
        -4058.762451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2236381471157074,
        -0.3873264193534851,
        0.8944072127342224
      ],
      "plane_d": -3133.30126953125,
      "bbox_min": [
        -2531.373046875,
        -4060.37841796875,
        1112.123779296875
      ],
      "bbox_max": [
        -2529.57421875,
        -4058.762451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9982051849365234,
        -0.05988685414195061,
        0.0
      ],
      "plane_d": 2301.13818359375,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5510034561157227,
        0.8345029950141907,
        0.0
      ],
      "plane_d": 1995.4210205078125,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4804.64404296875,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22360868752002716,
        0.3873026669025421,
        -0.8944248557090759
      ],
      "plane_d": 3134.49169921875,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22360868752002716,
        0.3873026967048645,
        0.8944248557090759
      ],
      "plane_d": 1154.013671875,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1112.123779296875
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659333825111389,
        -0.2587907314300537,
        -0.0
      ],
      "plane_d": -3486.25048828125,
      "bbox_min": [
        -2522.5478515625,
        -4069.592529296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660311102867126,
        0.4999901354312897,
        0.0
      ],
      "plane_d": -148.8487548828125,
      "bbox_min": [
        -2522.5478515625,
        -4069.592529296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123937964439392,
        0.3535696566104889,
        0.7070801854133606
      ],
      "plane_d": -884.8445434570312,
      "bbox_min": [
        -2522.5478515625,
        -4069.592529296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123788356781006,
        0.35356104373931885,
        -0.7070974707603455
      ],
      "plane_d": 680.8279418945312,
      "bbox_min": [
        -2522.5478515625,
        -4069.592529296875,
        1111.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7039642930030823,
        0.4064340889453888,
        -0.5824480056762695
      ],
      "plane_d": 500.59686279296875,
      "bbox_min": [
        -2671.39990234375,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2545.11376953125,
        -4042.25439453125,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6586298942565918,
        0.6586298942565918,
        0.36388659477233887
      ],
      "plane_d": 639.390625,
      "bbox_min": [
        -2671.39990234375,
        -4249.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2661.413818359375,
        -4243.69189453125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5814270973205566,
        0.5814270973205566,
        -0.5691089630126953
      ],
      "plane_d": 1555.0584716796875,
      "bbox_min": [
        -2671.39990234375,
        -4249.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2661.413818359375,
        -4243.69189453125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1121.623779296875,
      "bbox_min": [
        -2673.075439453125,
        -4249.7685546875,
        1119.9119873046875
      ],
      "bbox_max": [
        -2550.69873046875,
        -4027.00439453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999916553497314,
        -0.8660259246826172,
        -1.847579596869764e-06
      ],
      "plane_d": -4828.642578125,
      "bbox_min": [
        -2673.075439453125,
        -4249.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -2564.874267578125,
        -4065.557373046875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6481254696846008,
        0.6481215357780457,
        0.399839848279953
      ],
      "plane_d": 573.4082641601562,
      "bbox_min": [
        -2673.075439453125,
        -4249.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -2656.4736328125,
        -4243.69189453125,
        1148.53466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5814270973205566,
        0.5814270973205566,
        -0.5691089630126953
      ],
      "plane_d": 1555.0584716796875,
      "bbox_min": [
        -2673.075439453125,
        -4249.7685546875,
        1119.9119873046875
      ],
      "bbox_max": [
        -2666.998779296875,
        -4243.69189453125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2741.692626953125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3984.21875,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6481265425682068,
        -0.648120105266571,
        0.3998405635356903
      ],
      "plane_d": -1443.3369140625,
      "bbox_min": [
        -2733.863037109375,
        -4249.7685546875,
        1106.8345947265625
      ],
      "bbox_max": [
        -2705.536865234375,
        -4221.44189453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5812633037567139,
        -0.5812574625015259,
        -0.5694496035575867
      ],
      "plane_d": -253.52349853515625,
      "bbox_min": [
        -2720.962646484375,
        -4247.17529296875,
        1112.623779296875
      ],
      "bbox_max": [
        -2719.6171875,
        -4245.830078125,
        1113.0404052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21275591850280762,
        -0.7940161824226379,
        -0.5694498419761658
      ],
      "plane_d": -2159.841552734375,
      "bbox_min": [
        -2730.640869140625,
        -4249.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2720.174560546875,
        -4246.7958984375,
        1115.8927001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5812633037567139,
        -0.5812574625015259,
        -0.5694496035575867
      ],
      "plane_d": -253.52349853515625,
      "bbox_min": [
        -2720.962646484375,
        -4247.66796875,
        1112.623779296875
      ],
      "bbox_max": [
        -2720.174560546875,
        -4246.7958984375,
        1113.4166259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882434844970703,
        0.9659245014190674,
        0.0
      ],
      "plane_d": 3390.9111328125,
      "bbox_min": [
        -2741.692626953125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3990.27880859375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23722945153713226,
        -0.8853526711463928,
        0.3998410999774933
      ],
      "plane_d": -3568.94140625,
      "bbox_min": [
        -2741.692626953125,
        -4249.7685546875,
        1137.827880859375
      ],
      "bbox_max": [
        -2724.7353515625,
        -4240.640625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000011920928955,
        -0.8660246729850769,
        2.6352649911132175e-06
      ],
      "plane_d": -4828.6474609375,
      "bbox_min": [
        -2722.857421875,
        -4221.44189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3990.27880859375,
        1121.623779296875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2667.0234375,
        -4065.557373046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3990.27880859375,
        1117.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.4999936819076538,
        -0.8660290837287903,
        -0.0
      ],
      "plane_d": -4779.642578125,
      "bbox_min": [
        -2630.650390625,
        -4062.599609375,
        1062.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4010.896484375,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 256.7711181640625,
      "bbox_min": [
        -2630.650390625,
        -4062.599609375,
        1062.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4010.896484375,
        1117.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -246.770751953125,
      "bbox_min": [
        -2630.650390625,
        -4062.599609375,
        1062.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4010.896484375,
        1117.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2628.05224609375,
        -4062.599609375,
        1095.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4025.422607421875,
        1117.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1100.123779296875,
      "bbox_min": [
        -2622.80224609375,
        -4056.464111328125,
        1095.623779296875
      ],
      "bbox_max": [
        -2607.786865234375,
        -4044.908203125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1095.623779296875,
      "bbox_min": [
        -2622.80224609375,
        -4056.4638671875,
        1095.623779296875
      ],
      "bbox_max": [
        -2607.786865234375,
        -4044.908203125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500001072883606,
        -0.8660247921943665,
        0.0
      ],
      "plane_d": -4813.14453125,
      "bbox_min": [
        -2622.80224609375,
        -4056.4638671875,
        1095.623779296875
      ],
      "bbox_max": [
        -2607.786865234375,
        -4044.908203125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 4818.14453125,
      "bbox_min": [
        -2622.80224609375,
        -4056.4638671875,
        1095.623779296875
      ],
      "bbox_max": [
        -2610.286865234375,
        -4049.23828125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660261034965515,
        0.4999989867210388,
        0.0
      ],
      "plane_d": -234.800048828125,
      "bbox_min": [
        -2628.05224609375,
        -4062.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4025.422607421875,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000037550926208,
        -0.8660233616828918,
        0.0
      ],
      "plane_d": -4790.64599609375,
      "bbox_min": [
        -2603.659912109375,
        -4041.30859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4031.422607421875,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999959468841553,
        0.8660277724266052,
        1.17841018436593e-05
      ],
      "plane_d": 4800.63037109375,
      "bbox_min": [
        -2603.659912109375,
        -4041.30859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4031.422607421875,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123776435852051,
        0.35355043411254883,
        -0.7071037888526917
      ],
      "plane_d": 624.2259521484375,
      "bbox_min": [
        -2603.659912109375,
        -4041.30859375,
        1115.1722412109375
      ],
      "bbox_max": [
        -2596.536865234375,
        -4031.422607421875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1117.623779296875,
      "bbox_min": [
        -2628.05224609375,
        -4062.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2598.659912109375,
        -4025.422607421875,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49998313188552856,
        0.8660352230072021,
        -0.0
      ],
      "plane_d": 4826.64013671875,
      "bbox_min": [
        -2628.05224609375,
        -4062.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2616.659912109375,
        -4056.599609375,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -239.6529541015625,
      "bbox_min": [
        -2628.05224609375,
        -4061.83154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2620.990234375,
        -4056.599609375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2628.05224609375,
        -4061.83154296875,
        1112.623779296875
      ],
      "bbox_max": [
        -2620.990234375,
        -4056.599609375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999936819076538,
        0.8660290837287903,
        -0.0
      ],
      "plane_d": 4789.642578125,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1062.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -4010.896484375,
        1117.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1100.123779296875,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1095.623779296875
      ],
      "bbox_max": [
        -2608.55224609375,
        -4019.556640625,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1117.623779296875,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2608.55224609375,
        -4019.556640625,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 249.77099609375,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2619.05224609375,
        -4041.2431640625,
        1117.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2589518129825592,
        -0.9658902883529663,
        0.0
      ],
      "plane_d": -3231.58642578125,
      "bbox_min": [
        -2629.516357421875,
        -4054.2333984375,
        1101.623779296875
      ],
      "bbox_max": [
        -2621.650390625,
        -4041.2431640625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2587907314300537,
        -0.9659333825111389,
        0.0
      ],
      "plane_d": -3225.113037109375,
      "bbox_min": [
        -2624.516357421875,
        -4045.5732421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2621.650390625,
        -4041.2431640625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659333825111389,
        0.2587907314300537,
        0.0
      ],
      "plane_d": 3581.71142578125,
      "bbox_min": [
        -2624.516357421875,
        -4045.5732421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2621.650390625,
        -4041.2431640625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660311102867126,
        -0.4999901354312897,
        0.0
      ],
      "plane_d": 250.84912109375,
      "bbox_min": [
        -2624.516357421875,
        -4045.5732421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2621.650390625,
        -4041.2431640625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123796105384827,
        -0.3535482585430145,
        -0.7071032524108887
      ],
      "plane_d": 963.4105224609375,
      "bbox_min": [
        -2624.516357421875,
        -4045.5732421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2621.650390625,
        -4041.2431640625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.612404465675354,
        -0.353562593460083,
        0.7070744633674622
      ],
      "plane_d": -602.2520751953125,
      "bbox_min": [
        -2624.516357421875,
        -4045.5732421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2621.650390625,
        -4041.2431640625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659333825111389,
        0.2587907314300537,
        0.0
      ],
      "plane_d": 3588.7822265625,
      "bbox_min": [
        -2629.516357421875,
        -4054.2333984375,
        1101.623779296875
      ],
      "bbox_max": [
        -2626.650390625,
        -4049.9033203125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 250.653076171875,
      "bbox_min": [
        -2629.516357421875,
        -4054.2333984375,
        1101.623779296875
      ],
      "bbox_max": [
        -2626.650390625,
        -4049.9033203125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6124150156974792,
        -0.3536019027233124,
        -0.7070456743240356
      ],
      "plane_d": 963.2224731445312,
      "bbox_min": [
        -2629.516357421875,
        -4054.2333984375,
        1101.623779296875
      ],
      "bbox_max": [
        -2626.650390625,
        -4049.9033203125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123776435852051,
        -0.3535803258419037,
        0.707088828086853
      ],
      "plane_d": -602.4100952148438,
      "bbox_min": [
        -2629.516357421875,
        -4054.2333984375,
        1101.623779296875
      ],
      "bbox_max": [
        -2626.650390625,
        -4049.9033203125,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999901354312897,
        -0.8660311102867126,
        0.0
      ],
      "plane_d": -4810.6416015625,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2619.05224609375,
        -4041.2431640625,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2619.05224609375,
        -4041.2431640625,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2587907314300537,
        -0.9659333825111389,
        0.0
      ],
      "plane_d": -3232.18408203125,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2623.784423828125,
        -4045.5732421875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659450054168701,
        0.2587476074695587,
        -0.0
      ],
      "plane_d": 3581.5673828125,
      "bbox_min": [
        -2626.650390625,
        -4049.9033203125,
        1101.623779296875
      ],
      "bbox_max": [
        -2623.784423828125,
        -4045.5732421875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 248.6531982421875,
      "bbox_min": [
        -2626.650390625,
        -4049.9033203125,
        1101.623779296875
      ],
      "bbox_max": [
        -2623.784423828125,
        -4045.5732421875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123776435852051,
        -0.3535803258419037,
        -0.707088828086853
      ],
      "plane_d": 955.4816284179688,
      "bbox_min": [
        -2626.650390625,
        -4049.9033203125,
        1101.623779296875
      ],
      "bbox_max": [
        -2623.784423828125,
        -4045.5732421875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123402714729309,
        -0.353558748960495,
        0.7071320414543152
      ],
      "plane_d": -610.2467651367188,
      "bbox_min": [
        -2626.650390625,
        -4049.9033203125,
        1111.623779296875
      ],
      "bbox_max": [
        -2623.784423828125,
        -4045.5732421875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4826.64599609375,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1112.623779296875
      ],
      "bbox_max": [
        -2627.052490234375,
        -4055.099609375,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1112.623779296875
      ],
      "bbox_max": [
        -2627.052490234375,
        -4055.099609375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2622.712646484375,
        -4034.0830078125,
        1101.623779296875
      ],
      "bbox_max": [
        -2608.55224609375,
        -4019.556640625,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2622.712646484375,
        -4034.0830078125,
        1101.623779296875
      ],
      "bbox_max": [
        -2608.55224609375,
        -4019.556640625,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1095.623779296875,
      "bbox_min": [
        -2629.29736328125,
        -4049.23828125,
        1095.623779296875
      ],
      "bbox_max": [
        -2610.71728515625,
        -4020.806640625,
        1100.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660250306129456,
        -0.5000006556510925,
        0.0
      ],
      "plane_d": 254.290771484375,
      "bbox_min": [
        -2629.29736328125,
        -4049.23828125,
        1095.623779296875
      ],
      "bbox_max": [
        -2610.71728515625,
        -4020.806640625,
        1100.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660250306129456,
        0.5000006556510925,
        0.0
      ],
      "plane_d": -249.29052734375,
      "bbox_min": [
        -2629.29736328125,
        -4049.23828125,
        1095.623779296875
      ],
      "bbox_max": [
        -2610.71728515625,
        -4023.306640625,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 4818.14453125,
      "bbox_min": [
        -2624.96728515625,
        -4049.23828125,
        1095.623779296875
      ],
      "bbox_max": [
        -2620.30224609375,
        -4043.658203125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500001072883606,
        -0.8660247921943665,
        0.0
      ],
      "plane_d": -4813.14453125,
      "bbox_min": [
        -2622.46728515625,
        -4044.908203125,
        1095.623779296875
      ],
      "bbox_max": [
        -2620.30224609375,
        -4043.658203125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 4818.14453125,
      "bbox_min": [
        -2629.29736328125,
        -4047.98828125,
        1095.623779296875
      ],
      "bbox_max": [
        -2624.96728515625,
        -4045.48828125,
        1100.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2617.212646484375,
        -4024.556640625,
        1112.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -4010.896484375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7492250204086304,
        -0.4325616657733917,
        -0.5015498995780945
      ],
      "plane_d": 780.3982543945312,
      "bbox_min": [
        -2667.0234375,
        -4046.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -3990.27880859375,
        1062.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.623779296875,
      "bbox_min": [
        -2664.091552734375,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2649.91748046875,
        -4012.0,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4012.0,
      "bbox_min": [
        -2664.091552734375,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2649.91748046875,
        -4012.0,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7604115605354309,
        -0.44979920983314514,
        -0.4684601128101349
      ],
      "plane_d": 705.8880615234375,
      "bbox_min": [
        -2667.0234375,
        -4035.83154296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2635.703125,
        -3993.17724609375,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4012.0,
      "bbox_min": [
        -2659.0380859375,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2649.91748046875,
        -4012.0,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7590693235397339,
        -0.4528779983520508,
        -0.4676700830459595
      ],
      "plane_d": 688.9970703125,
      "bbox_min": [
        -2667.0234375,
        -4035.83154296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.690673828125,
        -4022.0,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4022.0,
      "bbox_min": [
        -2658.9130859375,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.690673828125,
        -4022.0,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253286361694,
        -0.5000002384185791,
        0.0
      ],
      "plane_d": 256.793212890625,
      "bbox_min": [
        -2645.994140625,
        -4046.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -4007.803466796875,
        1062.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.5006539225578308,
        0.865647554397583,
        -0.0
      ],
      "plane_d": 4809.3369140625,
      "bbox_min": [
        -2645.994140625,
        -4037.7431640625,
        1052.623779296875
      ],
      "bbox_max": [
        -2619.958740234375,
        -4021.54638671875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5006539225578308,
        -0.865647554397583,
        -0.0
      ],
      "plane_d": -4810.8369140625,
      "bbox_min": [
        -2645.994140625,
        -4037.7431640625,
        1052.623779296875
      ],
      "bbox_max": [
        -2627.712646484375,
        -4025.871337890625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8656676411628723,
        0.5006192326545715,
        0.0
      ],
      "plane_d": -274.4727783203125,
      "bbox_min": [
        -2645.994140625,
        -4027.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2645.2431640625,
        -4025.871337890625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1055.423828125,
      "bbox_min": [
        -2635.0615234375,
        -4036.4208984375,
        1052.623779296875
      ],
      "bbox_max": [
        -2619.958740234375,
        -4021.54638671875,
        1055.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660413026809692,
        0.49997252225875854,
        0.0
      ],
      "plane_d": -262.4549560546875,
      "bbox_min": [
        -2635.0615234375,
        -4033.671630859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2624.721923828125,
        -4021.54638671875,
        1055.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1054.163818359375,
      "bbox_min": [
        -2635.0615234375,
        -4033.670166015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2630.21484375,
        -4029.12548828125,
        1054.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -266.1470947265625,
      "bbox_min": [
        -2635.0615234375,
        -4031.7451171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2633.549072265625,
        -4029.12548828125,
        1054.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253286361694,
        -0.5000002384185791,
        0.0
      ],
      "plane_d": 246.79296875,
      "bbox_min": [
        -2619.05224609375,
        -4046.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -4007.803466796875,
        1062.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8578631281852722,
        -0.5138782262802124,
        0.0
      ],
      "plane_d": 179.80859375,
      "bbox_min": [
        -2612.212646484375,
        -4015.896484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -4007.803466796875,
        1062.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999936819076538,
        0.8660290837287903,
        -0.0
      ],
      "plane_d": 4779.642578125,
      "bbox_min": [
        -2612.212646484375,
        -4015.896484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -4007.803466796875,
        1062.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8578631281852722,
        -0.5138782262802124,
        0.0
      ],
      "plane_d": 179.30859375,
      "bbox_min": [
        -2612.212646484375,
        -4011.1533203125,
        1055.623779296875
      ],
      "bbox_max": [
        -2611.779541015625,
        -4010.896484375,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1057.623779296875,
      "bbox_min": [
        -2612.212646484375,
        -4011.1533203125,
        1057.623779296875
      ],
      "bbox_max": [
        -2611.779541015625,
        -4010.896484375,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1057.623779296875,
      "bbox_min": [
        -2612.212646484375,
        -4011.146240234375,
        1057.623779296875
      ],
      "bbox_max": [
        -2609.930908203125,
        -4007.803466796875,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5088441371917725,
        -0.860858678817749,
        -0.0
      ],
      "plane_d": -4812.919921875,
      "bbox_min": [
        -2619.05224609375,
        -4046.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2612.5048828125,
        -4042.7431640625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659904599189758,
        -0.5000606179237366,
        0.0
      ],
      "plane_d": 239.7235107421875,
      "bbox_min": [
        -2613.2548828125,
        -4046.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2612.5048828125,
        -4044.87109375,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745940685272217,
        0.4472135901451111,
        0.447218120098114
      ],
      "plane_d": -696.4476318359375,
      "bbox_min": [
        -2722.857421875,
        -4221.44189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4040.179443359375,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2714.197021484375,
        -4221.44189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.33154296875,
        1079.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4947.8427734375,
      "bbox_min": [
        -2692.456787109375,
        -4168.78662109375,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.33154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        -0.5000061392784119,
        0.0
      ],
      "plane_d": 238.760498046875,
      "bbox_min": [
        -2637.016357421875,
        -4074.06591796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.33154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -239.7708740234375,
      "bbox_min": [
        -2637.016357421875,
        -4071.857666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.990234375,
        -4056.33154296875,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2627.490234375,
        -4071.857666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2626.624267578125,
        -4071.357666015625,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2637.016357421875,
        -4071.357666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2626.990234375,
        -4056.33154296875,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4838.6455078125,
      "bbox_min": [
        -2636.150390625,
        -4071.357666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2626.990234375,
        -4056.83154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 249.652587890625,
      "bbox_min": [
        -2636.150390625,
        -4066.357666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2635.650390625,
        -4065.49169921875,
        1057.7200927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 249.7708740234375,
      "bbox_min": [
        -2635.650390625,
        -4065.49169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2630.650390625,
        -4056.83154296875,
        1057.7200927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999901354312897,
        0.8660311102867126,
        0.0
      ],
      "plane_d": 4837.798828125,
      "bbox_min": [
        -2625.71240234375,
        -4074.06591796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2622.1142578125,
        -4070.833984375,
        1059.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -237.5089111328125,
      "bbox_min": [
        -2625.71240234375,
        -4074.06591796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2622.1142578125,
        -4070.833984375,
        1059.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999901354312897,
        -0.8660311102867126,
        0.0
      ],
      "plane_d": -4839.798828125,
      "bbox_min": [
        -2625.71240234375,
        -4074.06591796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2622.1142578125,
        -4070.833984375,
        1059.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39631029963493347,
        -0.6864476203918457,
        0.6096949577331543
      ],
      "plane_d": -4480.40380859375,
      "bbox_min": [
        -2625.71240234375,
        -4074.06591796875,
        1056.5999755859375
      ],
      "bbox_max": [
        -2622.1142578125,
        -4070.833984375,
        1059.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        -0.5000061392784119,
        0.0
      ],
      "plane_d": 238.760498046875,
      "bbox_min": [
        -2629.69677734375,
        -4071.857666015625,
        1072.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4061.83154296875,
        1079.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -239.7708740234375,
      "bbox_min": [
        -2629.69677734375,
        -4071.857666015625,
        1072.623779296875
      ],
      "bbox_max": [
        -2621.990234375,
        -4061.83154296875,
        1079.719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2627.490234375,
        -4071.857666015625,
        1072.623779296875
      ],
      "bbox_max": [
        -2626.624267578125,
        -4071.357666015625,
        1079.719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4838.6455078125,
      "bbox_min": [
        -2629.19677734375,
        -4070.49169921875,
        1072.623779296875
      ],
      "bbox_max": [
        -2626.990234375,
        -4069.2177734375,
        1077.7196044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660218715667725,
        0.5000061392784119,
        0.0
      ],
      "plane_d": -250.7601318359375,
      "bbox_min": [
        -2688.893310546875,
        -4107.025390625,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4040.179443359375,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 249.7708740234375,
      "bbox_min": [
        -2637.016357421875,
        -4071.857666015625,
        1055.72021484375
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.83154296875,
        1113.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2637.016357421875,
        -4066.357666015625,
        1055.72021484375
      ],
      "bbox_max": [
        -2636.150390625,
        -4065.857666015625,
        1113.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4838.6455078125,
      "bbox_min": [
        -2636.150390625,
        -4071.857666015625,
        1062.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.83154296875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        -0.5000061392784119,
        0.0
      ],
      "plane_d": 238.760498046875,
      "bbox_min": [
        -2636.150390625,
        -4071.857666015625,
        1062.623779296875
      ],
      "bbox_max": [
        -2626.124267578125,
        -4065.49169921875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2636.150390625,
        -4067.58349609375,
        1062.623779296875
      ],
      "bbox_max": [
        -2633.527099609375,
        -4065.49169921875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -239.7708740234375,
      "bbox_min": [
        -2635.650390625,
        -4070.99169921875,
        1077.719482421875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.83154296875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2635.650390625,
        -4070.49169921875,
        1112.623779296875
      ],
      "bbox_max": [
        -2621.990234375,
        -4056.83154296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2688.893310546875,
        -4107.025390625,
        1052.623779296875
      ],
      "bbox_max": [
        -2636.712646484375,
        -4040.179443359375,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86602783203125,
        -0.4999958872795105,
        0.0
      ],
      "plane_d": 256.8175048828125,
      "bbox_min": [
        -2688.893310546875,
        -4107.025390625,
        1052.623779296875
      ],
      "bbox_max": [
        -2636.712646484375,
        -4053.33154296875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.30000096559524536,
        -0.519611120223999,
        0.8000024557113647
      ],
      "plane_d": -3776.47412109375,
      "bbox_min": [
        -2688.893310546875,
        -4107.025390625,
        1052.623779296875
      ],
      "bbox_max": [
        -2657.71240234375,
        -4076.552490234375,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1057.5999755859375,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        -0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": -4345.6044921875,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3041.499755859375,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3041.499755859375,
        -3926.80859375,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3041.499755859375,
        -4247.66796875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3041.499755859375,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.23722945153713226,
        -0.8853526711463928,
        0.3998410999774933
      ],
      "plane_d": -3568.94140625,
      "bbox_min": [
        -2910.0,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2740.97705078125,
        -4247.66796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2910.0,
      "bbox_min": [
        -2910.0,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2910.0,
        -4247.66796875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3041.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -2846.860595703125,
        -3905.65966796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2823.6796875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9752788543701172,
        -0.22097784280776978,
        0.0
      ],
      "plane_d": 1913.418701171875,
      "bbox_min": [
        -2846.860595703125,
        -3905.65966796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2845.2509765625,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -3021.999755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3903.140869140625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -2772.9892578125,
        -3918.51513671875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2751.3486328125,
        -3913.915283203125,
        1185.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -3021.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3903.140869140625,
        1185.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2994.94970703125,
      "bbox_min": [
        -3021.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3021.999755859375,
      "bbox_min": [
        -3021.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -3987.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3008.0888671875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4042.89697265625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -2250.0205078125,
      "bbox_min": [
        -2995.999755859375,
        -4048.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4048.234375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2716.85986328125,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -2250.0205078125,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4048.234130859375,
        1069.623779296875
      ],
      "bbox_max": [
        -2850.55126953125,
        -3974.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2922.809814453125,
      "bbox_min": [
        -2994.94970703125,
        -4048.234130859375,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.099853515625,
        -4018.86865234375,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660361766815186,
        0.4999813139438629,
        0.0
      ],
      "plane_d": 4614.6796875,
      "bbox_min": [
        -2994.94970703125,
        -4048.234130859375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.185791015625,
        -4042.89697265625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4048.234130859375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.185791015625,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5,
        -0.0
      ],
      "plane_d": 4476.6689453125,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2720.068603515625,
        -3979.57568359375,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2922.809814453125,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4019.310546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4035.3193359375,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.099853515625,
        -4020.2685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660361766815186,
        0.4999813139438629,
        0.0
      ],
      "plane_d": 4614.6796875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2989.91064453125,
        -4046.827880859375,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2989.91064453125,
        -4046.827880859375,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2839.3173828125,
      "bbox_min": [
        -2929.9638671875,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4019.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 519.7159423828125,
      "bbox_min": [
        -2929.9638671875,
        -4035.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2920.927978515625,
        -4019.7685546875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        -0.0
      ],
      "plane_d": 4482.66845703125,
      "bbox_min": [
        -2846.4638671875,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075148224830627,
        0.4084834158420563,
        -0.5766835808753967
      ],
      "plane_d": 4282.77734375,
      "bbox_min": [
        -2846.4638671875,
        -4050.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375558018684387,
        0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": 3232.564697265625,
      "bbox_min": [
        -2845.30908203125,
        -4050.7685546875,
        1106.623779296875
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4035.3193359375,
      "bbox_min": [
        -2862.34423828125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2720.068603515625,
        -3979.57568359375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999080300331116,
        -0.0,
        0.013563040643930435
      ],
      "plane_d": 2764.814453125,
      "bbox_min": [
        -2862.34423828125,
        -4020.66845703125,
        1069.623779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -3979.57568359375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -2862.34423828125,
        -3980.7685546875,
        1069.623779296875
      ],
      "bbox_max": [
        -2857.65478515625,
        -3979.57568359375,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": -2676.225341796875,
      "bbox_min": [
        -2793.499755859375,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2761.676025390625,
        -4026.1279296875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075143456459045,
        -0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 933.3873291015625,
      "bbox_min": [
        -2771.9638671875,
        -4041.419189453125,
        1064.0205078125
      ],
      "bbox_max": [
        -2761.676025390625,
        -4026.1279296875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2770.80908203125,
        -4041.419189453125,
        1093.623779296875
      ],
      "bbox_max": [
        -2761.676025390625,
        -4026.1279296875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375649213790894,
        -0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -258.964111328125,
      "bbox_min": [
        -2770.80908203125,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2761.676025390625,
        -4027.783447265625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 382.884033203125,
      "bbox_min": [
        -2771.9638671875,
        -4035.419189453125,
        1064.0205078125
      ],
      "bbox_max": [
        -2767.03125,
        -4026.87548828125,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4035.419189453125,
      "bbox_min": [
        -2790.03564453125,
        -4035.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2767.03125,
        -4026.87548828125,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 382.884033203125,
      "bbox_min": [
        -2771.9638671875,
        -4035.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2767.03125,
        -4026.87548828125,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2720.068603515625,
        -4029.599853515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2720.06884765625,
        -4044.698486328125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2720.068603515625,
        -4044.698486328125,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2730.0888671875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2720.068603515625,
        -4046.827880859375,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5,
        -0.0
      ],
      "plane_d": 4396.64990234375,
      "bbox_min": [
        -2859.99951171875,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -3969.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999080300331116,
        -0.0,
        0.013563040643930435
      ],
      "plane_d": 2764.814453125,
      "bbox_min": [
        -2859.99951171875,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -3969.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -2859.99951171875,
        -3984.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -3571.166748046875,
      "bbox_min": [
        -2832.85693359375,
        -3984.7685546875,
        1065.623779296875
      ],
      "bbox_max": [
        -2824.999755859375,
        -3980.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2819.999755859375,
      "bbox_min": [
        -2824.999755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1063.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3979.7685546875,
      "bbox_min": [
        -2824.999755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3974.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1063.623779296875,
      "bbox_min": [
        -2824.999755859375,
        -3979.7685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -2819.999755859375,
        -3974.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375558018684387,
        0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": 3164.416259765625,
      "bbox_min": [
        -2771.9638671875,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        -0.5,
        0.0
      ],
      "plane_d": 376.881591796875,
      "bbox_min": [
        -2771.9638671875,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075148224830627,
        0.4084834158420563,
        -0.5766835808753967
      ],
      "plane_d": 4217.404296875,
      "bbox_min": [
        -2771.9638671875,
        -4029.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075143456459045,
        -0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 933.3873291015625,
      "bbox_min": [
        -2768.499755859375,
        -4029.60009765625,
        1066.0557861328125
      ],
      "bbox_max": [
        -2755.999755859375,
        -4019.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4029.60009765625,
        1093.623779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4019.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375649213790894,
        -0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -258.964111328125,
      "bbox_min": [
        -2765.245849609375,
        -4029.60009765625,
        1106.623779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4019.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 382.884033203125,
      "bbox_min": [
        -2767.03125,
        -4026.87548828125,
        1066.0557861328125
      ],
      "bbox_max": [
        -2762.927978515625,
        -4019.7685546875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        -0.0
      ],
      "plane_d": 4402.6494140625,
      "bbox_min": [
        -2771.9638671875,
        -4026.87548828125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2762.927978515625,
        -4004.117919921875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 382.884033203125,
      "bbox_min": [
        -2767.03125,
        -4026.87548828125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2762.927978515625,
        -4019.7685546875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2761.676025390625,
        -4032.48779296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2755.999755859375,
      "bbox_min": [
        -2755.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4039.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": 2905.50537109375,
      "bbox_min": [
        -2731.999755859375,
        -4046.718505859375,
        1098.82373046875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2727.813720703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4012.0,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -4012.0,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.623779296875,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -4012.0,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4739527404308319,
        0.0,
        -0.8805503249168396
      ],
      "plane_d": 2237.621826171875,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4739527404308319,
        0.0,
        -0.8805503249168396
      ],
      "plane_d": 2255.23291015625,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1098.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": 2905.50537109375,
      "bbox_min": [
        -2716.85986328125,
        -4046.718505859375,
        1098.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660361766815186,
        0.4999813139438629,
        -0.0
      ],
      "plane_d": 4373.92138671875,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2711.91064453125,
        -4042.89697265625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2711.91064453125,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4022.0,
      "bbox_min": [
        -2709.0,
        -4022.0,
        1057.5999755859375
      ],
      "bbox_max": [
        -2664.091552734375,
        -4022.0,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882434844970703,
        0.9659245014190674,
        0.0
      ],
      "plane_d": 3390.9111328125,
      "bbox_min": [
        -3008.0888671875,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2685.8232421875,
        -4050.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23722945153713226,
        -0.8853526711463928,
        0.3998410999774933
      ],
      "plane_d": -3568.94140625,
      "bbox_min": [
        -2750.961181640625,
        -4247.66796875,
        1146.69970703125
      ],
      "bbox_max": [
        -2739.973876953125,
        -4244.7236328125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2994.94970703125,
      "bbox_min": [
        -3008.0888671875,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2685.8232421875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4054.818603515625,
      "bbox_min": [
        -3008.0888671875,
        -4058.64013671875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3008.0888671875,
        -4054.818603515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        0.8912780284881592,
        0.0
      ],
      "plane_d": 4970.70166015625,
      "bbox_min": [
        -2995.999755859375,
        -4053.302734375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4052.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -3005.750732421875,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3005.750732421875,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4054.818603515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2839.3173828125,
      "bbox_min": [
        -2994.94970703125,
        -4054.818603515625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4066.316650390625,
      "bbox_min": [
        -2994.94970703125,
        -4054.818603515625,
        1108.123779296875
      ],
      "bbox_max": [
        -2854.599853515625,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660361766815186,
        -0.4999813139438629,
        0.0
      ],
      "plane_d": 564.0621337890625,
      "bbox_min": [
        -2994.94970703125,
        -4051.404296875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2989.91064453125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4051.404296875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2989.91064453125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        0.8912780284881592,
        0.0
      ],
      "plane_d": 4970.70166015625,
      "bbox_min": [
        -2994.94970703125,
        -4054.818603515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2990.277587890625,
        -4051.404296875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4054.818603515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.185791015625,
        -4053.30322265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4054.70947265625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2990.277587890625,
        -4051.404296875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        0.8912780284881592,
        0.0
      ],
      "plane_d": 4970.70166015625,
      "bbox_min": [
        -2992.185302734375,
        -4054.818603515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2991.97021484375,
        -4054.709228515625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        -0.5,
        0.0
      ],
      "plane_d": 425.900390625,
      "bbox_min": [
        -2839.766357421875,
        -4054.818603515625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 431.90283203125,
      "bbox_min": [
        -2839.766357421875,
        -4054.818603515625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075143456459045,
        -0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 973.43408203125,
      "bbox_min": [
        -2839.766357421875,
        -4054.818603515625,
        1076.123779296875
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375649213790894,
        -0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -217.216064453125,
      "bbox_min": [
        -2837.45703125,
        -4054.818603515625,
        1106.623779296875
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4054.818603515625,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4054.818603515625,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4054.818603515625,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2755.999755859375,
      "bbox_min": [
        -2755.999755859375,
        -4054.818603515625,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2730.0888671875,
        -4054.818603515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -2376.92626953125,
      "bbox_min": [
        -2728.029052734375,
        -4054.818603515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2723.999755859375,
        -4052.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        0.8912780284881592,
        0.0
      ],
      "plane_d": 4970.70166015625,
      "bbox_min": [
        -2994.94970703125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2922.809814453125,
      "bbox_min": [
        -2994.94970703125,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.099853515625,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660361766815186,
        -0.4999813139438629,
        0.0
      ],
      "plane_d": 564.0621337890625,
      "bbox_min": [
        -2994.94970703125,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.248779296875,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -2994.94970703125,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.248779296875,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.248779296875,
        -4054.818603515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        -0.5,
        0.0
      ],
      "plane_d": 425.900390625,
      "bbox_min": [
        -2939.89990234375,
        -4082.2265625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2728.028564453125,
        -4054.818603515625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2922.809814453125,
      "bbox_min": [
        -2939.89990234375,
        -4082.2265625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2832.838134765625,
        -4054.818603515625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": 4065.4736328125,
      "bbox_min": [
        -2939.89990234375,
        -4081.2685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.099853515625,
        -4080.86865234375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        -0.0
      ],
      "plane_d": 4570.4814453125,
      "bbox_min": [
        -2929.9638671875,
        -4081.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2832.838134765625,
        -4054.818603515625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 431.90283203125,
      "bbox_min": [
        -2846.4638671875,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2832.838134765625,
        -4054.818603515625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075143456459045,
        -0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 973.43408203125,
      "bbox_min": [
        -2846.4638671875,
        -4072.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2832.838134765625,
        -4054.818603515625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375649213790894,
        -0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -217.216064453125,
      "bbox_min": [
        -2845.30908203125,
        -4072.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2832.838134765625,
        -4054.818603515625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": 4065.4736328125,
      "bbox_min": [
        -2790.03564453125,
        -4081.514404296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2728.028564453125,
        -4054.818603515625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999080300331116,
        -0.0,
        0.013563040643930435
      ],
      "plane_d": 2764.814453125,
      "bbox_min": [
        -2780.499755859375,
        -4081.514404296875,
        1108.123779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -4080.86865234375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": 4427.650390625,
      "bbox_min": [
        -2790.03564453125,
        -4075.4091796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2728.028564453125,
        -4054.818603515625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4066.117919921875,
      "bbox_min": [
        -2790.03564453125,
        -4075.4091796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2761.67578125,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": 4433.6494140625,
      "bbox_min": [
        -2771.9638671875,
        -4075.4091796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2761.67578125,
        -4066.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4075.4091796875,
        1093.623779296875
      ],
      "bbox_max": [
        -2767.031005859375,
        -4072.1181640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3190.83642578125,
      "bbox_min": [
        -2769.654296875,
        -4074.661865234375,
        1093.623779296875
      ],
      "bbox_max": [
        -2761.67578125,
        -4066.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4074.661865234375,
        1093.623779296875
      ],
      "bbox_max": [
        -2761.676025390625,
        -4066.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4066.117919921875,
        1093.623779296875
      ],
      "bbox_max": [
        -2765.035888671875,
        -4060.118408203125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4056.839111328125,
        1102.623779296875
      ],
      "bbox_max": [
        -2728.028564453125,
        -4054.818603515625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375583052635193,
        -0.4258343279361725,
        0.5240923166275024
      ],
      "plane_d": -285.4197998046875,
      "bbox_min": [
        -2771.9638671875,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": 4427.650390625,
      "bbox_min": [
        -2771.9638671875,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075129747390747,
        -0.4084874093532562,
        -0.5766832232475281
      ],
      "plane_d": 908.0388793945312,
      "bbox_min": [
        -2771.9638671875,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4071.937255859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075146436691284,
        0.4084837734699249,
        -0.5766837000846863
      ],
      "plane_d": 4242.7314453125,
      "bbox_min": [
        -2768.499755859375,
        -4081.7685546875,
        1066.05615234375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4071.937255859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4081.7685546875,
        1093.623779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4071.937255859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3190.83642578125,
      "bbox_min": [
        -2765.245849609375,
        -4081.7685546875,
        1106.623779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4071.937255859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": 4433.6494140625,
      "bbox_min": [
        -2767.031005859375,
        -4081.7685546875,
        1066.05615234375
      ],
      "bbox_max": [
        -2762.927978515625,
        -4074.661865234375,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660222887992859,
        -0.5000054836273193,
        0.0
      ],
      "plane_d": 351.8505859375,
      "bbox_min": [
        -2771.9638671875,
        -4097.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2762.927978515625,
        -4074.661865234375,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": 4433.6494140625,
      "bbox_min": [
        -2767.031005859375,
        -4081.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2762.927978515625,
        -4074.661865234375,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2761.676025390625,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2755.999755859375,
      "bbox_min": [
        -2755.999755859375,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": -981.156494140625,
      "bbox_min": [
        -2731.999755859375,
        -4061.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -2727.750732421875,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4061.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2716.85986328125,
        -4088.39453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2685.8232421875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30000096559524536,
        -0.519611120223999,
        0.8000024557113647
      ],
      "plane_d": -3776.47412109375,
      "bbox_min": [
        -2687.17529296875,
        -4088.39453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2685.8232421875,
        -4085.78515625,
        1059.6280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": -981.156494140625,
      "bbox_min": [
        -2716.85986328125,
        -4061.7685546875,
        1098.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4054.818603515625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2716.85986328125,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2711.91064453125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3041.499755859375,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1052.623779296875
      ],
      "bbox_max": [
        -3041.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2846.860595703125,
        -3905.65966796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2823.678955078125,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9752788543701172,
        -0.22097784280776978,
        0.0
      ],
      "plane_d": 1913.418701171875,
      "bbox_min": [
        -2846.860595703125,
        -3905.65966796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2845.2509765625,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3513067364692688,
        -0.936260461807251,
        -0.0
      ],
      "plane_d": -4664.21923828125,
      "bbox_min": [
        -2823.678955078125,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2658.927490234375,
        -3903.140869140625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2772.989501953125,
        -3918.51513671875,
        1052.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3913.915283203125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2823.678955078125,
        -3913.915283203125,
        1052.623779296875
      ],
      "bbox_max": [
        -2772.989501953125,
        -3903.140869140625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2819.999755859375,
      "bbox_min": [
        -2819.999755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -3925.844482421875,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2704.999755859375,
      "bbox_min": [
        -2819.999755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -3925.844482421875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1736631691455841,
        -0.9848051071166992,
        0.0
      ],
      "plane_d": -4355.2041015625,
      "bbox_min": [
        -2819.999755859375,
        -3930.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2812.499755859375,
        -3925.844482421875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000314116477966,
        -0.8660072684288025,
        0.0
      ],
      "plane_d": -1991.7872314453125,
      "bbox_min": [
        -2819.999755859375,
        -3930.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2815.8681640625,
        -3925.844482421875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939699649810791,
        -0.3420009911060333,
        0.0
      ],
      "plane_d": 1305.6259765625,
      "bbox_min": [
        -2819.999755859375,
        -3930.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2818.830078125,
        -3927.5546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2704.999755859375,
      "bbox_min": [
        -3041.499755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3979.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3041.499755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3021.999755859375,
      "bbox_min": [
        -3021.999755859375,
        -4020.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882434844970703,
        0.9659245014190674,
        0.0
      ],
      "plane_d": 3390.9111328125,
      "bbox_min": [
        -2999.499755859375,
        -4247.66796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -3994.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 394.1783447265625,
      "bbox_min": [
        -2999.499755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4413.98095703125,
      "bbox_min": [
        -2999.499755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4049.902587890625,
      "bbox_min": [
        -2999.499755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2997.999755859375,
        -4049.902587890625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 570.81298828125,
      "bbox_min": [
        -2998.499755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2997.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4022.0,
      "bbox_min": [
        -2709.0,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -4022.0,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4467.1337890625,
      "bbox_min": [
        -2851.999755859375,
        -4003.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2849.499755859375,
        -3994.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 468.3311767578125,
      "bbox_min": [
        -2851.999755859375,
        -4003.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2849.499755859375,
        -3998.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4012.0,
      "bbox_min": [
        -2709.0,
        -4012.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -4012.0,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        -0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2658.927490234375,
        -3984.21875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3979.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4022.0,
      "bbox_min": [
        -2704.999755859375,
        -4094.796630859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2664.091552734375,
        -4022.0,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6879106163978577,
        -0.6849433779716492,
        0.24006594717502594
      ],
      "plane_d": -658.194091796875,
      "bbox_min": [
        -3600.0,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4264.18798828125,
      "bbox_min": [
        -3600.0,
        -4119.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3549.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6787002682685852,
        -0.6787002682685852,
        0.2805918753147125
      ],
      "plane_d": -5190.9072265625,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3224.999755859375,
        -3984.973388671875,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3857.455078125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3207.47998046875,
        -3984.973388671875,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3857.455078125,
        1165.0567626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3207.47998046875,
        -3984.973388671875,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1133.5926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3068.5068359375,
        -3889.566650390625,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1098.4541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1992727518081665,
        0.9384201169013977,
        0.2822374105453491
      ],
      "plane_d": 4158.921875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3224.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6980487108230591,
        0.6980504989624023,
        0.15954118967056274
      ],
      "plane_d": 5042.2138671875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4032.349609375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4096.39453125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071084380149841,
        -0.7071052193641663,
        -0.0
      ],
      "plane_d": -5400.009765625,
      "bbox_min": [
        -3440.33251953125,
        -4210.6396484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3426.12841796875,
        -4196.435546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6224409937858582,
        -0.7379052639007568,
        0.2608889639377594
      ],
      "plane_d": -5213.8037109375,
      "bbox_min": [
        -3301.525146484375,
        -3890.92822265625,
        1102.623779296875
      ],
      "bbox_max": [
        -3224.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6375481486320496,
        -0.7279708385467529,
        0.25217205286026
      ],
      "plane_d": -1145.8114013671875,
      "bbox_min": [
        -3502.938720703125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3502.938720703125,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3479.999755859375,
        -4189.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3188.277587890625,
        -3976.673095703125,
        1098.453857421875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3083.468505859375,
        -3931.36865234375,
        1098.453857421875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3439.048583984375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826853334903717,
        0.9238787889480591,
        0.0
      ],
      "plane_d": 2758.4794921875,
      "bbox_min": [
        -3439.048583984375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4197.71923828125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3051.571044921875,
        -4249.7685546875,
        1147.9725341796875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4247.66796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071084380149841,
        -0.7071052193641663,
        -0.0
      ],
      "plane_d": -5400.009765625,
      "bbox_min": [
        -3439.048583984375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3386.999755859375,
        -4197.71923828125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3699.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4119.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3699.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4206.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3744.02880859375,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9751271605491638,
        0.22164621949195862
      ],
      "plane_d": -4427.49267578125,
      "bbox_min": [
        -3749.999755859375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3744.02880859375,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4264.18798828125,
      "bbox_min": [
        -3749.999755859375,
        -4119.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        3.487878927899146e-07,
        0.0
      ],
      "plane_d": -2919.998291015625,
      "bbox_min": [
        -3835.11669921875,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4249.7685546875,
        1302.6241455078125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2214.77978515625,
      "bbox_min": [
        -2920.0,
        -5077.3330078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48899564146995544,
        0.8722862601280212,
        0.0
      ],
      "plane_d": 2783.7412109375,
      "bbox_min": [
        -2214.77978515625,
        -4432.9013671875,
        1167.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4379.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2920.0,
        -5077.3330078125,
        1060.0
      ],
      "bbox_max": [
        -2214.77978515625,
        -4919.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2920.0,
        -5077.3330078125,
        1060.0
      ],
      "bbox_max": [
        -2908.47216796875,
        -4942.994140625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        -2920.0,
        -5077.3330078125,
        1060.0
      ],
      "bbox_max": [
        -2910.000244140625,
        -5050.6669921875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2839.999755859375,
      "bbox_min": [
        -2920.0,
        -4919.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4869.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4869.7685546875,
        1231.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9920545220375061,
        0.12580856680870056
      ],
      "plane_d": -5025.68896484375,
      "bbox_min": [
        -2920.0,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4850.7685546875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4850.7685546875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1179.3675537109375
      ],
      "bbox_max": [
        -2901.78662109375,
        -4852.89501953125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01754850521683693,
        -0.9926998019218445,
        0.11932884156703949
      ],
      "plane_d": -4969.9775390625,
      "bbox_min": [
        -2920.0,
        -4916.376953125,
        1179.3675537109375
      ],
      "bbox_max": [
        -2901.78662109375,
        -4910.19970703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2839.999755859375,
      "bbox_min": [
        -2920.0,
        -4910.60400390625,
        1227.393310546875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4639.62060546875,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4869.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      "bbox_max": [
        -2799.999755859375,
        -4869.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": 1732.95654296875,
      "bbox_min": [
        -2920.0,
        -4910.60400390625,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        -0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": -4913.1123046875,
      "bbox_min": [
        -2920.0,
        -4910.60400390625,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2920.0,
        -4857.9619140625,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135422706604004,
        -0.4067438244819641,
        -0.0
      ],
      "plane_d": -3873.526123046875,
      "bbox_min": [
        -2346.841796875,
        -4307.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7610056400299072,
        -0.6487452983856201,
        -0.0
      ],
      "plane_d": -4560.17578125,
      "bbox_min": [
        -2346.841796875,
        -4307.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.841796875,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4067084789276123,
        0.9135580062866211,
        0.0
      ],
      "plane_d": 2985.219970703125,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135460257530212,
        -0.4067356288433075,
        -0.0
      ],
      "plane_d": -3861.5,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8099361658096313,
        -0.3606100380420685,
        -0.4625622630119324
      ],
      "plane_d": -2866.8154296875,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1203.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2654.999755859375,
        -4250.8173828125,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.341064453125,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7892683148384094,
        0.45568564534187317,
        0.411590039730072
      ],
      "plane_d": -632.83740234375,
      "bbox_min": [
        -2654.999755859375,
        -4250.8173828125,
        1151.3607177734375
      ],
      "bbox_max": [
        -2654.341064453125,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6481254696846008,
        0.6481215357780457,
        0.399839848279953
      ],
      "plane_d": 573.4082641601562,
      "bbox_min": [
        -2654.999755859375,
        -4250.8173828125,
        1152.302978515625
      ],
      "bbox_max": [
        -2654.874267578125,
        -4250.61962890625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4372.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2869.999755859375,
      "bbox_min": [
        -2917.16259765625,
        -4372.7685546875,
        1053.123779296875
      ],
      "bbox_max": [
        -2656.499755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1122.623779296875,
      "bbox_min": [
        -2862.999755859375,
        -4372.7685546875,
        1053.123779296875
      ],
      "bbox_max": [
        -2656.499755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4306.16796875,
      "bbox_min": [
        -2919.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2588197588920593,
        -0.9659256935119629,
        0.0
      ],
      "plane_d": -3447.43505859375,
      "bbox_min": [
        -2910.0,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2910.0,
        -4291.30322265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2910.0,
      "bbox_min": [
        -2910.0,
        -4260.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2910.0,
        -4249.7685546875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": 3450.1103515625,
      "bbox_min": [
        -2919.999755859375,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9270538687705994,
        0.37492841482162476
      ],
      "plane_d": 3567.89501953125,
      "bbox_min": [
        -2919.999755859375,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2687.31787109375,
        -4283.1357421875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8128714561462402,
        -0.5824432373046875
      ],
      "plane_d": 4142.2626953125,
      "bbox_min": [
        -2919.999755859375,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2687.31787109375,
        -4283.1357421875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24108071625232697,
        0.8997085690498352,
        0.36387449502944946
      ],
      "plane_d": 2799.443115234375,
      "bbox_min": [
        -2750.96142578125,
        -4298.61669921875,
        1101.623779296875
      ],
      "bbox_max": [
        -2687.31787109375,
        -4283.1357421875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21281865239143372,
        0.7942498922348022,
        -0.5691003799438477
      ],
      "plane_d": 3461.91455078125,
      "bbox_min": [
        -2750.961181640625,
        -4298.61669921875,
        1112.623779296875
      ],
      "bbox_max": [
        -2711.724853515625,
        -4288.103515625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23722945153713226,
        -0.8853526711463928,
        0.3998410999774933
      ],
      "plane_d": -3568.94140625,
      "bbox_min": [
        -2750.961181640625,
        -4261.66796875,
        1105.03173828125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1147.9725341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21275591850280762,
        -0.7940161824226379,
        -0.5694498419761658
      ],
      "plane_d": -2159.841552734375,
      "bbox_min": [
        -2750.961181640625,
        -4261.66796875,
        1105.0318603515625
      ],
      "bbox_max": [
        -2714.73876953125,
        -4249.7685546875,
        1129.285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6481265425682068,
        -0.648120105266571,
        0.3998405635356903
      ],
      "plane_d": -1443.3369140625,
      "bbox_min": [
        -2719.46533203125,
        -4252.76513671875,
        1116.799072265625
      ],
      "bbox_max": [
        -2714.73876953125,
        -4249.7685546875,
        1129.285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5812633037567139,
        -0.5812574625015259,
        -0.5694496035575867
      ],
      "plane_d": -253.52349853515625,
      "bbox_min": [
        -2719.46533203125,
        -4252.76513671875,
        1116.799072265625
      ],
      "bbox_max": [
        -2714.73876953125,
        -4249.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24103493988513947,
        -0.8995543122291565,
        0.364285945892334
      ],
      "plane_d": -3570.03125,
      "bbox_min": [
        -2750.961181640625,
        -4255.21337890625,
        1105.0318603515625
      ],
      "bbox_max": [
        -2719.356201171875,
        -4249.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2684.974853515625,
        -4261.66796875,
        1105.03173828125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1145.650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9268820285797119,
        0.3753526508808136
      ],
      "plane_d": -4361.70703125,
      "bbox_min": [
        -2919.999755859375,
        -4270.7001953125,
        1101.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585177183151245,
        -0.6585177183151245,
        0.36429232358932495
      ],
      "plane_d": -1410.3582763671875,
      "bbox_min": [
        -2719.438720703125,
        -4251.033203125,
        1101.623779296875
      ],
      "bbox_max": [
        -2717.470703125,
        -4249.7685546875,
        1105.0968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6586298942565918,
        0.6586298942565918,
        0.36388659477233887
      ],
      "plane_d": 639.390625,
      "bbox_min": [
        -2680.242431640625,
        -4259.66796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2663.85009765625,
        -4259.66796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4250.8173828125,
        1112.62353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2691.27490234375,
        -4270.7001953125,
        1101.623779296875
      ],
      "bbox_max": [
        -2659.3955078125,
        -4255.21337890625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6586298942565918,
        0.6586298942565918,
        0.36388659477233887
      ],
      "plane_d": 639.390625,
      "bbox_min": [
        -2691.27490234375,
        -4270.7001953125,
        1101.623779296875
      ],
      "bbox_max": [
        -2669.71044921875,
        -4255.21337890625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5814270973205566,
        0.5814270973205566,
        -0.5691089630126953
      ],
      "plane_d": 1555.0584716796875,
      "bbox_min": [
        -2684.974853515625,
        -4265.732421875,
        1112.623779296875
      ],
      "bbox_max": [
        -2669.71044921875,
        -4255.21337890625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2750.961181640625,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5814270973205566,
        0.5814270973205566,
        -0.5691089630126953
      ],
      "plane_d": 1555.0584716796875,
      "bbox_min": [
        -2711.724853515625,
        -4288.103515625,
        1101.623779296875
      ],
      "bbox_max": [
        -2684.8994140625,
        -4268.1669921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6586298942565918,
        0.6586298942565918,
        0.36388659477233887
      ],
      "plane_d": 639.390625,
      "bbox_min": [
        -2711.724853515625,
        -4288.103515625,
        1101.623779296875
      ],
      "bbox_max": [
        -2684.8994140625,
        -4268.1669921875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24108071625232697,
        0.8997085690498352,
        0.36387449502944946
      ],
      "plane_d": 2799.443115234375,
      "bbox_min": [
        -2711.724853515625,
        -4288.103515625,
        1101.623779296875
      ],
      "bbox_max": [
        -2699.260986328125,
        -4280.91064453125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7892683148384094,
        0.45568564534187317,
        0.411590039730072
      ],
      "plane_d": -632.83740234375,
      "bbox_min": [
        -2656.4736328125,
        -4250.61962890625,
        1148.53466796875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.302978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.625
      ],
      "bbox_max": [
        -2687.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4559.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.625
      ],
      "bbox_max": [
        -2687.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2909.999755859375,
      "bbox_min": [
        -2919.999755859375,
        -4559.7685546875,
        1052.625
      ],
      "bbox_max": [
        -2703.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1072.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4014.522705078125,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4444.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": -3100.363525390625,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2899.999755859375,
        -4444.7685546875,
        1127.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -2847.9599609375,
      "bbox_min": [
        -2904.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2899.999755859375,
        -4499.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3835.11669921875,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.789697527885437,
        -0.6134963631629944,
        0.0
      ],
      "plane_d": 308.167724609375,
      "bbox_min": [
        -3784.999755859375,
        -4369.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4289.7998046875,
      "bbox_min": [
        -3722.8740234375,
        -4289.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700089693069458,
        -0.0,
        0.24306941032409668
      ],
      "plane_d": 3403.469482421875,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932385265827179,
        0.26299288868904114,
        0.24797670543193817
      ],
      "plane_d": 4451.162109375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.931310772895813,
        0.2715262770652771,
        0.24276229739189148
      ],
      "plane_d": 4492.71728515625,
      "bbox_min": [
        -3835.11669921875,
        -4668.23779296875,
        1102.623779296875
      ],
      "bbox_max": [
        -3750.459716796875,
        -4549.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9732754826545715,
        0.0,
        0.22964049875736237
      ],
      "plane_d": 3347.911865234375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7658141851425171,
        -0.594942033290863,
        0.2440749555826187
      ],
      "plane_d": 29.72479248046875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3729.92431640625,
        -4260.35546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1222.32177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3733.5146484375,
        -4260.80517578125,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1236.6832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1356099247932434,
        0.955426812171936,
        0.26223912835121155
      ],
      "plane_d": 4679.6083984375,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1350298374891281,
        0.9555009007453918,
        0.2622690796852112
      ],
      "plane_d": 4677.7451171875,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3747.18896484375,
        -4668.23779296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9751271605491638,
        0.22164621949195862
      ],
      "plane_d": -4427.49267578125,
      "bbox_min": [
        -3746.760498046875,
        -4289.7998046875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783878922462463,
        0.06522687524557114,
        0.1962204873561859
      ],
      "plane_d": 3718.708251953125,
      "bbox_min": [
        -3747.18896484375,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4723.5966796875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3736.77734375,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4829.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4679.7998046875,
      "bbox_min": [
        -3699.999755859375,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1302.6241455078125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3599.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3339.772216796875,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8292540311813354,
        0.5588719248771667,
        0.0
      ],
      "plane_d": 13.907958984375,
      "bbox_min": [
        -3243.922119140625,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555710792541504,
        -0.8314691185951233,
        -0.0
      ],
      "plane_d": -5637.83984375,
      "bbox_min": [
        -3170.900634765625,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3133.7236328125,
        -4739.90283203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7978267073631287,
        0.537691593170166,
        0.272691011428833
      ],
      "plane_d": 4645.59619140625,
      "bbox_min": [
        -3079.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9838698506355286,
        0.0,
        0.17888544499874115
      ],
      "plane_d": -3236.50634765625,
      "bbox_min": [
        -3079.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4239882528781891,
        0.8451507687568665,
        0.3255058228969574
      ],
      "plane_d": 4885.83447265625,
      "bbox_min": [
        -3079.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3727562129497528,
        -0.9278368353843689,
        0.013100594282150269
      ],
      "plane_d": -3274.530029296875,
      "bbox_min": [
        -3055.98583984375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4729.86767578125,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3323265016078949,
        -0.9431077241897583,
        0.010337146930396557
      ],
      "plane_d": -5497.1044921875,
      "bbox_min": [
        -3055.98583984375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4738.62744140625,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4239882528781891,
        0.8451507687568665,
        0.3255058228969574
      ],
      "plane_d": 2257.107666015625,
      "bbox_min": [
        -3133.7236328125,
        -4695.8544921875,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1179.4783935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9838699102401733,
        -0.0,
        0.17888544499874115
      ],
      "plane_d": 2863.486328125,
      "bbox_min": [
        -3124.88232421875,
        -4695.8544921875,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1179.4783935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3116.6005859375,
        -4721.17822265625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.874157190322876,
        0.0,
        -0.4856429100036621
      ],
      "plane_d": 3229.236083984375,
      "bbox_min": [
        -3116.6005859375,
        -4721.17822265625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4909895062446594,
        -0.87116539478302
      ],
      "plane_d": 3257.42919921875,
      "bbox_min": [
        -3116.6005859375,
        -4717.83740234375,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3116.6005859375,
        -4717.83740234375,
        1092.623779296875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8741673827171326,
        0.0,
        -0.48562484979629517
      ],
      "plane_d": -2189.454833984375,
      "bbox_min": [
        -3116.6005859375,
        -4701.46728515625,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555710792541504,
        -0.8314691185951233,
        0.0
      ],
      "plane_d": -2193.2998046875,
      "bbox_min": [
        -3170.900634765625,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4686.6845703125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3170.900634765625,
        -4739.90283203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3099.9990234375,
        -4686.6845703125,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7978267073631287,
        0.537691593170166,
        0.272691011428833
      ],
      "plane_d": -300.9292297363281,
      "bbox_min": [
        -3170.900634765625,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4686.6845703125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3727562129497528,
        -0.9278368353843689,
        0.013100594282150269
      ],
      "plane_d": -5585.61865234375,
      "bbox_min": [
        -3170.900634765625,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4686.6845703125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242666959762573,
        0.8449944257736206,
        0.32554891705513
      ],
      "plane_d": 2255.4482421875,
      "bbox_min": [
        -3145.921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4686.6845703125,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9838699102401733,
        -0.0,
        0.17888544499874115
      ],
      "plane_d": 2863.486328125,
      "bbox_min": [
        -3145.921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4692.59228515625,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3323265314102173,
        -0.9431077837944031,
        0.010334725491702557
      ],
      "plane_d": -3436.677978515625,
      "bbox_min": [
        -3145.921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3144.01171875,
        -4738.626953125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8741673827171326,
        0.0,
        -0.48562484979629517
      ],
      "plane_d": -2189.454833984375,
      "bbox_min": [
        -3116.6005859375,
        -4720.31103515625,
        1092.623779296875
      ],
      "bbox_max": [
        -3099.99951171875,
        -4698.1259765625,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3111.6005859375,
        -4716.97021484375,
        1092.623779296875
      ],
      "bbox_max": [
        -3099.99951171875,
        -4701.46728515625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3114.210205078125,
        -4739.90283203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4709.21826171875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3323265016078949,
        -0.9431077241897583,
        0.010337146930396557
      ],
      "plane_d": -5497.1044921875,
      "bbox_min": [
        -3079.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4722.58154296875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9838698506355286,
        0.0,
        0.17888544499874115
      ],
      "plane_d": -3236.50634765625,
      "bbox_min": [
        -3079.999755859375,
        -4733.689453125,
        1152.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4722.58154296875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3114.210205078125,
        -4730.02880859375,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4709.21826171875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3114.2099609375,
        -4730.02880859375,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4709.21875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8741673827171326,
        0.0,
        -0.48562484979629517
      ],
      "plane_d": -2189.454833984375,
      "bbox_min": [
        -3114.2099609375,
        -4719.63330078125,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4716.97021484375,
        1097.321044921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3323265314102173,
        -0.9431077837944031,
        0.010334725491702557
      ],
      "plane_d": -3436.677978515625,
      "bbox_min": [
        -3145.921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4722.58251953125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9838699102401733,
        -0.0,
        0.17888544499874115
      ],
      "plane_d": 2863.486328125,
      "bbox_min": [
        -3129.999755859375,
        -4733.689453125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4722.58251953125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3116.6005859375,
        -4729.57080078125,
        1092.623779296875
      ],
      "bbox_max": [
        -3100.000244140625,
        -4718.7138671875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3116.600341796875,
        -4729.5703125,
        1092.623779296875
      ],
      "bbox_max": [
        -3100.00048828125,
        -4718.7138671875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8741673827171326,
        0.0,
        -0.48562484979629517
      ],
      "plane_d": -2189.454833984375,
      "bbox_min": [
        -3116.600341796875,
        -4729.5703125,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4718.7138671875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3116.600341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4723.720703125,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8741673827171326,
        0.0,
        -0.48562484979629517
      ],
      "plane_d": -2189.454833984375,
      "bbox_min": [
        -3116.600341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4727.80859375,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8741573691368103,
        0.0,
        -0.4856429696083069
      ],
      "plane_d": 3229.236572265625,
      "bbox_min": [
        -3087.100341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4728.2666015625,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3243.922119140625,
        -4740.7734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3231.940185546875,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3600.0,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.541015625,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3600.0,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4854.802734375,
        1102.623779296875
      ],
      "bbox_max": [
        -3574.9658203125,
        -4829.7685546875,
        1202.759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3347.175537109375,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4919.7685546875,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -3319.999755859375,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1140.0
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1140.0
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1140.0
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3319.999755859375,
        -4932.2685546875,
        1140.0
      ],
      "bbox_max": [
        -3289.445068359375,
        -4929.11279296875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3319.999755859375,
        -4980.90283203125,
        1140.0
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3290.547119140625,
        -4932.2685546875,
        1140.0
      ],
      "bbox_max": [
        -3274.022705078125,
        -4929.11279296875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -3319.999755859375,
        -4980.90283203125,
        1140.0
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2925.976806640625,
        -4932.2685546875,
        1140.0
      ],
      "bbox_max": [
        -2920.0,
        -4929.11279296875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 2056.304443359375,
      "bbox_min": [
        -3319.999755859375,
        -4965.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3319.999755859375,
        -4965.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 5852.33740234375,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 5390.181640625,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 235.0537109375,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": 4104.474609375,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": -1976.3916015625,
      "bbox_min": [
        -3145.921875,
        -4965.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3145.921875,
        -4965.7685546875,
        1140.0
      ],
      "bbox_max": [
        -3054.07763671875,
        -4965.7685546875,
        1152.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": 0.334716796875,
      "bbox_min": [
        -3219.999755859375,
        -4850.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        -0.5555662512779236,
        -0.0
      ],
      "plane_d": -5154.79296875,
      "bbox_min": [
        -3219.999755859375,
        -4850.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807850122451782,
        -0.19509224593639374,
        -0.0
      ],
      "plane_d": -3869.08642578125,
      "bbox_min": [
        -3219.999755859375,
        -4850.7685546875,
        1140.0
      ],
      "bbox_max": [
        -2979.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555710792541504,
        -0.8314691185951233,
        0.0
      ],
      "plane_d": -2193.2998046875,
      "bbox_min": [
        -3219.999755859375,
        -4850.7685546875,
        1140.0
      ],
      "bbox_max": [
        -3015.14697265625,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555710792541504,
        -0.8314691185951233,
        -0.0
      ],
      "plane_d": -5637.83984375,
      "bbox_min": [
        -3219.999755859375,
        -4850.7685546875,
        1140.0
      ],
      "bbox_max": [
        -3015.14697265625,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807848930358887,
        -0.19509220123291016,
        -9.289935292144946e-07
      ],
      "plane_d": 2211.781005859375,
      "bbox_min": [
        -3219.999755859375,
        -4850.7685546875,
        1140.0
      ],
      "bbox_max": [
        -3210.865234375,
        -4804.8466796875,
        1152.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5219.0,
      "bbox_min": [
        -3319.999755859375,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4976.0,
      "bbox_min": [
        -3319.999755859375,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.8741573691368103,
        0.0,
        -0.4856429696083069
      ],
      "plane_d": 3229.236572265625,
      "bbox_min": [
        -3319.999755859375,
        -4976.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3319.999755859375,
        -4976.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8741573691368103,
        1.5244095266098157e-06,
        -0.4856429696083069
      ],
      "plane_d": -2189.39599609375,
      "bbox_min": [
        -3319.999755859375,
        -4976.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4740.537109375,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3116.600830078125,
        -4976.0,
        1070.57373046875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4740.6494140625,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.000656990276183933,
        0.9999998807907104
      ],
      "plane_d": -1104.8690185546875,
      "bbox_min": [
        -3116.600830078125,
        -4976.0,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4934.7685546875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.5999755859375,
      "bbox_min": [
        -3116.6005859375,
        -4976.0,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4934.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4939.7685546875,
      "bbox_min": [
        -3116.587646484375,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.113525390625,
        -4939.7685546875,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3116.587646484375,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.113525390625,
        -4965.7685546875,
        1101.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3085.73388671875,
      "bbox_min": [
        -3116.6005859375,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3082.100341796875,
        -4934.7685546875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4939.76806640625,
      "bbox_min": [
        -3085.73388671875,
        -4965.7685546875,
        1101.5999755859375
      ],
      "bbox_max": [
        -3082.100341796875,
        -4939.7685546875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3085.73388671875,
        -4965.7685546875,
        1101.5999755859375
      ],
      "bbox_max": [
        -3082.10986328125,
        -4965.7685546875,
        1101.606689453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3116.59130859375,
        -4965.7685546875,
        1101.5999755859375
      ],
      "bbox_max": [
        -3085.73388671875,
        -4965.7685546875,
        1101.606689453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3114.265625,
      "bbox_min": [
        -3116.600830078125,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3114.265625,
        -4939.7685546875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3111.6005859375,
        -4769.7685546875,
        1070.573974609375
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3100.489013671875,
        -4769.7685546875,
        1070.573974609375
      ],
      "bbox_max": [
        -3098.21142578125,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3111.600341796875,
        -4965.7685546875,
        1070.57373046875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4789.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4789.7685546875,
      "bbox_min": [
        -3100.489013671875,
        -4789.7685546875,
        1070.573974609375
      ],
      "bbox_max": [
        -3098.21142578125,
        -4789.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3319.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3099.350341796875,
        -4740.537109375,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 5852.33740234375,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3099.350341796875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 5390.181640625,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3099.350341796875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": 4104.474609375,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3099.350341796875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555710792541504,
        -0.8314691185951233,
        0.0
      ],
      "plane_d": -2193.2998046875,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3099.350341796875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807846546173096,
        -0.1950935274362564,
        3.671312470032717e-06
      ],
      "plane_d": 2211.76904296875,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4879.7685546875,
      "bbox_min": [
        -3137.999755859375,
        -4949.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3100.907958984375,
        -4859.7685546875,
        1067.76953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3137.999755859375,
        -4879.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3102.194580078125,
        -4859.7685546875,
        1065.4539794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3137.999755859375,
        -4859.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3102.194580078125,
        -4859.7685546875,
        1065.4539794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23462752997875214,
        -0.048543624579906464,
        -0.9708725214004517
      ],
      "plane_d": 1522.31396484375,
      "bbox_min": [
        -3137.999755859375,
        -4870.9296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3104.516845703125,
        -4859.7685546875,
        1061.2734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3137.999755859375,
        -4859.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3104.516845703125,
        -4859.7685546875,
        1061.2734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23462752997875214,
        -0.04854360595345497,
        -0.9708725214004517
      ],
      "plane_d": 66.652587890625,
      "bbox_min": [
        -3137.99951171875,
        -4949.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3100.908203125,
        -4879.7685546875,
        1067.7694091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33401644229888916,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": 723.85986328125,
      "bbox_min": [
        -3108.204833984375,
        -4899.7685546875,
        1063.588134765625
      ],
      "bbox_max": [
        -3100.908203125,
        -4879.7685546875,
        1067.7694091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": 992.184326171875,
      "bbox_min": [
        -3137.99951171875,
        -4949.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4929.7685546875,
        1059.9736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5752.28564453125,
      "bbox_min": [
        -3137.99951171875,
        -4949.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1058.7777099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -3375.313232421875,
      "bbox_min": [
        -3137.99951171875,
        -4949.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1058.7777099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3356.835693359375,
      "bbox_min": [
        -3137.99951171875,
        -4949.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3129.999755859375,
        -4929.7685546875,
        1055.890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -5770.763671875,
      "bbox_min": [
        -3137.99951171875,
        -4949.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3129.999755859375,
        -4932.697265625,
        1055.890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -1010.661865234375,
      "bbox_min": [
        -3137.99951171875,
        -4946.83984375,
        1052.623779296875
      ],
      "bbox_max": [
        -3137.07080078125,
        -4932.697265625,
        1053.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4791.3212890625,
      "bbox_min": [
        -3137.99951171875,
        -4946.83984375,
        1052.623779296875
      ],
      "bbox_max": [
        -3137.07080078125,
        -4944.59765625,
        1053.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3108.5498046875,
        -4899.7685546875,
        1063.314453125
      ],
      "bbox_max": [
        -3103.231201171875,
        -4893.56298828125,
        1064.7900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4899.76806640625,
      "bbox_min": [
        -3108.5498046875,
        -4899.7685546875,
        1063.314453125
      ],
      "bbox_max": [
        -3103.231201171875,
        -4899.7685546875,
        1064.7900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3106.600341796875,
      "bbox_min": [
        -3106.600341796875,
        -4789.7685546875,
        1057.5238037109375
      ],
      "bbox_max": [
        -3100.908447265625,
        -4769.7685546875,
        1067.769287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3106.600341796875,
        -4789.7685546875,
        1057.5238037109375
      ],
      "bbox_max": [
        -3100.908447265625,
        -4769.7685546875,
        1067.769287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4791.3212890625,
      "bbox_min": [
        -3139.999755859375,
        -4949.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4929.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -1010.661865234375,
      "bbox_min": [
        -3139.999755859375,
        -4949.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4929.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -5770.763671875,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1053.0030517578125
      ],
      "bbox_max": [
        -3119.999755859375,
        -4929.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5752.28564453125,
      "bbox_min": [
        -3129.999755859375,
        -4949.7685546875,
        1055.890380859375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4929.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -3375.313232421875,
      "bbox_min": [
        -3129.999755859375,
        -4949.7685546875,
        1055.890380859375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4932.697265625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        0.38267579674720764,
        -0.0
      ],
      "plane_d": 4772.84375,
      "bbox_min": [
        -3122.9287109375,
        -4946.83984375,
        1058.7777099609375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4932.697265625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": 992.184326171875,
      "bbox_min": [
        -3122.9287109375,
        -4946.83984375,
        1058.7777099609375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4939.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1962762027978897,
        0.09117655456066132,
        -0.9763004183769226
      ],
      "plane_d": 871.4920043945312,
      "bbox_min": [
        -3213.928955078125,
        -4899.7685546875,
        1064.161865234375
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14150792360305786,
        -0.04840825870633125,
        -0.9887527823448181
      ],
      "plane_d": 377.13336181640625,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.161865234375
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17693176865577698,
        -0.033184535801410675,
        -0.9836634993553162
      ],
      "plane_d": 334.79840087890625,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1065.071533203125
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17616158723831177,
        0.03705311939120293,
        -0.9836636781692505
      ],
      "plane_d": 680.149658203125,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1065.071533203125
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1758042424917221,
        0.038869597017765045,
        -0.9836574792861938
      ],
      "plane_d": 690.1115112304688,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1065.071533203125
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509725272655487,
        -0.9807839393615723,
        -0.0
      ],
      "plane_d": -5414.7080078125,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1065.071533203125
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314690589904785,
        -0.5555711388587952,
        -0.0
      ],
      "plane_d": -5343.529296875,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1065.071533203125
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15917500853538513,
        0.14545495808124542,
        0.9764764308929443
      ],
      "plane_d": 157.85400390625,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1065.071533203125
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33401644229888916,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": 723.85986328125,
      "bbox_min": [
        -3180.083984375,
        -4899.7685546875,
        1065.071533203125
      ],
      "bbox_max": [
        -3100.572265625,
        -4847.80224609375,
        1081.421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555662512779236,
        -0.8314722776412964,
        -0.0
      ],
      "plane_d": -5817.4580078125,
      "bbox_min": [
        -3180.083984375,
        -4899.7685546875,
        1065.071533203125
      ],
      "bbox_max": [
        -3100.572265625,
        -4847.80224609375,
        1081.421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4899.76806640625,
      "bbox_min": [
        -3180.083984375,
        -4899.7685546875,
        1065.071533203125
      ],
      "bbox_max": [
        -3100.572265625,
        -4847.80224609375,
        1080.6424560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        -0.19508720934391022,
        -0.0
      ],
      "plane_d": -4065.03759765625,
      "bbox_min": [
        -3180.083984375,
        -4862.7294921875,
        1077.311279296875
      ],
      "bbox_max": [
        -3177.4326171875,
        -4849.39990234375,
        1080.6424560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509625434875488,
        0.9807841777801514,
        -0.0
      ],
      "plane_d": 5395.08984375,
      "bbox_min": [
        -3169.90478515625,
        -4879.7685546875,
        1067.14453125
      ],
      "bbox_max": [
        -3121.999755859375,
        -4847.80224609375,
        1077.19189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14628201723098755,
        0.16601243615150452,
        -0.9752134680747986
      ],
      "plane_d": 1391.5875244140625,
      "bbox_min": [
        -3169.90478515625,
        -4855.07568359375,
        1074.311279296875
      ],
      "bbox_max": [
        -3158.954833984375,
        -4847.80224609375,
        1077.19189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14628201723098755,
        0.16601243615150452,
        -0.9752134680747986
      ],
      "plane_d": 1391.5875244140625,
      "bbox_min": [
        -3163.64404296875,
        -4855.07568359375,
        1074.311279296875
      ],
      "bbox_max": [
        -3158.954833984375,
        -4848.0576171875,
        1076.4903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3160.323974609375,
        -4855.07568359375,
        1074.311279296875
      ],
      "bbox_max": [
        -3158.954833984375,
        -4848.19287109375,
        1076.4903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701396822929382,
        0.0,
        -0.24254676699638367
      ],
      "plane_d": -2753.6748046875,
      "bbox_min": [
        -3181.999755859375,
        -4895.201171875,
        1068.64306640625
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -3804.4072265625,
      "bbox_min": [
        -3109.1005859375,
        -4794.7685546875,
        1068.64306640625
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3109.1005859375,
        -4769.7685546875,
        1070.3232421875
      ],
      "bbox_max": [
        -3099.350341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3106.600341796875,
        -4769.7685546875,
        1070.3232421875
      ],
      "bbox_max": [
        -3099.350341796875,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4789.7685546875,
      "bbox_min": [
        -3106.600341796875,
        -4789.7685546875,
        1068.64306640625
      ],
      "bbox_max": [
        -3099.350341796875,
        -4789.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14644506573677063,
        0.15934692323207855,
        -0.9763004183769226
      ],
      "plane_d": 1359.9833984375,
      "bbox_min": [
        -3181.999755859375,
        -4895.201171875,
        1069.7401123046875
      ],
      "bbox_max": [
        -3105.87939453125,
        -4769.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07161380350589752,
        0.2093566656112671,
        -0.9752134084701538
      ],
      "plane_d": 1837.46435546875,
      "bbox_min": [
        -3181.999755859375,
        -4895.201171875,
        1075.7105712890625
      ],
      "bbox_max": [
        -3137.30712890625,
        -4818.85400390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555662512779236,
        -0.8314722776412964,
        -0.0
      ],
      "plane_d": -5817.4580078125,
      "bbox_min": [
        -3181.999755859375,
        -4895.201171875,
        1075.7105712890625
      ],
      "bbox_max": [
        -3137.30712890625,
        -4818.85400390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        -0.19508720934391022,
        -0.0
      ],
      "plane_d": -4065.03759765625,
      "bbox_min": [
        -3181.999755859375,
        -4876.7236328125,
        1075.7105712890625
      ],
      "bbox_max": [
        -3137.30712890625,
        -4833.06640625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        0.19508720934391022,
        0.0
      ],
      "plane_d": -2176.68359375,
      "bbox_min": [
        -3181.999755859375,
        -4839.7685546875,
        1080.373779296875
      ],
      "bbox_max": [
        -3180.666748046875,
        -4833.06640625,
        1082.3773193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        0.8314674496650696,
        -0.0
      ],
      "plane_d": 5797.841796875,
      "bbox_min": [
        -3161.999755859375,
        -4876.7236328125,
        1075.7105712890625
      ],
      "bbox_max": [
        -3137.30712890625,
        -4839.021484375,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3161.999755859375,
        -4855.07568359375,
        1075.7105712890625
      ],
      "bbox_max": [
        -3158.954833984375,
        -4839.021484375,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": 2157.001953125,
      "bbox_min": [
        -3161.999755859375,
        -4839.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3161.85107421875,
        -4839.021484375,
        1077.64697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24678322672843933,
        0.027199994772672653,
        0.9686889052391052
      ],
      "plane_d": -135.60809326171875,
      "bbox_min": [
        -3181.999755859375,
        -4881.71044921875,
        1076.186279296875
      ],
      "bbox_max": [
        -3137.30712890625,
        -4818.85400390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        0.8314674496650696,
        -0.0
      ],
      "plane_d": 5797.841796875,
      "bbox_min": [
        -3181.999755859375,
        -4876.7236328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3137.30712890625,
        -4818.875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": 2157.001953125,
      "bbox_min": [
        -3172.42822265625,
        -4855.07568359375,
        1077.5233154296875
      ],
      "bbox_max": [
        -3158.954833984375,
        -4818.875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0005590629298239946,
        0.36375975608825684,
        -0.9314926862716675
      ],
      "plane_d": 2759.59716796875,
      "bbox_min": [
        -3172.42822265625,
        -4823.4228515625,
        1080.84326171875
      ],
      "bbox_max": [
        -3161.4619140625,
        -4818.875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25508740544319153,
        0.018345549702644348,
        0.9667438864707947
      ],
      "plane_d": -150.4522705078125,
      "bbox_min": [
        -3163.80517578125,
        -4879.9853515625,
        1079.248779296875
      ],
      "bbox_max": [
        -3150.283935546875,
        -4850.93994140625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25476783514022827,
        0.01656128093600273,
        0.9668603539466858
      ],
      "plane_d": -160.2706298828125,
      "bbox_min": [
        -3163.80517578125,
        -4868.052734375,
        1079.248779296875
      ],
      "bbox_max": [
        -3150.283935546875,
        -4850.93994140625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2875499427318573,
        -0.07020564377307892,
        0.9551891088485718
      ],
      "plane_d": -465.35321044921875,
      "bbox_min": [
        -3163.80517578125,
        -4857.0849609375,
        1081.311279296875
      ],
      "bbox_max": [
        -3158.954833984375,
        -4850.93994140625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23999640345573425,
        -0.14432397484779358,
        0.959985613822937
      ],
      "plane_d": -980.6093139648438,
      "bbox_min": [
        -3162.706298828125,
        -4855.07568359375,
        1081.311279296875
      ],
      "bbox_max": [
        -3158.954833984375,
        -4850.93994140625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": 2157.001953125,
      "bbox_min": [
        -3168.95166015625,
        -4855.07568359375,
        1080.291015625
      ],
      "bbox_max": [
        -3155.208251953125,
        -4818.85400390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0005590629298239946,
        0.36375975608825684,
        -0.9314926862716675
      ],
      "plane_d": 2759.59716796875,
      "bbox_min": [
        -3168.95166015625,
        -4824.46142578125,
        1080.436279296875
      ],
      "bbox_max": [
        -3157.840087890625,
        -4818.85791015625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3161.999755859375,
        -4855.07568359375,
        1080.436279296875
      ],
      "bbox_max": [
        -3155.208251953125,
        -4818.85400390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23999640345573425,
        -0.14432397484779358,
        0.959985613822937
      ],
      "plane_d": -980.6093139648438,
      "bbox_min": [
        -3161.7177734375,
        -4855.07568359375,
        1081.311279296875
      ],
      "bbox_max": [
        -3158.954833984375,
        -4848.515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -53.724609375,
      "bbox_min": [
        -3158.954833984375,
        -4824.46142578125,
        1080.436279296875
      ],
      "bbox_max": [
        -3155.208251953125,
        -4818.85400390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0005590629298239946,
        0.36375975608825684,
        -0.9314926862716675
      ],
      "plane_d": 2759.59716796875,
      "bbox_min": [
        -3158.954833984375,
        -4824.46142578125,
        1080.436279296875
      ],
      "bbox_max": [
        -3155.208251953125,
        -4818.85400390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3106.600341796875,
      "bbox_min": [
        -3181.999755859375,
        -4848.38427734375,
        1069.7401123046875
      ],
      "bbox_max": [
        -3105.87939453125,
        -4769.7685546875,
        1080.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4789.7685546875,
      "bbox_min": [
        -3106.600341796875,
        -4789.7685546875,
        1069.7401123046875
      ],
      "bbox_max": [
        -3105.87939453125,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3106.600341796875,
        -4769.7685546875,
        1071.706787109375
      ],
      "bbox_max": [
        -3106.37109375,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14628201723098755,
        0.16601243615150452,
        -0.9752134680747986
      ],
      "plane_d": 1391.5875244140625,
      "bbox_min": [
        -3181.999755859375,
        -4848.38427734375,
        1075.688232421875
      ],
      "bbox_max": [
        -3160.285888671875,
        -4839.7685546875,
        1080.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3161.999755859375,
        -4848.38427734375,
        1075.688232421875
      ],
      "bbox_max": [
        -3160.285888671875,
        -4839.7685546875,
        1077.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1940375715494156,
        0.0555294007062912,
        -0.9794212579727173
      ],
      "plane_d": 709.2298583984375,
      "bbox_min": [
        -3164.42626953125,
        -4882.19482421875,
        1068.1536865234375
      ],
      "bbox_max": [
        -3129.5654296875,
        -4868.052734375,
        1074.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        0.8314674496650696,
        -0.0
      ],
      "plane_d": 5797.841796875,
      "bbox_min": [
        -3150.283935546875,
        -4878.263671875,
        1068.1536865234375
      ],
      "bbox_max": [
        -3129.5654296875,
        -4868.052734375,
        1072.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509625434875488,
        0.9807841777801514,
        -0.0
      ],
      "plane_d": 5395.08984375,
      "bbox_min": [
        -3137.30712890625,
        -4878.263671875,
        1068.1536865234375
      ],
      "bbox_max": [
        -3129.5654296875,
        -4876.7236328125,
        1069.59814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.143018901348114,
        -0.04942425712943077,
        -0.9884851574897766
      ],
      "plane_d": 367.152099609375,
      "bbox_min": [
        -3137.30712890625,
        -4899.7685546875,
        1064.161865234375
      ],
      "bbox_max": [
        -3105.739501953125,
        -4876.7236328125,
        1069.186279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4899.76806640625,
      "bbox_min": [
        -3137.30712890625,
        -4899.7685546875,
        1065.0394287109375
      ],
      "bbox_max": [
        -3105.739501953125,
        -4876.7236328125,
        1069.186279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4879.7685546875,
        1065.0394287109375
      ],
      "bbox_max": [
        -3107.515380859375,
        -4879.7685546875,
        1067.14453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4879.7685546875,
        1064.161865234375
      ],
      "bbox_max": [
        -3107.593994140625,
        -4879.7685546875,
        1067.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3121.999755859375,
        -4899.7685546875,
        1064.649169921875
      ],
      "bbox_max": [
        -3108.204833984375,
        -4895.28515625,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4899.76806640625,
      "bbox_min": [
        -3121.999755859375,
        -4899.7685546875,
        1064.649169921875
      ],
      "bbox_max": [
        -3108.204833984375,
        -4899.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3106.600341796875,
      "bbox_min": [
        -3213.928955078125,
        -4823.02880859375,
        1065.445068359375
      ],
      "bbox_max": [
        -3099.489501953125,
        -4769.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3106.600341796875,
        -4789.7685546875,
        1065.445068359375
      ],
      "bbox_max": [
        -3099.489501953125,
        -4769.7685546875,
        1071.7528076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4789.7685546875,
      "bbox_min": [
        -3106.600341796875,
        -4789.7685546875,
        1065.445068359375
      ],
      "bbox_max": [
        -3100.423095703125,
        -4789.7685546875,
        1069.885009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1081.1998291015625,
      "bbox_min": [
        -3213.928955078125,
        -4823.02880859375,
        1081.199951171875
      ],
      "bbox_max": [
        -3206.739501953125,
        -4808.85498046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807847142219543,
        -0.1950935274362564,
        0.0
      ],
      "plane_d": 2206.40234375,
      "bbox_min": [
        -3213.928955078125,
        -4823.02880859375,
        1081.199951171875
      ],
      "bbox_max": [
        -3206.739501953125,
        -4808.85498046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4917427897453308,
        0.870740532875061,
        -0.0
      ],
      "plane_d": 5766.5771484375,
      "bbox_min": [
        -3213.928955078125,
        -4823.02880859375,
        1081.199951171875
      ],
      "bbox_max": [
        -3206.739501953125,
        -4808.85498046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4917427897453308,
        -0.870740532875061,
        -0.0
      ],
      "plane_d": -5777.61181640625,
      "bbox_min": [
        -3213.928955078125,
        -4823.02880859375,
        1081.199951171875
      ],
      "bbox_max": [
        -3209.005859375,
        -4820.24853515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1484331339597702,
        -0.06927737593650818,
        -0.9864928722381592
      ],
      "plane_d": 1233.1123046875,
      "bbox_min": [
        -3319.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4740.537109375,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1425086259841919,
        -0.06312164664268494,
        -0.9877788424491882
      ],
      "plane_d": 1244.798095703125,
      "bbox_min": [
        -3314.85302734375,
        -4850.7685546875,
        1091.927978515625
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4850.7685546875,
      "bbox_min": [
        -3314.85302734375,
        -4850.7685546875,
        1091.987060546875
      ],
      "bbox_max": [
        -3275.146484375,
        -4850.7685546875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9061561822891235,
        0.42292529344558716,
        -0.003878816729411483
      ],
      "plane_d": -907.3564453125,
      "bbox_min": [
        -3319.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4740.537109375,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 5852.33740234375,
      "bbox_min": [
        -3246.87841796875,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4740.537109375,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": 0.334716796875,
      "bbox_min": [
        -3246.87841796875,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4740.537109375,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999457597732544,
        -0.8660286068916321,
        0.0
      ],
      "plane_d": -5770.419921875,
      "bbox_min": [
        -3246.87841796875,
        -4817.24169921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3213.019775390625,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9153205752372742,
        0.40272602438926697,
        0.0
      ],
      "plane_d": -1038.0235595703125,
      "bbox_min": [
        -3242.2041015625,
        -4791.263671875,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9029519557952881,
        0.42863431572914124,
        -0.030828554183244705
      ],
      "plane_d": -840.0320434570312,
      "bbox_min": [
        -3246.87841796875,
        -4801.26220703125,
        1095.0
      ],
      "bbox_max": [
        -3242.132080078125,
        -4791.22216796875,
        1097.6827392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4992690682411194,
        0.8664470314979553,
        0.0
      ],
      "plane_d": 5781.10546875,
      "bbox_min": [
        -3246.87841796875,
        -4817.24169921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3219.147216796875,
        -4801.26220703125,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807852506637573,
        -0.19509004056453705,
        0.0
      ],
      "plane_d": 2211.79150390625,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1094.9998779296875,
      "bbox_min": [
        -3219.147216796875,
        -4820.24853515625,
        1095.0
      ],
      "bbox_max": [
        -3211.66259765625,
        -4808.0712890625,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701396822929382,
        0.0,
        -0.24254676699638367
      ],
      "plane_d": -2753.6748046875,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -3804.4072265625,
      "bbox_min": [
        -3111.6005859375,
        -4799.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3111.6005859375,
        -4764.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.051469944417476654,
        0.1215628981590271,
        -0.9912483096122742
      ],
      "plane_d": 1823.041748046875,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06524178385734558,
        0.13515299558639526,
        -0.9886744618415833
      ],
      "plane_d": 1929.0216064453125,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555662512779236,
        0.8314722776412964,
        0.0
      ],
      "plane_d": 2230.80859375,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509725272655487,
        0.9807839393615723,
        0.0
      ],
      "plane_d": 4078.82666015625,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314690589904785,
        0.5555711388587952,
        0.0
      ],
      "plane_d": 34.142333984375,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        -0.19508720934391022,
        -0.0
      ],
      "plane_d": -4065.03759765625,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23699171841144562,
        0.09816411882638931,
        -0.9665395617485046
      ],
      "plane_d": 2268.083740234375,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23879718780517578,
        -0.17490077018737793,
        0.9551887512207031
      ],
      "plane_d": -1127.1842041015625,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        0.19508720934391022,
        0.0
      ],
      "plane_d": -2176.68359375,
      "bbox_min": [
        -3181.999755859375,
        -4866.73876953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3147.731201171875,
        -4809.77880859375,
        1092.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -53.724609375,
      "bbox_min": [
        -3177.4326171875,
        -4866.73876953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3147.731201171875,
        -4809.77880859375,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314690589904785,
        -0.5555711388587952,
        -0.0
      ],
      "plane_d": -5343.529296875,
      "bbox_min": [
        -3177.4326171875,
        -4866.73876953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3174.753662109375,
        -4862.7294921875,
        1084.027587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3161.999755859375,
        -4847.28466796875,
        1082.623779296875
      ],
      "bbox_max": [
        -3147.731201171875,
        -4809.77880859375,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -2250.378173828125,
      "bbox_min": [
        -3150.283935546875,
        -4811.484375,
        1085.498779296875
      ],
      "bbox_max": [
        -3147.731201171875,
        -4809.77880859375,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16649271547794342,
        -0.22518348693847656,
        0.959985613822937
      ],
      "plane_d": -1604.3692626953125,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": 2157.001953125,
      "bbox_min": [
        -3161.999755859375,
        -4839.7685546875,
        1084.373779296875
      ],
      "bbox_max": [
        -3139.737548828125,
        -4804.4375,
        1088.9765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -53.724609375,
      "bbox_min": [
        -3158.954833984375,
        -4824.46142578125,
        1086.2979736328125
      ],
      "bbox_max": [
        -3139.737548828125,
        -4804.4375,
        1088.9765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -2250.378173828125,
      "bbox_min": [
        -3150.283935546875,
        -4811.484375,
        1086.2979736328125
      ],
      "bbox_max": [
        -3139.737548828125,
        -4804.4375,
        1088.9765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2875499427318573,
        -0.07020564377307892,
        0.9551891088485718
      ],
      "plane_d": -465.35321044921875,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.009122781455516815,
        -0.2162281721830368,
        0.9763002991676331
      ],
      "plane_d": -2135.724609375,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07770257443189621,
        -0.4069710969924927,
        0.9101300835609436
      ],
      "plane_d": -2707.666015625,
      "bbox_min": [
        -3170.151611328125,
        -4852.583984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3114.329345703125,
        -4779.7685546875,
        1099.846923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4779.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4779.7685546875,
        1095.6551513671875
      ],
      "bbox_max": [
        -3114.329345703125,
        -4779.7685546875,
        1099.846923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -2250.378173828125,
      "bbox_min": [
        -3150.283935546875,
        -4811.484375,
        1088.8004150390625
      ],
      "bbox_max": [
        -3116.85986328125,
        -4799.7685546875,
        1095.322998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3161.999755859375,
        -4848.515625,
        1082.623779296875
      ],
      "bbox_max": [
        -3160.259765625,
        -4839.7685546875,
        1084.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4799.7685546875,
      "bbox_min": [
        -3122.699462890625,
        -4799.90771484375,
        1094.884033203125
      ],
      "bbox_max": [
        -3114.647705078125,
        -4799.7685546875,
        1095.4263916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950962394475937,
        -0.9807841181755066,
        0.0
      ],
      "plane_d": -4098.4462890625,
      "bbox_min": [
        -3122.699462890625,
        -4799.90771484375,
        1095.3203125
      ],
      "bbox_max": [
        -3121.999755859375,
        -4799.7685546875,
        1095.357666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07770257443189621,
        -0.4069710969924927,
        0.9101300835609436
      ],
      "plane_d": -2707.666015625,
      "bbox_min": [
        -3177.83642578125,
        -4868.89794921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3150.283935546875,
        -4811.484375,
        1092.498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25476783514022827,
        0.01656128093600273,
        0.9668603539466858
      ],
      "plane_d": -160.2706298828125,
      "bbox_min": [
        -3170.67626953125,
        -4868.89794921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3163.013916015625,
        -4857.0849609375,
        1084.4830322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25508740544319153,
        0.018345549702644348,
        0.9667438864707947
      ],
      "plane_d": -150.4522705078125,
      "bbox_min": [
        -3166.46142578125,
        -4868.89794921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3163.013916015625,
        -4864.880859375,
        1083.4571533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1822548806667328,
        -0.1801173835992813,
        0.9666131138801575
      ],
      "plane_d": -2496.810302734375,
      "bbox_min": [
        -3170.67626953125,
        -4877.94921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3113.336181640625,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -2250.378173828125,
      "bbox_min": [
        -3150.283935546875,
        -4811.484375,
        1092.498779296875
      ],
      "bbox_max": [
        -3113.336181640625,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4779.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4779.7685546875,
        1099.7872314453125
      ],
      "bbox_max": [
        -3115.61328125,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25508740544319153,
        0.018345549702644348,
        0.9667438864707947
      ],
      "plane_d": -150.4522705078125,
      "bbox_min": [
        -3170.67626953125,
        -4877.94921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3162.363037109375,
        -4859.93115234375,
        1084.4830322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25476783514022827,
        0.01656128093600273,
        0.9668603539466858
      ],
      "plane_d": -160.2706298828125,
      "bbox_min": [
        -3170.67626953125,
        -4864.880859375,
        1083.4571533203125
      ],
      "bbox_max": [
        -3166.46142578125,
        -4859.93115234375,
        1084.4830322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3122.9287109375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4932.697265625,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        0.38267579674720764,
        -0.0
      ],
      "plane_d": 4772.84375,
      "bbox_min": [
        -3122.9287109375,
        -4946.83984375,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4932.697265625,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": 992.184326171875,
      "bbox_min": [
        -3122.9287109375,
        -4946.83984375,
        1092.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4939.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4939.7685546875,
      "bbox_min": [
        -3119.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4939.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        0.38267579674720764,
        -0.0
      ],
      "plane_d": 4772.84375,
      "bbox_min": [
        -3122.9287109375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4932.697265625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": 992.184326171875,
      "bbox_min": [
        -3122.9287109375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4791.3212890625,
      "bbox_min": [
        -3139.999755859375,
        -4949.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3356.835693359375,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5752.28564453125,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -5770.763671875,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4946.83984375,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -3375.313232421875,
      "bbox_min": [
        -3129.999755859375,
        -4949.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4946.83984375,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31399640440940857,
        0.0,
        0.949424147605896
      ],
      "plane_d": -2026.2049560546875,
      "bbox_min": [
        -3181.999755859375,
        -4884.84912109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3115.306396484375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950962394475937,
        -0.9807841181755066,
        0.0
      ],
      "plane_d": -4098.4462890625,
      "bbox_min": [
        -3173.36083984375,
        -4884.84912109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3115.306396484375,
        -4799.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555662512779236,
        -0.8314722776412964,
        -0.0
      ],
      "plane_d": -5817.4580078125,
      "bbox_min": [
        -3164.42626953125,
        -4883.857421875,
        1082.623779296875
      ],
      "bbox_max": [
        -3161.938232421875,
        -4882.19482421875,
        1083.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4799.7685546875,
      "bbox_min": [
        -3172.40966796875,
        -4884.84912109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3115.306396484375,
        -4799.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25476783514022827,
        0.01656128093600273,
        0.9668603539466858
      ],
      "plane_d": -160.2706298828125,
      "bbox_min": [
        -3172.40966796875,
        -4884.84912109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3160.45361328125,
        -4859.93115234375,
        1084.9814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2286498099565506,
        0.11457083374261856,
        0.9667434096336365
      ],
      "plane_d": 235.678955078125,
      "bbox_min": [
        -3164.42626953125,
        -4884.84912109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3160.45361328125,
        -4879.9853515625,
        1083.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555662512779236,
        -0.8314722776412964,
        -0.0
      ],
      "plane_d": -5817.4580078125,
      "bbox_min": [
        -3164.42626953125,
        -4884.84912109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3160.45361328125,
        -4882.19482421875,
        1083.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24678322672843933,
        0.027199994772672653,
        0.9686889052391052
      ],
      "plane_d": -135.60809326171875,
      "bbox_min": [
        -3164.42626953125,
        -4882.19482421875,
        1082.623779296875
      ],
      "bbox_max": [
        -3162.0263671875,
        -4879.9853515625,
        1083.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25508740544319153,
        0.018345549702644348,
        0.9667438864707947
      ],
      "plane_d": -150.4522705078125,
      "bbox_min": [
        -3181.999755859375,
        -4870.71337890625,
        1084.6375732421875
      ],
      "bbox_max": [
        -3172.09814453125,
        -4839.7685546875,
        1089.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314690589904785,
        -0.5555711388587952,
        -0.0
      ],
      "plane_d": -5343.529296875,
      "bbox_min": [
        -3177.4326171875,
        -4870.71337890625,
        1084.6375732421875
      ],
      "bbox_max": [
        -3172.09814453125,
        -4862.7294921875,
        1086.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25476783514022827,
        0.01656128093600273,
        0.9668603539466858
      ],
      "plane_d": -160.2706298828125,
      "bbox_min": [
        -3181.999755859375,
        -4863.73193359375,
        1084.9521484375
      ],
      "bbox_max": [
        -3172.321044921875,
        -4839.7685546875,
        1089.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23999640345573425,
        -0.14432397484779358,
        0.959985613822937
      ],
      "plane_d": -980.6093139648438,
      "bbox_min": [
        -3181.999755859375,
        -4842.80224609375,
        1087.7757568359375
      ],
      "bbox_max": [
        -3177.43212890625,
        -4839.7685546875,
        1089.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1221439465880394,
        0.05059312283992767,
        -0.991222083568573
      ],
      "plane_d": 1706.1895751953125,
      "bbox_min": [
        -3144.960693359375,
        -4802.8134765625,
        1089.561279296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1097.5357666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19617928564548492,
        0.0,
        -0.9805680513381958
      ],
      "plane_d": 1683.86376953125,
      "bbox_min": [
        -3137.30712890625,
        -4802.8134765625,
        1089.561279296875
      ],
      "bbox_max": [
        -3111.736083984375,
        -4779.7685546875,
        1097.5357666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950962394475937,
        -0.9807841181755066,
        0.0
      ],
      "plane_d": -4098.4462890625,
      "bbox_min": [
        -3137.30712890625,
        -4802.8134765625,
        1089.561279296875
      ],
      "bbox_max": [
        -3112.640869140625,
        -4779.7685546875,
        1097.5357666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4779.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4779.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3112.640869140625,
        -4779.7685546875,
        1097.5357666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4799.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4799.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3112.640869140625,
        -4799.7685546875,
        1095.7479248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3121.999755859375,
        -4799.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1093.8231201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4779.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4799.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1093.8231201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4799.7685546875,
      "bbox_min": [
        -3113.71533203125,
        -4799.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4799.7685546875,
        1092.86767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0005590629298239946,
        0.36375975608825684,
        -0.9314926862716675
      ],
      "plane_d": 2759.59716796875,
      "bbox_min": [
        -3178.644287109375,
        -4830.72802734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3150.283935546875,
        -4811.484375,
        1085.498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -53.724609375,
      "bbox_min": [
        -3178.644287109375,
        -4830.72802734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3150.283935546875,
        -4811.484375,
        1085.498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07161380350589752,
        0.2093566656112671,
        -0.9752134084701538
      ],
      "plane_d": 1837.46435546875,
      "bbox_min": [
        -3177.4326171875,
        -4819.884765625,
        1082.623779296875
      ],
      "bbox_max": [
        -3172.42822265625,
        -4816.8076171875,
        1083.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": 2157.001953125,
      "bbox_min": [
        -3160.201416015625,
        -4830.72802734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3158.954833984375,
        -4824.46142578125,
        1083.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9060542583465576,
        0.4231615960597992,
        0.0
      ],
      "plane_d": -910.13818359375,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4786.7001953125,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9153205752372742,
        0.40272602438926697,
        0.0
      ],
      "plane_d": -1038.0235595703125,
      "bbox_min": [
        -3241.68994140625,
        -4790.2587890625,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.88623046875,
        -4788.43212890625,
        1094.0478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9143241047859192,
        -0.4049834907054901,
        0.0
      ],
      "plane_d": 1046.1676025390625,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4786.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3292.7587890625,
        -4850.7685546875,
        1095.1993408203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3292.7587890625,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4786.7001953125,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4787.7001953125,
      "bbox_min": [
        -3264.823974609375,
        -4788.43212890625,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4786.7001953125,
        1098.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1093.623779296875,
      "bbox_min": [
        -3253.0908203125,
        -4787.7001953125,
        1093.623779296875
      ],
      "bbox_max": [
        -3247.90869140625,
        -4786.7001953125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9153205752372742,
        0.40272602438926697,
        0.0
      ],
      "plane_d": -1038.0235595703125,
      "bbox_min": [
        -3240.88623046875,
        -4788.43212890625,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3319.999755859375,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3319.999755859375,
        -4929.11279296875,
        1102.623779296875
      ],
      "bbox_max": [
        -3269.999755859375,
        -4919.7685546875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 5852.33740234375,
      "bbox_min": [
        -3318.725830078125,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3318.725830078125,
        -4850.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3294.428466796875,
        -4850.7685546875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": 0.334716796875,
      "bbox_min": [
        -3294.428466796875,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3294.428466796875,
        -4850.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3271.273681640625,
        -4850.7685546875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 5390.181640625,
      "bbox_min": [
        -3219.999755859375,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": 4104.474609375,
      "bbox_min": [
        -3219.999755859375,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555710792541504,
        -0.8314691185951233,
        0.0
      ],
      "plane_d": -2193.2998046875,
      "bbox_min": [
        -3219.999755859375,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807848930358887,
        -0.19509220123291016,
        -9.289935292144946e-07
      ],
      "plane_d": 2211.781005859375,
      "bbox_min": [
        -3219.999755859375,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4804.8466796875,
        1140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1122.6236572265625,
      "bbox_min": [
        -3145.921875,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4929.7685546875,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 4965.76806640625,
      "bbox_min": [
        -3145.921875,
        -4965.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.265625,
        -4929.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5752.28564453125,
      "bbox_min": [
        -3129.999755859375,
        -4949.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -3375.313232421875,
      "bbox_min": [
        -3129.999755859375,
        -4949.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4946.83984375,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4939.76806640625,
      "bbox_min": [
        -3119.999755859375,
        -4939.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.265625,
        -4934.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8264905214309692,
        0.0,
        0.5629506707191467
      ],
      "plane_d": -3198.854248046875,
      "bbox_min": [
        -3116.265625,
        -4939.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.265625,
        -4934.7685546875,
        1110.1207275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3116.265625,
        -4934.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.265625,
        -4934.7685546875,
        1110.1207275390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3356.835693359375,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3129.999755859375,
        -4929.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -5770.763671875,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3129.999755859375,
        -4946.83984375,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8264952301979065,
        0.0,
        -0.5629439353942871
      ],
      "plane_d": 3196.861328125,
      "bbox_min": [
        -3114.265869140625,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.43359375,
        -4929.9482421875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4939.7685546875,
      "bbox_min": [
        -3114.265625,
        -4939.7685546875,
        1106.5679931640625
      ],
      "bbox_max": [
        -3103.32958984375,
        -4934.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3114.265625,
        -4939.7685546875,
        1106.5679931640625
      ],
      "bbox_max": [
        -3106.92919921875,
        -4934.7685546875,
        1117.3388671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8264905214309692,
        0.0,
        0.5629506707191467
      ],
      "plane_d": -3198.854248046875,
      "bbox_min": [
        -3114.265625,
        -4939.7685546875,
        1110.1207275390625
      ],
      "bbox_max": [
        -3106.92919921875,
        -4934.7685546875,
        1117.3388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32747307419776917,
        0.0,
        0.944860577583313
      ],
      "plane_d": -2073.1650390625,
      "bbox_min": [
        -3110.096923828125,
        -4939.7685546875,
        1116.240966796875
      ],
      "bbox_max": [
        -3106.92919921875,
        -4934.7685546875,
        1117.3388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32747265696525574,
        0.0,
        -0.9448606371879578
      ],
      "plane_d": 2071.163818359375,
      "bbox_min": [
        -3108.81689453125,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.43359375,
        -4929.9482421875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4939.7685546875,
      "bbox_min": [
        -3108.816650390625,
        -4965.7685546875,
        1114.5679931640625
      ],
      "bbox_max": [
        -3085.57275390625,
        -4934.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3108.816650390625,
        -4965.7685546875,
        1114.5679931640625
      ],
      "bbox_max": [
        -3085.5732421875,
        -4965.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3108.816650390625,
        -4939.7685546875,
        1114.5679931640625
      ],
      "bbox_max": [
        -3096.946044921875,
        -4934.7685546875,
        1119.740478515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.32747307419776917,
        0.0,
        0.944860577583313
      ],
      "plane_d": -2073.1650390625,
      "bbox_min": [
        -3106.92919921875,
        -4939.7685546875,
        1117.3388671875
      ],
      "bbox_max": [
        -3096.946044921875,
        -4934.7685546875,
        1119.740478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32747307419776917,
        -0.0,
        0.944860577583313
      ],
      "plane_d": -42.83221435546875,
      "bbox_min": [
        -3099.999755859375,
        -4939.7685546875,
        1118.68212890625
      ],
      "bbox_max": [
        -3096.946044921875,
        -4934.7685546875,
        1119.740478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3085.73388671875,
      "bbox_min": [
        -3100.0,
        -4976.0,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.43359375,
        -4929.9482421875,
        1122.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3085.73388671875,
        -4965.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.43359375,
        -4929.9482421875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -5747.80419921875,
      "bbox_min": [
        -3077.07080078125,
        -4949.5888671875,
        1110.6771240234375
      ],
      "bbox_max": [
        -3070.433837890625,
        -4946.83984375,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3379.79541015625,
      "bbox_min": [
        -3077.07080078125,
        -4932.697265625,
        1110.6771240234375
      ],
      "bbox_max": [
        -3070.433837890625,
        -4929.9482421875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3085.73388671875,
        -4934.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3083.73388671875,
        -4934.7685546875,
        1110.1207275390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8264952301979065,
        -0.0,
        -0.5629439353942871
      ],
      "plane_d": -1927.408447265625,
      "bbox_min": [
        -3100.0,
        -4976.0,
        1106.5679931640625
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1122.568115234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4939.7685546875,
      "bbox_min": [
        -3094.550537109375,
        -4939.7685546875,
        1106.5679931640625
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1122.5679931640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3093.06982421875,
        -4939.7685546875,
        1106.5679931640625
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1117.3387451171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8264905214309692,
        -0.0,
        0.5629506707191467
      ],
      "plane_d": 1925.386474609375,
      "bbox_min": [
        -3093.06982421875,
        -4939.7685546875,
        1110.1207275390625
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1117.3387451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32747307419776917,
        -0.0,
        0.944860577583313
      ],
      "plane_d": -42.83221435546875,
      "bbox_min": [
        -3093.06982421875,
        -4939.7685546875,
        1116.240966796875
      ],
      "bbox_max": [
        -3089.902587890625,
        -4934.7685546875,
        1117.3387451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32747265696525574,
        -0.0,
        -0.9448606371879578
      ],
      "plane_d": 40.83355712890625,
      "bbox_min": [
        -3100.0,
        -4976.0,
        1114.5679931640625
      ],
      "bbox_max": [
        -3091.182861328125,
        -4934.7685546875,
        1119.512451171875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3099.999755859375,
        -4965.7685546875,
        1114.5679931640625
      ],
      "bbox_max": [
        -3091.182861328125,
        -4965.7685546875,
        1119.512451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3099.999755859375,
        -4939.7685546875,
        1114.5679931640625
      ],
      "bbox_max": [
        -3091.182861328125,
        -4934.7685546875,
        1118.68212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32747307419776917,
        -0.0,
        0.944860577583313
      ],
      "plane_d": -42.83221435546875,
      "bbox_min": [
        -3096.946044921875,
        -4939.7685546875,
        1117.3387451171875
      ],
      "bbox_max": [
        -3093.06982421875,
        -4934.7685546875,
        1118.68212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3145.921875,
        -4965.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3060.780029296875,
        -4929.7685546875,
        1140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1132.6236572265625,
      "bbox_min": [
        -3139.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3064.878173828125,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923882782459259,
        0.38267579674720764,
        -0.0
      ],
      "plane_d": 4772.84375,
      "bbox_min": [
        -3139.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3064.878173828125,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -1010.661865234375,
      "bbox_min": [
        -3139.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4791.3212890625,
      "bbox_min": [
        -3139.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": 992.184326171875,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3356.835693359375,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5752.28564453125,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -5770.763671875,
      "bbox_min": [
        -3137.07080078125,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4946.83984375,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -3375.313232421875,
      "bbox_min": [
        -3129.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4946.83984375,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -955.22900390625,
      "bbox_min": [
        -3079.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3064.878173828125,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4735.888671875,
      "bbox_min": [
        -3079.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3064.878173828125,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3379.79541015625,
      "bbox_min": [
        -3077.07080078125,
        -4949.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3064.878173828125,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -3398.272705078125,
      "bbox_min": [
        -3069.999755859375,
        -4949.7685546875,
        1123.4049072265625
      ],
      "bbox_max": [
        -3064.878173828125,
        -4947.6474609375,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 235.0537109375,
      "bbox_min": [
        -3109.32275390625,
        -4976.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2979.098876953125,
        -4976.0,
        1102.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4919.7685546875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": -1976.3916015625,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2979.999755859375,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807850122451782,
        -0.19509224593639374,
        -0.0
      ],
      "plane_d": -3869.08642578125,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2979.999755859375,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555710792541504,
        -0.8314691185951233,
        -0.0
      ],
      "plane_d": -5637.83984375,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3015.14697265625,
        -4740.06005859375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": 936.751220703125,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        0.38267579674720764,
        -0.0
      ],
      "plane_d": 4717.4111328125,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5729.326171875,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -4859.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -3398.272705078125,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3379.79541015625,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -5747.80419921875,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -4931.8896484375,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4735.888671875,
      "bbox_min": [
        -3087.100341796875,
        -4947.6474609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -4931.8896484375,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -955.22900390625,
      "bbox_min": [
        -3079.999755859375,
        -4947.6474609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -4931.8896484375,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1132.6236572265625,
      "bbox_min": [
        -3064.878173828125,
        -4947.6474609375,
        1132.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -4931.8896484375,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4939.7685546875,
      "bbox_min": [
        -3087.100341796875,
        -4946.83984375,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.07080078125,
        -4939.7685546875,
        1105.4046630859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3087.100341796875,
        -4946.83984375,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.07080078125,
        -4939.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4942.6865234375,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1101.623779296875,
      "bbox_min": [
        -3077.07080078125,
        -4952.69677734375,
        1101.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4946.83984375,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1122.6236572265625,
      "bbox_min": [
        -3070.433837890625,
        -4949.94775390625,
        1122.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4949.5888671875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3108.630615234375,
        -4965.7685546875,
        1053.8697509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3108.630615234375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3087.1005859375,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.07080078125,
        -4952.69677734375,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1122.6236572265625,
      "bbox_min": [
        -3070.433837890625,
        -4964.95947265625,
        1122.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4949.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3104.875,
        -4899.7685546875,
        1056.38720703125
      ],
      "bbox_max": [
        -3076.568115234375,
        -4859.7685546875,
        1074.3255615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33401647210121155,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": -1349.8382568359375,
      "bbox_min": [
        -3103.383056640625,
        -4899.7685546875,
        1058.52734375
      ],
      "bbox_max": [
        -3076.568115234375,
        -4859.7685546875,
        1074.3255615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3780319392681122,
        0.0,
        0.9257925748825073
      ],
      "plane_d": 183.02239990234375,
      "bbox_min": [
        -3103.383056640625,
        -4899.7685546875,
        1058.52734375
      ],
      "bbox_max": [
        -3076.568115234375,
        -4859.7685546875,
        1074.3255615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3103.383056640625,
        -4892.6259765625,
        1058.52734375
      ],
      "bbox_max": [
        -3082.07958984375,
        -4859.7685546875,
        1068.3741455078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.33401644229888916,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": 723.85986328125,
      "bbox_min": [
        -3101.4658203125,
        -4892.6259765625,
        1060.8125
      ],
      "bbox_max": [
        -3082.07958984375,
        -4879.7685546875,
        1068.3741455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23462752997875214,
        -0.048543624579906464,
        -0.9708725214004517
      ],
      "plane_d": 1522.31396484375,
      "bbox_min": [
        -3103.383056640625,
        -4879.7685546875,
        1062.11328125
      ],
      "bbox_max": [
        -3090.707275390625,
        -4859.7685546875,
        1068.1405029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3103.383056640625,
        -4859.7685546875,
        1062.11328125
      ],
      "bbox_max": [
        -3093.13623046875,
        -4859.7685546875,
        1067.1285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3099.999755859375,
        -4879.7685546875,
        1062.4404296875
      ],
      "bbox_max": [
        -3091.44970703125,
        -4872.435546875,
        1064.649169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37803196907043457,
        0.0,
        0.9257925748825073
      ],
      "plane_d": -2160.775390625,
      "bbox_min": [
        -3099.99951171875,
        -4879.7685546875,
        1064.3460693359375
      ],
      "bbox_max": [
        -3084.852294921875,
        -4859.7685546875,
        1074.3255615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4879.7685546875,
      "bbox_min": [
        -3099.99951171875,
        -4879.7685546875,
        1064.3460693359375
      ],
      "bbox_max": [
        -3084.852294921875,
        -4859.7685546875,
        1074.3255615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3097.521484375,
        -4859.7685546875,
        1065.337890625
      ],
      "bbox_max": [
        -3093.135986328125,
        -4859.7685546875,
        1068.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3104.210693359375,
        -4879.7685546875,
        1058.146484375
      ],
      "bbox_max": [
        -3084.85205078125,
        -4859.7685546875,
        1063.314453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.23462752997875214,
        -0.048543624579906464,
        -0.9708725214004517
      ],
      "plane_d": 1522.31396484375,
      "bbox_min": [
        -3104.210693359375,
        -4879.7685546875,
        1061.30712890625
      ],
      "bbox_max": [
        -3098.733154296875,
        -4859.7685546875,
        1063.314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3104.210693359375,
        -4859.7685546875,
        1061.30712890625
      ],
      "bbox_max": [
        -3098.733154296875,
        -4859.7685546875,
        1063.314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3102.068603515625,
        -4879.7685546875,
        1061.906005859375
      ],
      "bbox_max": [
        -3099.999755859375,
        -4871.74609375,
        1062.4404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23462752997875214,
        -0.048543624579906464,
        -0.9708725214004517
      ],
      "plane_d": 1522.31396484375,
      "bbox_min": [
        -3104.875,
        -4879.7685546875,
        1060.62890625
      ],
      "bbox_max": [
        -3101.266357421875,
        -4859.7685546875,
        1062.7064208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3104.875,
        -4879.7685546875,
        1060.62890625
      ],
      "bbox_max": [
        -3102.068603515625,
        -4859.7685546875,
        1062.7064208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4879.7685546875,
      "bbox_min": [
        -3104.51708984375,
        -4879.7685546875,
        1061.2734375
      ],
      "bbox_max": [
        -3101.266357421875,
        -4879.7685546875,
        1062.30712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        0.0,
        -0.24253563582897186
      ],
      "plane_d": 3259.927734375,
      "bbox_min": [
        -3106.600341796875,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3106.600341796875,
        -4782.21875,
        1052.623779296875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3106.600341796875,
      "bbox_min": [
        -3106.600341796875,
        -4779.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3106.600341796875,
        -4769.7685546875,
        1057.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3106.600341796875,
      "bbox_min": [
        -3106.600341796875,
        -4789.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3106.600341796875,
        -4779.7685546875,
        1057.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33401647210121155,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": -1349.8382568359375,
      "bbox_min": [
        -3093.135986328125,
        -4859.9287109375,
        1068.699951171875
      ],
      "bbox_max": [
        -3093.069580078125,
        -4859.7685546875,
        1068.7476806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17693176865577698,
        -0.03318452090024948,
        -0.9836635589599609
      ],
      "plane_d": 1432.439208984375,
      "bbox_min": [
        -3093.244140625,
        -4879.7685546875,
        1063.4658203125
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14644503593444824,
        0.15934692323207855,
        -0.9763003587722778
      ],
      "plane_d": 2264.755859375,
      "bbox_min": [
        -3093.244140625,
        -4879.7685546875,
        1063.813232421875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14150793850421906,
        -0.04840826988220215,
        -0.9887527823448181
      ],
      "plane_d": 1255.4505615234375,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1063.813232421875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17616155743598938,
        0.03705311194062233,
        -0.9836636185646057
      ],
      "plane_d": 1771.610107421875,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1758042573928833,
        0.03886957839131355,
        -0.9836574792861938
      ],
      "plane_d": 1779.3203125,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555662512779236,
        0.8314722776412964,
        0.0
      ],
      "plane_d": 5658.68994140625,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555662512779236,
        -0.8314722776412964,
        0.0
      ],
      "plane_d": -2356.318359375,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509725272655487,
        0.9807839393615723,
        0.0
      ],
      "plane_d": 5268.81396484375,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509725272655487,
        -0.9807839393615723,
        0.0
      ],
      "plane_d": -4185.4892578125,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314690589904785,
        -0.5555711388587952,
        0.0
      ],
      "plane_d": -177.309814453125,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15917502343654633,
        0.14545495808124542,
        0.9764764308929443
      ],
      "plane_d": -831.9400634765625,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16064220666885376,
        0.1464138925075531,
        0.9760926961898804
      ],
      "plane_d": -831.3634643554688,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3019.91552734375,
        -4828.38427734375,
        1080.6424560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33401647210121155,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": -1349.8382568359375,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3019.91552734375,
        -4828.38427734375,
        1080.6424560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807859063148499,
        -0.19508720934391022,
        0.0
      ],
      "plane_d": 2019.736572265625,
      "bbox_min": [
        -3085.949951171875,
        -4879.7685546875,
        1067.14306640625
      ],
      "bbox_max": [
        -3019.91552734375,
        -4829.39990234375,
        1080.6424560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4879.7685546875,
      "bbox_min": [
        -3085.949951171875,
        -4879.7685546875,
        1067.14306640625
      ],
      "bbox_max": [
        -3077.999755859375,
        -4877.11865234375,
        1077.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37803196907043457,
        0.0,
        0.9257925748825073
      ],
      "plane_d": -2160.775390625,
      "bbox_min": [
        -3085.949951171875,
        -4879.7685546875,
        1073.87744140625
      ],
      "bbox_max": [
        -3077.999755859375,
        -4877.11865234375,
        1077.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3093.13623046875,
        -4859.7685546875,
        1064.978271484375
      ],
      "bbox_max": [
        -3039.713623046875,
        -4828.38427734375,
        1077.010009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3077.999755859375,
        -4859.7685546875,
        1067.1446533203125
      ],
      "bbox_max": [
        -3039.713623046875,
        -4828.38427734375,
        1077.010009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3041.044677734375,
        -4835.07568359375,
        1074.4188232421875
      ],
      "bbox_max": [
        -3039.713623046875,
        -4828.38427734375,
        1076.4903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07161381840705872,
        0.20935668051242828,
        -0.9752134680747986
      ],
      "plane_d": 2277.282958984375,
      "bbox_min": [
        -3087.100341796875,
        -4875.201171875,
        1075.7105712890625
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2286498099565506,
        0.11457086354494095,
        0.9667434096336365
      ],
      "plane_d": -1184.240966796875,
      "bbox_min": [
        -3087.100341796875,
        -4875.201171875,
        1075.7105712890625
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807859063148499,
        -0.19508720934391022,
        0.0
      ],
      "plane_d": 2019.736572265625,
      "bbox_min": [
        -3062.6923828125,
        -4856.7236328125,
        1075.7105712890625
      ],
      "bbox_max": [
        -3017.999755859375,
        -4819.02197265625,
        1084.0179443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3062.6923828125,
        -4856.7236328125,
        1075.7105712890625
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        0.8314674496650696,
        0.0
      ],
      "plane_d": 2336.656982421875,
      "bbox_min": [
        -3062.6923828125,
        -4856.7236328125,
        1075.7105712890625
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3041.044677734375,
        -4835.07568359375,
        1075.7105712890625
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3038.148193359375,
        -4819.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1077.646728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807859063148499,
        -0.19508720934391022,
        0.0
      ],
      "plane_d": 2019.736572265625,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23879720270633698,
        -0.17490075528621674,
        0.9551888108253479
      ],
      "plane_d": -2604.228759765625,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0005590711371041834,
        0.3637598156929016,
        -0.9314926862716675
      ],
      "plane_d": 2755.78857421875,
      "bbox_min": [
        -3057.064697265625,
        -4841.73681640625,
        1077.523193359375
      ],
      "bbox_max": [
        -3022.56689453125,
        -4763.93310546875,
        1089.8314208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3052.357421875,
        -4841.73681640625,
        1077.523193359375
      ],
      "bbox_max": [
        -3037.999755859375,
        -4789.23681640625,
        1086.6236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3052.357421875,
        -4841.73681640625,
        1078.4774169921875
      ],
      "bbox_max": [
        -3041.044677734375,
        -4789.23681640625,
        1086.6236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -5678.3037109375,
      "bbox_min": [
        -3052.26806640625,
        -4791.484375,
        1085.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4789.77880859375,
        1086.6236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.051469940692186356,
        0.1215628907084465,
        -0.9912483096122742
      ],
      "plane_d": 1501.496826171875,
      "bbox_min": [
        -3057.064697265625,
        -4796.8076171875,
        1083.436279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4763.93310546875,
        1089.8314208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2369917780160904,
        0.0981641411781311,
        -0.9665396213531494
      ],
      "plane_d": 796.7720947265625,
      "bbox_min": [
        -3057.064697265625,
        -4791.484375,
        1085.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4763.93310546875,
        1089.8314208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12214395403862,
        0.05059313401579857,
        -0.991222083568573
      ],
      "plane_d": 947.8853759765625,
      "bbox_min": [
        -3057.064697265625,
        -4766.7880859375,
        1089.561279296875
      ],
      "bbox_max": [
        -3055.038818359375,
        -4763.93310546875,
        1089.8314208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2875499129295349,
        -0.07020559161901474,
        0.955189049243927
      ],
      "plane_d": -2246.758056640625,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3048.349365234375,
        -4846.0078125,
        1078.30859375
      ],
      "bbox_max": [
        -3040.0419921875,
        -4830.03515625,
        1081.9833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3041.044677734375,
        -4835.07568359375,
        1080.809814453125
      ],
      "bbox_max": [
        -3040.0419921875,
        -4830.03515625,
        1081.9833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2550874352455139,
        0.018345560878515244,
        0.9667439460754395
      ],
      "plane_d": -1732.361083984375,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3060.59228515625,
        -4855.3203125,
        1076.5166015625
      ],
      "bbox_max": [
        -3041.163330078125,
        -4835.25341796875,
        1081.262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        0.8314674496650696,
        0.0
      ],
      "plane_d": 2336.656982421875,
      "bbox_min": [
        -3060.59228515625,
        -4855.3203125,
        1076.5166015625
      ],
      "bbox_max": [
        -3049.715576171875,
        -4848.052734375,
        1079.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23999638855457306,
        -0.14432395994663239,
        0.9599855542182922
      ],
      "plane_d": -2465.7001953125,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25476786494255066,
        0.016561293974518776,
        0.9668603539466858
      ],
      "plane_d": -1740.162353515625,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24678324162960052,
        0.02719999849796295,
        0.9686889052391052
      ],
      "plane_d": -1666.2080078125,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        0.8314674496650696,
        0.0
      ],
      "plane_d": 2336.656982421875,
      "bbox_min": [
        -3062.6923828125,
        -4856.7236328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4848.052734375,
        1079.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12214395403862,
        0.05059313401579857,
        -0.991222083568573
      ],
      "plane_d": 947.8853759765625,
      "bbox_min": [
        -3087.100341796875,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4759.7685546875,
        1097.2554931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19617927074432373,
        -0.0,
        -0.980567991733551
      ],
      "plane_d": 467.55218505859375,
      "bbox_min": [
        -3087.048095703125,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4759.7685546875,
        1097.2554931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -5678.3037109375,
      "bbox_min": [
        -3086.18994140625,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4759.7685546875,
        1097.2554931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950962394475937,
        -0.9807840585708618,
        0.0
      ],
      "plane_d": -5288.4267578125,
      "bbox_min": [
        -3082.49072265625,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4779.7685546875,
        1093.6697998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -5197.7412109375,
      "bbox_min": [
        -3082.49072265625,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4779.7685546875,
        1093.6697998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3041.044677734375,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4804.46142578125,
        1087.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3087.048095703125,
        -4779.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.999755859375,
        -4759.7685546875,
        1094.262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4779.7685546875,
      "bbox_min": [
        -3087.048095703125,
        -4779.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.999755859375,
        -4779.7685546875,
        1093.5223388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2369917780160904,
        0.0981641411781311,
        -0.9665396213531494
      ],
      "plane_d": 796.7720947265625,
      "bbox_min": [
        -3087.100341796875,
        -4799.11962890625,
        1086.2978515625
      ],
      "bbox_max": [
        -3044.61376953125,
        -4759.7685546875,
        1093.67333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3087.100341796875,
        -4779.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.999755859375,
        -4759.7685546875,
        1093.67333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4759.7685546875,
      "bbox_min": [
        -3087.100341796875,
        -4779.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.999755859375,
        -4759.7685546875,
        1093.67333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4779.7685546875,
      "bbox_min": [
        -3087.100341796875,
        -4779.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3086.283935546875,
        -4779.7685546875,
        1092.7178955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1664927452802658,
        -0.22518356144428253,
        0.9599857330322266
      ],
      "plane_d": -2632.12109375,
      "bbox_min": [
        -3041.044677734375,
        -4819.7685546875,
        1084.373779296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4796.8076171875,
        1092.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3041.044677734375,
        -4819.7685546875,
        1084.373779296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4804.46142578125,
        1087.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4759.7685546875,
      "bbox_min": [
        -3084.6484375,
        -4759.7685546875,
        1097.037109375
      ],
      "bbox_max": [
        -3077.999755859375,
        -4759.7685546875,
        1099.8349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950962394475937,
        -0.9807840585708618,
        0.0
      ],
      "plane_d": -5288.4267578125,
      "bbox_min": [
        -3086.677490234375,
        -4782.8134765625,
        1093.384765625
      ],
      "bbox_max": [
        -3062.6923828125,
        -4779.7685546875,
        1095.428466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4779.7685546875,
      "bbox_min": [
        -3086.677490234375,
        -4779.7685546875,
        1093.384765625
      ],
      "bbox_max": [
        -3077.999755859375,
        -4779.7685546875,
        1095.428466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10164552181959152,
        -0.14857377111911774,
        0.9836635589599609
      ],
      "plane_d": -1477.9390869140625,
      "bbox_min": [
        -3085.542236328125,
        -4791.484375,
        1092.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1822548657655716,
        -0.18011736869812012,
        0.9666131138801575
      ],
      "plane_d": -1363.227783203125,
      "bbox_min": [
        -3085.542236328125,
        -4791.484375,
        1092.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -5678.3037109375,
      "bbox_min": [
        -3085.542236328125,
        -4791.484375,
        1092.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3082.100341796875,
        -4762.57421875,
        1101.623779296875
      ],
      "bbox_max": [
        -3077.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950962394475937,
        -0.9807840585708618,
        0.0
      ],
      "plane_d": -5288.4267578125,
      "bbox_min": [
        -3085.542236328125,
        -4782.8134765625,
        1094.5404052734375
      ],
      "bbox_max": [
        -3062.6923828125,
        -4779.7685546875,
        1099.167724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4779.7685546875,
      "bbox_min": [
        -3085.542236328125,
        -4779.7685546875,
        1095.3577880859375
      ],
      "bbox_max": [
        -3077.999755859375,
        -4779.7685546875,
        1099.167724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31399640440940857,
        -0.0,
        0.949424147605896
      ],
      "plane_d": -79.42742919921875,
      "bbox_min": [
        -3083.46484375,
        -4782.8134765625,
        1096.561279296875
      ],
      "bbox_max": [
        -3062.6923828125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3083.46484375,
        -4782.8134765625,
        1096.561279296875
      ],
      "bbox_max": [
        -3062.6923828125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950962394475937,
        -0.9807840585708618,
        0.0
      ],
      "plane_d": -5288.4267578125,
      "bbox_min": [
        -3083.46484375,
        -4782.8134765625,
        1096.561279296875
      ],
      "bbox_max": [
        -3062.6923828125,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4779.7685546875,
      "bbox_min": [
        -3083.46484375,
        -4779.7685546875,
        1098.60302734375
      ],
      "bbox_max": [
        -3077.999755859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.051469940692186356,
        0.1215628907084465,
        -0.9912483096122742
      ],
      "plane_d": 1501.496826171875,
      "bbox_min": [
        -3037.419677734375,
        -4796.8076171875,
        1083.436279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4776.1083984375,
        1086.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06524179130792618,
        0.13515298068523407,
        -0.988674521446228
      ],
      "plane_d": 1521.8194580078125,
      "bbox_min": [
        -3037.419677734375,
        -4778.083984375,
        1086.4462890625
      ],
      "bbox_max": [
        -3035.5732421875,
        -4776.1083984375,
        1086.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1940375417470932,
        0.0555293932557106,
        -0.9794211387634277
      ],
      "plane_d": 1911.15185546875,
      "bbox_min": [
        -3070.432373046875,
        -4862.19482421875,
        1068.1539306640625
      ],
      "bbox_max": [
        -3035.5732421875,
        -4848.052734375,
        1074.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        0.8314674496650696,
        0.0
      ],
      "plane_d": 2336.656982421875,
      "bbox_min": [
        -3070.432373046875,
        -4858.26318359375,
        1068.1539306640625
      ],
      "bbox_max": [
        -3049.715576171875,
        -4848.052734375,
        1072.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509625434875488,
        0.9807841777801514,
        0.0
      ],
      "plane_d": 4165.87744140625,
      "bbox_min": [
        -3070.432373046875,
        -4858.26318359375,
        1068.1539306640625
      ],
      "bbox_max": [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.143018901348114,
        -0.04942425712943077,
        -0.9884851574897766
      ],
      "plane_d": 1254.857666015625,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1063.813232421875
      ],
      "bbox_max": [
        -3062.6923828125,
        -4856.7236328125,
        1069.186279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509625434875488,
        0.9807841777801514,
        0.0
      ],
      "plane_d": 4165.87744140625,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.9337158203125
      ],
      "bbox_max": [
        -3062.6923828125,
        -4856.7236328125,
        1069.186279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4879.7685546875,
      "bbox_min": [
        -3084.852294921875,
        -4879.7685546875,
        1067.1322021484375
      ],
      "bbox_max": [
        -3077.999755859375,
        -4879.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23462752997875214,
        -0.048543624579906464,
        -0.9708725214004517
      ],
      "plane_d": 1522.31396484375,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1063.813232421875
      ],
      "bbox_max": [
        -3077.999755859375,
        -4859.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1063.813232421875
      ],
      "bbox_max": [
        -3077.999755859375,
        -4859.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4879.7685546875,
      "bbox_min": [
        -3084.852294921875,
        -4879.7685546875,
        1066.4678955078125
      ],
      "bbox_max": [
        -3077.999755859375,
        -4879.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3085.949951171875,
        -4879.7685546875,
        1066.0699462890625
      ],
      "bbox_max": [
        -3077.999755859375,
        -4877.11865234375,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4879.7685546875,
      "bbox_min": [
        -3084.852294921875,
        -4879.7685546875,
        1066.353515625
      ],
      "bbox_max": [
        -3077.999755859375,
        -4879.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14628201723098755,
        0.1660124659538269,
        -0.9752135276794434
      ],
      "plane_d": 2295.2158203125,
      "bbox_min": [
        -3093.244140625,
        -4836.1044921875,
        1068.04833984375
      ],
      "bbox_max": [
        -3017.999755859375,
        -4769.7685546875,
        1080.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.7685546875,
        1077.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1758042573928833,
        0.03886957839131355,
        -0.9836574792861938
      ],
      "plane_d": 1779.3203125,
      "bbox_min": [
        -3041.22607421875,
        -4835.98681640625,
        1074.2427978515625
      ],
      "bbox_max": [
        -3039.69970703125,
        -4835.07568359375,
        1074.5296630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      "bbox_max": [
        -3041.044677734375,
        -4835.07568359375,
        1074.4188232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1758042573928833,
        0.03886957839131355,
        -0.9836574792861938
      ],
      "plane_d": 1779.3203125,
      "bbox_min": [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      "bbox_max": [
        -3041.044677734375,
        -4835.07568359375,
        1074.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3092.100341796875,
      "bbox_min": [
        -3093.244140625,
        -4789.7685546875,
        1068.04833984375
      ],
      "bbox_max": [
        -3092.100341796875,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4789.7685546875,
      "bbox_min": [
        -3093.244140625,
        -4789.7685546875,
        1068.04833984375
      ],
      "bbox_max": [
        -3092.100341796875,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3092.752685546875,
        -4769.7685546875,
        1070.0147705078125
      ],
      "bbox_max": [
        -3092.100341796875,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3092.100341796875,
      "bbox_min": [
        -3097.100341796875,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4769.7685546875,
        1070.1458740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3097.100341796875,
        -4789.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3092.100341796875,
        -4769.7685546875,
        1070.1458740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3084.85205078125,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1060.822998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33401644229888916,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": 723.85986328125,
      "bbox_min": [
        -3084.85205078125,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1060.822998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3084.85205078125,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1060.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4899.76806640625,
      "bbox_min": [
        -3076.568115234375,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4899.7685546875,
        1058.572509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3084.85205078125,
        -4886.4619140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1058.52734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23462752997875214,
        -0.04854360595345497,
        -0.9708725214004517
      ],
      "plane_d": 66.652587890625,
      "bbox_min": [
        -3084.85205078125,
        -4886.4619140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1058.146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3070.76904296875,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4963.9111328125,
        1140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3069.999755859375,
      "bbox_min": [
        -3070.76904296875,
        -4965.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4963.9111328125,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1101.623779296875,
      "bbox_min": [
        -3070.76904296875,
        -4965.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4963.9111328125,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1122.6236572265625,
      "bbox_min": [
        -3070.433837890625,
        -4965.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4963.9111328125,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3295.0,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4976.0,
        1140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.11588192731142044,
        0.0,
        0.9932630062103271
      ],
      "plane_d": -1432.636962890625,
      "bbox_min": [
        -3295.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3195.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1065337285399437,
        0.9943090677261353,
        0.0
      ],
      "plane_d": 4650.06201171875,
      "bbox_min": [
        -3295.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3195.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1064.699951171875,
      "bbox_min": [
        -3295.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5024.57177734375,
        1064.699951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1064.699951171875,
      "bbox_min": [
        -3295.0,
        -5029.71484375,
        1064.699951171875
      ],
      "bbox_max": [
        -3224.8740234375,
        -4976.0,
        1140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5023.5,
      "bbox_min": [
        -3257.0,
        -5024.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3224.8740234375,
        -4976.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3257.0,
      "bbox_min": [
        -3257.0,
        -5024.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3257.0,
        -5023.5,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3229.66650390625,
        -4978.57177734375,
        1126.0738525390625
      ],
      "bbox_max": [
        -3224.8740234375,
        -4976.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1101.5999755859375,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4976.0,
        1140.0
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5004.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1069.5999755859375,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5219.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -5004.0,
        1069.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -5044.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2979.000244140625,
        -5159.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2969.000244140625,
        -5159.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5084.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1060.0
      ],
      "bbox_max": [
        -2960.000244140625,
        -5084.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2979.000244140625,
        -5159.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5159.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.000244140625,
        -5134.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3080.000244140625,
        -5134.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3010.000244140625,
      "bbox_min": [
        -3010.000244140625,
        -5093.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.0,
      "bbox_min": [
        -3010.000244140625,
        -5093.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3317185044288635,
        -0.0,
        0.9433784484863281
      ],
      "plane_d": -6.55694580078125,
      "bbox_min": [
        -3010.000244140625,
        -5093.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -3010.000244140625,
        -5090.7353515625,
        1060.0
      ],
      "bbox_max": [
        -2994.78076171875,
        -5036.39013671875,
        1065.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4003121852874756,
        0.9163788557052612,
        -0.0
      ],
      "plane_d": 5858.853515625,
      "bbox_min": [
        -3004.734375,
        -5090.7353515625,
        1060.0
      ],
      "bbox_max": [
        -2994.78076171875,
        -5080.89208984375,
        1063.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4281085133552551,
        0.9037274122238159,
        0.0
      ],
      "plane_d": 5882.72802734375,
      "bbox_min": [
        -2996.000244140625,
        -5090.7353515625,
        1060.0
      ],
      "bbox_max": [
        -2994.78076171875,
        -5090.15771484375,
        1060.4288330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -3009.00048828125,
        -5093.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5034.0,
      "bbox_min": [
        -2990.000244140625,
        -5034.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4003121852874756,
        0.9163788557052612,
        -0.0
      ],
      "plane_d": 5858.853515625,
      "bbox_min": [
        -3004.734375,
        -5093.0,
        1060.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5080.89208984375,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11514623463153839,
        -0.26358821988105774,
        0.9577382206916809
      ],
      "plane_d": -2002.928955078125,
      "bbox_min": [
        -3004.734375,
        -5047.10791015625,
        1063.5
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5034.0,
      "bbox_min": [
        -2988.498046875,
        -5034.0,
        1063.6376953125
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5034.0,
      "bbox_min": [
        -2987.204833984375,
        -5034.0,
        1064.1339111328125
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5034.0,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1065.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4281085133552551,
        0.9037274122238159,
        0.0
      ],
      "plane_d": 5882.72802734375,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1065.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2996.000244140625,
      "bbox_min": [
        -2996.000244140625,
        -5091.0,
        1065.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5090.15771484375,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -2996.000244140625,
        -5037.84228515625,
        1065.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5034.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2996.000244140625,
      "bbox_min": [
        -2996.000244140625,
        -5037.84228515625,
        1065.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5037.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3130.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2960.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3180.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5184.0,
        1083.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.29828330874443054,
        -0.9544774293899536
      ],
      "plane_d": 2562.102783203125,
      "bbox_min": [
        -3195.000244140625,
        -5124.0,
        1083.0
      ],
      "bbox_max": [
        -3180.000244140625,
        -5076.00146484375,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3195.000244140625,
        -5124.0,
        1098.0
      ],
      "bbox_max": [
        -3180.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3180.000244140625,
        -5184.0,
        1086.5
      ],
      "bbox_max": [
        -3130.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        1086.5
      ],
      "bbox_max": [
        -3130.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.5,
      "bbox_min": [
        -3135.000244140625,
        -5114.0,
        1101.5
      ],
      "bbox_max": [
        -3130.000244140625,
        -5105.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.5,
      "bbox_min": [
        -3130.000244140625,
        -5219.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2960.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5219.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2960.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2960.000244140625,
        -5084.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5084.0,
      "bbox_min": [
        -2980.000244140625,
        -5084.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2960.000244140625,
        -5084.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.0,
      "bbox_min": [
        -3130.000244140625,
        -5184.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5079.60009765625,
      "bbox_min": [
        -3124.500244140625,
        -5144.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1070.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5086.57568359375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5093.0,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5090.15771484375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4281085133552551,
        0.9037274122238159,
        0.0
      ],
      "plane_d": 5882.72802734375,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2990.000244140625,
        -5090.15771484375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2996.000244140625,
      "bbox_min": [
        -2996.000244140625,
        -5091.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -2996.000244140625,
        -5090.15771484375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6363866329193115,
        -0.7713702321052551
      ],
      "plane_d": 4063.937744140625,
      "bbox_min": [
        -3120.000244140625,
        -5093.0,
        1070.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5086.57568359375,
        1072.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5093.0,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1070.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5090.15771484375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4281085133552551,
        0.9037274122238159,
        0.0
      ],
      "plane_d": 5882.72802734375,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1070.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5090.15771484375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2996.000244140625,
      "bbox_min": [
        -2996.000244140625,
        -5091.0,
        1070.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5090.15771484375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5034.0,
      "bbox_min": [
        -2996.000244140625,
        -5037.84228515625,
        1069.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -2996.000244140625,
        -5037.84228515625,
        1069.5999755859375
      ],
      "bbox_max": [
        -2990.000244140625,
        -5034.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2996.000244140625,
      "bbox_min": [
        -2996.000244140625,
        -5037.84228515625,
        1069.5999755859375
      ],
      "bbox_max": [
        -2996.000244140625,
        -5037.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1079.9998779296875,
      "bbox_min": [
        -3130.000244140625,
        -5184.0,
        1072.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3010.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5093.0,
        1072.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -3010.000244140625,
        -5093.0,
        1072.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5093.0,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1072.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5034.0,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1072.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4281085133552551,
        0.9037274122238159,
        0.0
      ],
      "plane_d": 5882.72802734375,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1072.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5037.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2996.000244140625,
      "bbox_min": [
        -2996.000244140625,
        -5091.0,
        1072.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5090.15771484375,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2996.000244140625,
      "bbox_min": [
        -2996.000244140625,
        -5037.84228515625,
        1072.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5037.0,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6363866329193115,
        -0.7713702321052551
      ],
      "plane_d": 4063.937744140625,
      "bbox_min": [
        -3120.000244140625,
        -5088.939453125,
        1072.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5076.87890625,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1075.0,
      "bbox_min": [
        -3120.000244140625,
        -5088.939453125,
        1075.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5076.87890625,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5083.939453125,
        1075.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5076.87890625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3092.500244140625,
      "bbox_min": [
        -3130.000244140625,
        -5184.0,
        1080.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3107.500244140625,
        -5072.63623046875,
        1083.5001220703125
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6363813281059265,
        -0.771374523639679
      ],
      "plane_d": 4063.915283203125,
      "bbox_min": [
        -3107.500244140625,
        -5072.63623046875,
        1083.5001220703125
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3130.000244140625,
        -5184.0,
        1080.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3130.000244140625,
        -5184.0,
        1080.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3130.000244140625,
        -5184.0,
        1086.5
      ],
      "bbox_max": [
        -3125.0,
        -5184.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.419780791271478e-06,
        0.6363813877105713,
        -0.7713745832443237
      ],
      "plane_d": 4063.9326171875,
      "bbox_min": [
        -3130.000244140625,
        -5094.0,
        1080.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5094.0,
      "bbox_min": [
        -3130.000244140625,
        -5094.0,
        1098.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5094.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3092.500244140625,
        -5144.0,
        1080.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2995.000244140625,
      "bbox_min": [
        -2995.000244140625,
        -5144.0,
        1098.0
      ],
      "bbox_max": [
        -2995.000244140625,
        -5124.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2995.000244140625,
      "bbox_min": [
        -3015.000244140625,
        -5124.0,
        1098.0
      ],
      "bbox_max": [
        -2995.000244140625,
        -5114.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5114.0,
      "bbox_min": [
        -3015.000244140625,
        -5114.0,
        1098.0
      ],
      "bbox_max": [
        -3010.000244140625,
        -5114.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3092.500244140625,
        -5077.87890625,
        1080.0
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3092.500244140625,
        -5077.87890625,
        1080.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6363813281059265,
        -0.771374523639679
      ],
      "plane_d": 4063.915283203125,
      "bbox_min": [
        -3092.500244140625,
        -5077.87890625,
        1080.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1086.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5077.87890625,
        1080.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5072.63623046875,
        1083.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.8944272398948669,
        0.0
      ],
      "plane_d": 3156.433349609375,
      "bbox_min": [
        -3050.000244140625,
        -5054.0,
        1098.0
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5219.0,
        1101.5
      ],
      "bbox_max": [
        -2969.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3130.000244140625,
        -5184.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3130.000244140625,
        -5184.0,
        1101.5
      ],
      "bbox_max": [
        -3125.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3092.500244140625,
        -5144.0,
        1101.5
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2995.000244140625,
      "bbox_min": [
        -3040.000244140625,
        -5144.0,
        1101.5
      ],
      "bbox_max": [
        -2995.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3040.000244140625,
        -5124.0,
        1101.5
      ],
      "bbox_max": [
        -3010.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3015.000244140625,
      "bbox_min": [
        -3015.000244140625,
        -5124.0,
        1101.5
      ],
      "bbox_max": [
        -3010.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5114.0,
      "bbox_min": [
        -3015.000244140625,
        -5114.0,
        1101.5
      ],
      "bbox_max": [
        -3010.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3092.500244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3092.500244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3090.000244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3092.500244140625,
        -5101.5,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -890.8753662109375,
      "bbox_min": [
        -3077.500244140625,
        -5101.5,
        1101.5
      ],
      "bbox_max": [
        -3075.303466796875,
        -5081.19677734375,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -896.6158447265625,
      "bbox_min": [
        -3077.500244140625,
        -5086.5,
        1101.5
      ],
      "bbox_max": [
        -3075.303466796875,
        -5081.19677734375,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3075.000244140625,
      "bbox_min": [
        -3075.000244140625,
        -5070.0,
        1101.5
      ],
      "bbox_max": [
        -3075.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.8944272398948669,
        0.0
      ],
      "plane_d": 3156.433349609375,
      "bbox_min": [
        -3050.000244140625,
        -5054.0,
        1101.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5204628705978394,
        0.0,
        0.8538843989372253
      ],
      "plane_d": -2522.84619140625,
      "bbox_min": [
        -3107.500244140625,
        -5004.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -3040.000244140625,
        -5004.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3040.000244140625,
        -5004.0,
        1098.0
      ],
      "bbox_max": [
        -3040.000244140625,
        -4991.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3107.500244140625,
      "bbox_min": [
        -3107.500244140625,
        -5004.0,
        1098.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -4991.58837890625,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3092.500244140625,
      "bbox_min": [
        -3092.500244140625,
        -5004.0,
        1098.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -4991.58837890625,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2969.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2969.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1115.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1115.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1115.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3070.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3070.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1124.0,
      "bbox_min": [
        -3010.000244140625,
        -5129.0,
        1124.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5124.0,
        1124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5114.0,
      "bbox_min": [
        -3070.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3015.000244140625,
      "bbox_min": [
        -3015.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5114.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1124.0,
      "bbox_min": [
        -3010.000244140625,
        -5124.0,
        1124.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5114.0,
        1124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": 4838.9267578125,
      "bbox_min": [
        -3070.000244140625,
        -5069.0,
        1120.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5059.0,
      "bbox_min": [
        -3070.000244140625,
        -5059.0,
        1135.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3195.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3195.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5104.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3125.0,
        -5184.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3195.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3130.000244140625,
        -5104.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3130.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3130.000244140625,
        -5104.0,
        1112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": 4838.9267578125,
      "bbox_min": [
        -3120.000244140625,
        -5101.5,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -890.8753662109375,
      "bbox_min": [
        -3077.500244140625,
        -5101.5,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5079.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -896.6158447265625,
      "bbox_min": [
        -3077.500244140625,
        -5086.5,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5079.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 3517.4609375,
      "bbox_min": [
        -3075.303466796875,
        -5081.19677734375,
        1101.7047119140625
      ],
      "bbox_max": [
        -3070.000244140625,
        -5079.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3120.000244140625,
        -5081.2666015625,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3075.000244140625,
      "bbox_min": [
        -3085.000244140625,
        -5081.2666015625,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 3517.4609375,
      "bbox_min": [
        -3075.000244140625,
        -5081.0712890625,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5079.0,
        1105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -896.6158447265625,
      "bbox_min": [
        -3075.332275390625,
        -5081.2666015625,
        1101.5999755859375
      ],
      "bbox_max": [
        -3075.303466796875,
        -5081.19677734375,
        1101.7047119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3319.999755859375,
        -5045.98291015625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3319.999755859375,
        -5044.55859375,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3319.999755859375,
        -4947.42724609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3290.547119140625,
        -4932.2685546875,
        1213.2578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3295.838623046875,
        -4994.4453125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3295.838623046875,
        -4947.5576171875,
        1152.623779296875
      ],
      "bbox_max": [
        -3275.381591796875,
        -4932.2685546875,
        1213.7796630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2924.617919921875,
        -4942.994140625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1195.5255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.583952009677887,
        0.5839559435844421,
        0.5639109015464783
      ],
      "plane_d": 372.40728759765625,
      "bbox_min": [
        -3220.900634765625,
        -4976.64208984375,
        1152.623779296875
      ],
      "bbox_max": [
        -3212.747802734375,
        -4965.7685546875,
        1166.2159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.497753769159317,
        0.6427804827690125,
        0.5823009610176086
      ],
      "plane_d": 4086.61962890625,
      "bbox_min": [
        -3214.99951171875,
        -4985.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2985.0,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.583952009677887,
        0.5839559435844421,
        0.5639109015464783
      ],
      "plane_d": 372.40728759765625,
      "bbox_min": [
        -3214.99951171875,
        -4980.81591796875,
        1152.623779296875
      ],
      "bbox_max": [
        -3184.010498046875,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49775373935699463,
        0.6427803635597229,
        0.582301139831543
      ],
      "plane_d": 1000.5457153320312,
      "bbox_min": [
        -3054.07763671875,
        -4985.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2985.0,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5839508175849915,
        0.5839548110961914,
        0.5639132261276245
      ],
      "plane_d": 3992.897705078125,
      "bbox_min": [
        -3015.989013671875,
        -4980.81591796875,
        1152.623779296875
      ],
      "bbox_max": [
        -2985.0,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9749282002449036,
        0.0,
        -0.22251980006694794
      ],
      "plane_d": -2600.0576171875,
      "bbox_min": [
        -2946.8349609375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01754850521683693,
        -0.9926998019218445,
        0.11932884156703949
      ],
      "plane_d": -4969.9775390625,
      "bbox_min": [
        -2946.8349609375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2946.8349609375,
        -4856.3642578125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -2929.999755859375,
        -4852.89501953125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1179.3675537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9920545220375061,
        0.12580856680870056
      ],
      "plane_d": -5025.68896484375,
      "bbox_min": [
        -2929.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4916.376953125,
        1179.3675537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3319.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9920545220375061,
        0.12580856680870056
      ],
      "plane_d": -5025.6884765625,
      "bbox_min": [
        -3319.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3292.71533203125,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3699.999755859375,
        -4854.5673828125,
        1102.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4829.7685546875,
        1201.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3295.838623046875,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3347.175537109375,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3369.999755859375,
        -5008.603515625,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8356147408485413,
        0.0,
        -0.5493159294128418
      ],
      "plane_d": -1788.7464599609375,
      "bbox_min": [
        -2989.006591796875,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01794245094060898,
        -0.9985645413398743,
        0.050468262284994125
      ],
      "plane_d": -5018.9169921875,
      "bbox_min": [
        -2989.006591796875,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2989.006591796875,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": 1732.95654296875,
      "bbox_min": [
        -2959.9150390625,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2959.9150390625,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        -0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": -4913.1123046875,
      "bbox_min": [
        -2959.9150390625,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4906.9423828125,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3014.40673828125,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0010623109992593527,
        -0.9993759989738464,
        0.035308580845594406
      ],
      "plane_d": -4952.8798828125,
      "bbox_min": [
        -3014.40673828125,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3014.40673828125,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3014.40673828125,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -2989.006591796875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4916.06201171875,
        1201.8182373046875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4744.802734375,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3600.0,
        -4916.06201171875,
        1201.8182373046875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4746.9443359375,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4863.9697265625,
        1201.8182373046875
      ],
      "bbox_max": [
        -3566.1171875,
        -4854.5673828125,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3302.565185546875,
        -4912.5498046875,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3302.565185546875,
        -4912.111328125,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9920545220375061,
        0.12580856680870056
      ],
      "plane_d": -5025.6884765625,
      "bbox_min": [
        -3302.565185546875,
        -4912.111328125,
        1213.0048828125
      ],
      "bbox_max": [
        -3292.71533203125,
        -4910.19970703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4914.876953125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4751.63671875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4879.7685546875,
        1238.15380859375
      ],
      "bbox_max": [
        -3549.999755859375,
        -4863.6513671875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        -0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": -5037.20947265625,
      "bbox_min": [
        -3298.212890625,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01794244721531868,
        -0.9985644817352295,
        0.050468266010284424
      ],
      "plane_d": -4907.67333984375,
      "bbox_min": [
        -3253.16455078125,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3253.16455078125,
        -4859.85693359375,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3221.869873046875,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0010623144917190075,
        -0.9993758797645569,
        0.035308584570884705
      ],
      "plane_d": -4946.29296875,
      "bbox_min": [
        -3221.869873046875,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3221.869873046875,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3210.992919921875,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3699.999755859375,
        -4879.7685546875,
        1198.05712890625
      ],
      "bbox_max": [
        -3600.0,
        -4853.626953125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -2.5699014258862007e-06
      ],
      "plane_d": -3128.597412109375,
      "bbox_min": [
        -3170.00048828125,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268569111824036,
        0.9238786101341248,
        0.0
      ],
      "plane_d": 2758.4775390625,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8526395559310913,
        -0.35317710041999817,
        0.3850606083869934
      ],
      "plane_d": 694.5632934570312,
      "bbox_min": [
        -3128.600341796875,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4257.44384765625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.865304172039032,
        -0.35842156410217285,
        0.3504037857055664
      ],
      "plane_d": 758.911865234375,
      "bbox_min": [
        -3121.054931640625,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3082.751220703125,
        -4271.79052734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770167350769043,
        -0.319015771150589,
        -0.5523326396942139
      ],
      "plane_d": 1637.0086669921875,
      "bbox_min": [
        -3121.054931640625,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3082.751220703125,
        -4271.79052734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3116.6005859375,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3082.751220703125,
        -4271.79052734375,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3099.21826171875,
        -4281.6142578125,
        1101.623779296875
      ],
      "bbox_max": [
        -3082.751220703125,
        -4271.79052734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3105.568115234375,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4257.44384765625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3094.654296875,
        -4288.0009765625,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4264.9892578125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3086.520751953125,
        -4274.68359375,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4264.9892578125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3105.568115234375,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4280.4765625,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3531681299209595,
        0.8526439666748047,
        0.385059118270874
      ],
      "plane_d": 2151.873046875,
      "bbox_min": [
        -3073.08740234375,
        -4306.16796875,
        1115.7283935546875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4301.943359375,
        1130.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31909674406051636,
        0.7703763246536255,
        -0.5519943833351135
      ],
      "plane_d": 2953.58642578125,
      "bbox_min": [
        -3073.08740234375,
        -4306.16796875,
        1115.7283935546875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4301.943359375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8654379844665527,
        0.35847145318984985,
        0.35002174973487854
      ],
      "plane_d": -1500.860595703125,
      "bbox_min": [
        -3082.100341796875,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4303.94384765625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35847729444503784,
        0.8654402494430542,
        0.35001006722450256
      ],
      "plane_d": 2238.665283203125,
      "bbox_min": [
        -3071.67333984375,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4303.94384765625,
        1107.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4329.7685546875,
        1152.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4629.7685546875,
      "bbox_min": [
        -3128.60009765625,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9113652110099792,
        0.0,
        0.4115986227989197
      ],
      "plane_d": -3272.40087890625,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4329.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9270538687705994,
        0.0,
        0.37492841482162476
      ],
      "plane_d": -3270.30322265625,
      "bbox_min": [
        -3084.1005859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3077.651611328125,
        -4329.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8128610849380493,
        0.0,
        -0.5824577808380127
      ],
      "plane_d": -1853.646728515625,
      "bbox_min": [
        -3084.1005859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3077.651611328125,
        -4329.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950360059738159,
        -0.0,
        -0.09951574355363846
      ],
      "plane_d": -2957.171875,
      "bbox_min": [
        -3084.1005859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3077.651611328125,
        -4629.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4629.7685546875,
      "bbox_min": [
        -3084.1005859375,
        -4629.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3077.651611328125,
        -4629.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9113733768463135,
        0.0,
        0.41158080101013184
      ],
      "plane_d": 2376.92529296875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4329.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9268893003463745,
        0.0,
        0.37533503770828247
      ],
      "plane_d": 2475.265625,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -4329.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855440855026245,
        -0.16941924393177032,
        4.717869614978554e-06
      ],
      "plane_d": -3867.750732421875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3120.0,
        -4629.7685546875,
        1131.2572021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.812631368637085,
        0.0,
        -0.5827782154083252
      ],
      "plane_d": 3184.68017578125,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -4329.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855440855026245,
        -0.16941924393177032,
        4.717869614978554e-06
      ],
      "plane_d": -3867.750732421875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1112.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950372576713562,
        0.0,
        -0.09950372576713562
      ],
      "plane_d": 3210.749267578125,
      "bbox_min": [
        -3121.054931640625,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -4629.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4629.7685546875,
      "bbox_min": [
        -3121.054931640625,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -4629.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855440855026245,
        -0.16941924393177032,
        4.717869614978554e-06
      ],
      "plane_d": -3867.750732421875,
      "bbox_min": [
        -3121.054931640625,
        -4679.7998046875,
        1110.0185546875
      ],
      "bbox_max": [
        -3120.0,
        -4673.66259765625,
        1114.0947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855440855026245,
        -0.16941924393177032,
        4.717869614978554e-06
      ],
      "plane_d": -3867.750732421875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1133.579345703125
      ],
      "bbox_max": [
        -3119.999755859375,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4306.16796875,
      "bbox_min": [
        -3070.100341796875,
        -4329.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3070.100341796875,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": 3450.1103515625,
      "bbox_min": [
        -3070.100341796875,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3531681299209595,
        0.8526439666748047,
        0.385059118270874
      ],
      "plane_d": 2151.873046875,
      "bbox_min": [
        -3070.100341796875,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -3020.09814453125,
        -4292.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9270538687705994,
        0.37492841482162476
      ],
      "plane_d": 3567.89501953125,
      "bbox_min": [
        -3070.100341796875,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -3020.09814453125,
        -4292.16796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35847729444503784,
        0.8654402494430542,
        0.35001006722450256
      ],
      "plane_d": 2238.665283203125,
      "bbox_min": [
        -3070.100341796875,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4294.16796875,
        1121.344482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31909674406051636,
        0.7703763246536255,
        -0.5519943833351135
      ],
      "plane_d": 2953.58642578125,
      "bbox_min": [
        -3070.100341796875,
        -4302.1435546875,
        1112.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4292.16796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": -4345.6044921875,
      "bbox_min": [
        -3070.100341796875,
        -4271.44384765625,
        1101.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8126208782196045,
        -0.5827926993370056
      ],
      "plane_d": -2809.4462890625,
      "bbox_min": [
        -3070.100341796875,
        -4269.443359375,
        1101.623779296875
      ],
      "bbox_max": [
        -3020.09814453125,
        -4255.21337890625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3070.100341796875,
        -4269.443359375,
        1101.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4255.21337890625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3070.100341796875,
        -4265.4453125,
        1112.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4255.21337890625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3070.100341796875,
        -4271.44384765625,
        1113.2596435546875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3070.100341796875,
        -4271.44384765625,
        1113.2596435546875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4261.66796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266539573669434,
        -0.9238870739936829,
        0.0
      ],
      "plane_d": -2812.622802734375,
      "bbox_min": [
        -3070.100341796875,
        -4329.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3531681299209595,
        0.8526439666748047,
        0.385059118270874
      ],
      "plane_d": 2151.873046875,
      "bbox_min": [
        -3070.100341796875,
        -4315.94287109375,
        1107.123779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8654379844665527,
        0.35847145318984985,
        0.35002174973487854
      ],
      "plane_d": -1500.860595703125,
      "bbox_min": [
        -3070.100341796875,
        -4311.5380859375,
        1107.123779296875
      ],
      "bbox_max": [
        -3064.730224609375,
        -4306.16796875,
        1115.7283935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35847729444503784,
        0.8654402494430542,
        0.35001006722450256
      ],
      "plane_d": 2238.665283203125,
      "bbox_min": [
        -3070.100341796875,
        -4307.74072265625,
        1107.123779296875
      ],
      "bbox_max": [
        -3064.730224609375,
        -4306.16796875,
        1114.0977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31909674406051636,
        0.7703763246536255,
        -0.5519943833351135
      ],
      "plane_d": 2953.58642578125,
      "bbox_min": [
        -3068.52734375,
        -4307.74072265625,
        1112.623779296875
      ],
      "bbox_max": [
        -3064.730224609375,
        -4306.16796875,
        1114.0977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7703686356544495,
        0.3190985918045044,
        -0.552003800868988
      ],
      "plane_d": -375.13067626953125,
      "bbox_min": [
        -3070.100341796875,
        -4311.5380859375,
        1112.623779296875
      ],
      "bbox_max": [
        -3067.27978515625,
        -4306.16796875,
        1115.7283935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31909674406051636,
        0.7703763246536255,
        -0.5519943833351135
      ],
      "plane_d": 2953.58642578125,
      "bbox_min": [
        -3070.100341796875,
        -4307.74072265625,
        1112.623779296875
      ],
      "bbox_max": [
        -3067.27978515625,
        -4306.16796875,
        1115.7283935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8526408672332764,
        0.3531631827354431,
        0.3850703537464142
      ],
      "plane_d": -1532.41943359375,
      "bbox_min": [
        -3070.100341796875,
        -4329.7685546875,
        1139.9432373046875
      ],
      "bbox_max": [
        -3063.18798828125,
        -4313.080078125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": 3450.1103515625,
      "bbox_min": [
        -3020.098876953125,
        -4306.16796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9270538687705994,
        0.37492841482162476
      ],
      "plane_d": 3567.89501953125,
      "bbox_min": [
        -3020.098876953125,
        -4298.61669921875,
        1101.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4292.16796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8128714561462402,
        -0.5824432373046875
      ],
      "plane_d": 4142.2626953125,
      "bbox_min": [
        -3020.0986328125,
        -4298.61669921875,
        1112.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4292.16796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": -4345.6044921875,
      "bbox_min": [
        -3020.098876953125,
        -4261.66796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1147.9725341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9268820285797119,
        0.3753526508808136
      ],
      "plane_d": -4361.70703125,
      "bbox_min": [
        -3020.098876953125,
        -4261.66796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4255.21337890625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8126208782196045,
        -0.5827926993370056
      ],
      "plane_d": -2809.4462890625,
      "bbox_min": [
        -3020.0986328125,
        -4261.66796875,
        1112.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4255.21337890625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6304340362548828,
        0.0,
        0.7762427926063538
      ],
      "plane_d": -2827.50341796875,
      "bbox_min": [
        -3170.00048828125,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4529.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7580097317695618,
        0.6522433161735535
      ],
      "plane_d": -3960.58642578125,
      "bbox_min": [
        -3309.619873046875,
        -4319.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3260.050048828125,
        -4264.0966796875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27660542726516724,
        -0.9063540101051331,
        -0.3193928301334381
      ],
      "plane_d": -4444.03955078125,
      "bbox_min": [
        -3309.619873046875,
        -4293.52392578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3260.050048828125,
        -4264.0966796875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123761534690857,
        -0.3535540997982025,
        -0.7071031332015991
      ],
      "plane_d": 1248.33935546875,
      "bbox_min": [
        -3268.512939453125,
        -4288.404296875,
        1077.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4280.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123761534690857,
        -0.3535540997982025,
        -0.7071031332015991
      ],
      "plane_d": 1248.33935546875,
      "bbox_min": [
        -3270.311767578125,
        -4293.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3264.46923828125,
        -4285.408203125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        -0.4999985098838806,
        -0.0
      ],
      "plane_d": -4989.20556640625,
      "bbox_min": [
        -3289.550048828125,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4280.75,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 682.920654296875,
      "bbox_min": [
        -3282.175048828125,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4280.75,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4293.52392578125,
      "bbox_min": [
        -3282.175048828125,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3267.425048828125,
        -4293.52392578125,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4653.2685546875,
      "bbox_min": [
        -3337.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3331.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4595.7685546875,
      "bbox_min": [
        -3337.999755859375,
        -4647.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3331.999755859375,
        -4595.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3332.999755859375,
      "bbox_min": [
        -3334.999755859375,
        -4647.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1591.25634765625,
      "bbox_min": [
        -3334.999755859375,
        -4647.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4652.36865234375,
      "bbox_min": [
        -3554.599853515625,
        -4652.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4650.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -4055.252197265625,
      "bbox_min": [
        -3554.599853515625,
        -4652.36865234375,
        1082.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4650.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3337.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4563.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4569.7998046875,
      "bbox_min": [
        -3337.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4569.7998046875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3332.999755859375,
      "bbox_min": [
        -3334.999755859375,
        -4563.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1591.25634765625,
      "bbox_min": [
        -3334.999755859375,
        -4563.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4546.0,
      "bbox_min": [
        -3508.06005859375,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3367.056640625,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38344883918762207,
        -0.0,
        0.9235621094703674
      ],
      "plane_d": 292.119384765625,
      "bbox_min": [
        -3417.0,
        -4546.0,
        1081.6539306640625
      ],
      "bbox_max": [
        -3367.056640625,
        -4413.39990234375,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15500178933143616,
        -0.0,
        0.9879142045974731
      ],
      "plane_d": -566.6591796875,
      "bbox_min": [
        -3450.0,
        -4546.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6748446226119995,
        -0.0,
        0.7379598617553711
      ],
      "plane_d": 1492.4248046875,
      "bbox_min": [
        -3426.66552734375,
        -4546.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4413.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9278242588043213,
        -0.3730178475379944,
        0.0
      ],
      "plane_d": 1474.636474609375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3925205171108246,
        -0.9197432398796082,
        0.0
      ],
      "plane_d": -2858.22802734375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06411544978618622,
        -0.150238499045372,
        0.9865686893463135
      ],
      "plane_d": -1561.7010498046875,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15470170974731445,
        -0.06219439208507538,
        0.9860016703605652
      ],
      "plane_d": -848.2979125976562,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513059735298157,
        -0.26184308528900146,
        0.7122068405151367
      ],
      "plane_d": 250.04437255859375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27256160974502563,
        -0.6386798024177551,
        0.7195821404457092
      ],
      "plane_d": -2778.075927734375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3426.66552734375,
        -4563.0,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3925205171108246,
        -0.9197432398796082,
        -0.0
      ],
      "plane_d": -5566.61962890625,
      "bbox_min": [
        -3473.33447265625,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3450.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06411544233560562,
        -0.15023845434188843,
        0.9865685105323792
      ],
      "plane_d": -2004.0972900390625,
      "bbox_min": [
        -3473.33447265625,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2725662291049957,
        -0.638690710067749,
        0.7195705771446228
      ],
      "plane_d": -4658.8037109375,
      "bbox_min": [
        -3473.33447265625,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4563.0,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9278242588043213,
        0.3730178475379944,
        -0.0
      ],
      "plane_d": 4816.65234375,
      "bbox_min": [
        -3433.5,
        -4413.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4389.3583984375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6512991786003113,
        0.26184508204460144,
        0.712212324142456
      ],
      "plane_d": 2595.980712890625,
      "bbox_min": [
        -3433.5,
        -4413.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4389.3583984375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 1057.446044921875,
      "bbox_min": [
        -3939.26220703125,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1100.3785400390625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2712554931640625,
        0.3530268669128418,
        0.8954285979270935
      ],
      "plane_d": 1485.3206787109375,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2750813663005829,
        0.35142311453819275,
        0.894892156124115
      ],
      "plane_d": -215.431884765625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2754322588443756,
        0.3464488685131073,
        0.8967219591140747
      ],
      "plane_d": 1463.6072998046875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27700290083885193,
        0.3484245240688324,
        0.8954717516899109
      ],
      "plane_d": -237.17449951171875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3248736560344696,
        0.30733799934387207,
        0.894427478313446
      ],
      "plane_d": 1431.6265869140625,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3270551264286041,
        0.3094017207622528,
        0.892919659614563
      ],
      "plane_d": -576.7142333984375,
      "bbox_min": [
        -2945.2109375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3714085817337036,
        1.1238243132538628e-05,
        0.9284694790840149
      ],
      "plane_d": -2031.978759765625,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3597.21337890625,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4909.36328125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -3939.26220703125,
        -5079.7685546875,
        1317.4210205078125
      ],
      "bbox_max": [
        -3758.24658203125,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3159162104129791,
        -0.32253599166870117,
        0.892282247543335
      ],
      "plane_d": -1351.46044921875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -2985.158203125,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3556.305419921875,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3749.999755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -3985.582763671875,
        -4266.263671875,
        1353.5482177734375
      ],
      "bbox_max": [
        -3900.749755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.315602570772171,
        -0.3142412602901459,
        0.8953476548194885
      ],
      "plane_d": -1324.80126953125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -2985.158203125,
      "bbox_min": [
        -4007.749267578125,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3549.999755859375,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3900.749755859375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3802.58349609375,
        -4266.263671875,
        1353.5482177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -3888.191162109375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3835.11669921875,
        -4333.81396484375,
        1329.1610107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43041878938674927,
        0.12140591442584991,
        0.8944273591041565
      ],
      "plane_d": 1038.8125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3556.986083984375,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4879.7685546875,
        1317.4210205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01794244721531868,
        -0.9985644817352295,
        0.050468266010284424
      ],
      "plane_d": -4907.67333984375,
      "bbox_min": [
        -3248.5048828125,
        -4907.111328125,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4906.32763671875,
        1315.9383544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        -0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": -5037.20947265625,
      "bbox_min": [
        -3248.5048828125,
        -4907.111328125,
        1302.6241455078125
      ],
      "bbox_max": [
        -3237.80029296875,
        -4906.36181640625,
        1315.9383544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -4035.11669921875,
        -4906.3974609375,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3248.5048828125,
        -4906.3974609375,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        0.9981757998466492,
        0.05695966258645058
      ],
      "plane_d": 4711.94189453125,
      "bbox_min": [
        -3248.5048828125,
        -4906.3974609375,
        1302.6241455078125
      ],
      "bbox_max": [
        -3233.817626953125,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01794244721531868,
        -0.9985644817352295,
        0.050468266010284424
      ],
      "plane_d": -4907.67333984375,
      "bbox_min": [
        -3239.638916015625,
        -4906.3974609375,
        1315.9034423828125
      ],
      "bbox_max": [
        -3233.817626953125,
        -4906.19970703125,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        -0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": -5037.20947265625,
      "bbox_min": [
        -3239.638916015625,
        -4906.3974609375,
        1315.92041015625
      ],
      "bbox_max": [
        -3237.16748046875,
        -4906.19970703125,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713906705379486,
        0.0,
        0.9284766912460327
      ],
      "plane_d": -2032.00439453125,
      "bbox_min": [
        -2978.129638671875,
        -4910.2978515625,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.77978515625,
        -4379.7685546875,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2297457456588745,
        0.4098278880119324,
        0.8827558755874634
      ],
      "plane_d": 157.9915771484375,
      "bbox_min": [
        -2214.77978515625,
        -4508.150390625,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.77978515625,
        -4379.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": 1732.95654296875,
      "bbox_min": [
        -2978.129638671875,
        -4907.111328125,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2978.129638671875,
        -4907.111328125,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01794245094060898,
        -0.9985645413398743,
        0.050468262284994125
      ],
      "plane_d": -5018.9169921875,
      "bbox_min": [
        -2978.129638671875,
        -4907.111328125,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2962.83203125,
        -4907.111328125,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        -0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": -4913.1123046875,
      "bbox_min": [
        -2962.83203125,
        -4907.111328125,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4906.19970703125,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3100.0,
        -4906.7841796875,
        1302.623779296875
      ],
      "bbox_max": [
        -2962.83203125,
        -3780.262451171875,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0010623109992593527,
        -0.9993759989738464,
        0.035308580845594406
      ],
      "plane_d": -4952.8798828125,
      "bbox_min": [
        -3100.0,
        -4906.7841796875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2962.83203125,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3100.0,
        -4906.7548828125,
        1302.6241455078125
      ],
      "bbox_max": [
        -3005.45556640625,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0014615867985412478,
        -0.9993944764137268,
        0.03476598486304283
      ],
      "plane_d": -4953.46337890625,
      "bbox_min": [
        -3100.0,
        -4906.7548828125,
        1302.6241455078125
      ],
      "bbox_max": [
        -3005.45556640625,
        -4859.455078125,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3014.40673828125,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3100.0,
        -3820.217529296875,
        1302.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3780.262451171875,
        1322.556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3311.842041015625,
        -4906.7841796875,
        1302.623779296875
      ],
      "bbox_max": [
        -3100.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3237.16748046875,
        -4906.7841796875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0010623144917190075,
        -0.9993758797645569,
        0.035308584570884705
      ],
      "plane_d": -4946.29296875,
      "bbox_min": [
        -3237.16748046875,
        -4906.7841796875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3194.5439453125,
        -4906.7548828125,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0014615982072427869,
        -0.999394416809082,
        0.034765973687171936
      ],
      "plane_d": -4944.40185546875,
      "bbox_min": [
        -3194.5439453125,
        -4906.7548828125,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.455078125,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: eledor4a",
      "entity_class": "CSlidingDoor",
      "piece_name": "eledor4a",
      "offset": 29169,
      "centroid": [
        -2613.1324462890625,
        -4022.4896240234375,
        1107.123779296875
      ],
      "bbox_min": [
        -2617.712646484375,
        -4025.422607421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2608.55224609375,
        -4019.556640625,
        1112.623779296875
      ],
      "dimensions_source": {
        "span_x": 9.160400390625,
        "span_y": 5.865966796875,
        "height_z": 11.0,
        "door_width": 9.160400390625,
        "door_depth": 5.865966796875,
        "leaf_depth": 5.825966796875,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.5,
          0.866,
          0.0
        ]
      },
      "vertices": [
        [
          -2608.55224609375,
          -4024.556640625,
          1112.623779296875
        ],
        [
          -2608.55224609375,
          -4024.556640625,
          1101.623779296875
        ],
        [
          -2617.212646484375,
          -4019.556640625,
          1101.623779296875
        ],
        [
          -2617.212646484375,
          -4019.556640625,
          1112.623779296875
        ],
        [
          -2617.712646484375,
          -4020.422607421875,
          1112.623779296875
        ],
        [
          -2609.05224609375,
          -4025.422607421875,
          1112.623779296875
        ],
        [
          -2609.05224609375,
          -4025.422607421875,
          1101.623779296875
        ],
        [
          -2617.712646484375,
          -4020.422607421875,
          1101.623779296875
        ]
      ],
      "plane_distance": 4789.6426,
      "authentic_texture": "doorjam"
    }
  ],
  "tutorial_messages": []
}